{
  "common": {
    "or": "oder"
  },
  "general": {
    "share": "Teilen"
  },
  "actions": {
    "abbreviation": "MN",
    "action": "Maßnahme",
    "actions": "Maßnahmen",
    "createAction": "Maßnahme hinzufügen",
    "deleteAction": "Maßnahme löschen",
    "editAction": "Maßnahme bearbeiten"
  },
  "analytics": {
    "title": "Nutzungsstatistiken",
    "dau": "Tägliche aktive Benutzer",
    "mau": "Monatliche aktive Benutzer",
    "projectInteractions": "Projektinteraktionen",
    "projectChanges": "Projektänderungen",
    "uniqueUsers": "Eindeutige Benutzer",
    "changes": "Änderungen",
    "last7Days": "Letzte 7 Tage",
    "last30Days": "Letzte 30 Tage",
    "last90Days": "Letzte 90 Tage",
    "last180Days": "Letzte 180 Tage",
    "last365Days": "Letzte 365 Tage",
    "last6Months": "Letzte 6 Monate",
    "last12Months": "Letzte 12 Monate",
    "projectName": "Projekt",
    "lastInteraction": "Letzte einzigartige Interaktion",
    "lastChange": "Letzte Änderung",
    "totalInteractions": "Gesamte einzigartige Interaktionen",
    "totalChanges": "Gesamte Änderungen",
    "selectProject": "Projekt auswählen",
    "allProjects": "Alle Projekte",
    "noData": "Keine Daten für den ausgewählten Zeitraum verfügbar",
    "changesOn": "Änderungen am",
    "changesBreakdown": "Änderungen nach Projekt",
    "lastOperation": "Letzte Änderung"
  },
  "companyVolatility": {
    "tabTitle": "Volatilität"
  },
  "volatilityAnalytics": {
    "title": "Volatilitäts-Analyse",
    "tabActivities": "Eckpunkte",
    "tabMilestones": "Meilensteine",
    "andMore": "+{count} weitere",
    "summaryProjects": "Projekte",
    "summaryItems": "Einträge",
    "summaryAvgDrift": "Ø Abweichung",
    "summaryMedianDrift": "Median Abweichung",
    "summaryAvgChanges": "Ø Änderungen",
    "summaryMedianChanges": "Median Änderungen",
    "propertyFilters": "Projekt-Eigenschaften"
  },
  "activityVolatility": {
    "columnDeadlineDrift": "Terminabweichung",
    "columnDeadlineChanges": "Terminänderungen",
    "columnMaxShift": "Max. Verschiebung",
    "columnTimesRed": "Anzahl Rot",
    "columnCompletionDelay": "Abschlussverzug",
    "columnStateChanges": "Statusänderung",
    "columnStatusChanges": "Änderung Ampel",
    "days": "T",
    "noActivities": "Keine Eckpunkte entsprechen den gewählten Filtern",
    "timelineTitle": "Eckpunkt-Verlauf",
    "timelineNoEvents": "Keine Ereignisse für diesen Eckpunkt vorhanden",
    "eventCreated": "Erstellt",
    "eventDeadlineChange": "Termin geändert",
    "eventStateChange": "Status geändert",
    "eventStatusChange": "Ampel geändert",
    "currentDeadline": "Aktueller Termin",
    "scatterTitle": "Terminabweichung vs. Terminänderungen",
    "scatterXAxis": "Terminabweichung (Tage)",
    "scatterYAxis": "Terminänderungen (Anzahl)"
  },
  "milestoneVolatility": {
    "columnDeadlineDrift": "Terminabweichung",
    "columnDeadlineChanges": "Terminänderungen",
    "columnMaxShift": "Max. Verschiebung",
    "columnTimesRed": "Anzahl Rot",
    "columnCompletionDelay": "Abschlussverzug",
    "columnStateChanges": "Statusänderung",
    "columnStatusChanges": "Änderung Ampel",
    "columnPhaseName": "Phase",
    "columnMilestoneType": "Typ",
    "milestoneTypeFinal": "Final",
    "milestoneTypeIntermediate": "Zwischen",
    "days": "T",
    "noMilestones": "Keine Meilensteine entsprechen den gewählten Filtern",
    "timelineTitle": "Meilenstein-Verlauf",
    "timelineNoEvents": "Keine Ereignisse für diesen Meilenstein vorhanden",
    "eventCreated": "Erstellt",
    "eventDeadlineChange": "Termin geändert",
    "eventStateChange": "Status geändert",
    "eventStatusChange": "Ampel geändert",
    "currentDeadline": "Aktueller Termin",
    "scatterTitle": "Terminabweichung vs. Terminänderungen",
    "scatterXAxis": "Terminabweichung (Tage)",
    "scatterYAxis": "Terminänderungen (Anzahl)"
  },
  "activity": {
    "abbreviation": "EP",
    "action": "Maßnahme",
    "actions": "Maßnahmen",
    "activities": "Eckpunkte",
    "activity": "Eckpunkt",
    "activityIsNotRequired": "Eckpunkt wird nicht benötigt",
    "activityIsRequired": "Eckpunkt wird benötigt",
    "activityStatusUnplannedDescription": "Der Status des Eckpunkts kann nicht verändert werden weil die Phase noch im Status Ungeplant ist. Um den Status ändern zu können muss zunächst die Phase auf Geplant gesetzt werden.",
    "activityStatusWarning": "Der Eckpunkt wird automatisch in den Status 'geplant' gesetzt",
    "activityUsed": "In Eckpunkten verwendet",
    "activityWillBeUpdated": "Eckpunkt wird aktualisiert",
    "addActivity": "Eckpunkt erstellen",
    "addActivityLinkTitle": "Abhängigkeit erstellen",
    "addApprover": "Neuer Freigabeverantwortlicher",
    "addCompletionCriterion": "Erfüllungskriterium hinzufügen",
    "addNewActivity": "Eckpunkt erstellen",
    "addPredecessor": "Vorgänger hinzufügen",
    "addSuccessor": "Nachfolger hinzufügen",
    "addTags": "Tags hinzufügen",
    "addTopics": "Themen hinzufügen",
    "approvers": "Freigabeverantwortliche",
    "changeHistory": "Änderungshistorie",
    "completedActivities": "Abgeschlossene Eckpunkte",
    "completionUser": "Verantwortlich bei Abschluss",
    "confirmStatePlanned": "Der Eckpunkt wird automatisch in den Status 'geplant' gesetzt",
    "confirmStateUnderway": "Die Phase wird automatisch in den Status 'in Bearbeitung' gesetzt",
    "deleteActivity": "Eckpunkt löschen",
    "deleteActivityAdditionalText": "Mögliche Vorgänger- / Nachfolgerbeziehungen und Input- / Outputketten werden ggf. unterbrochen.",
    "deleteActivityCriterion": "Erfüllungskriterium löschen",
    "deleteActivityCriterionBody": "Dieser Eckpunkt ist mit anderen verbunden und daher wird auch diese Beziehung entfernt. Du kannst diese Aktion nicht rückgängig machen.",
    "deleteActivityCriterionTitle": "Möchtest du dieses Erfüllungskriterium wirklich löschen?",
    "deleteActivityLinkTitle": "Abhängigkeit löschen",
    "deleteApprover": "Entferne Freigabeverantwortlichen",
    "deletedUser": "Gelöschter Benutzer mit ID:",
    "description": "Beschreibung",
    "dueDate": "Fälligkeitsdatum: {date}",
    "editActivity": "Eckpunkt bearbeiten",
    "editActivityLinkTitle": "Abhängigkeit bearbeiten",
    "editApprover": "Freigabeverantwortlichen bearbeiten",
    "goToCompanyLevelActivity": "Zu Bibliothekseckpunkt gehen",
    "initiallyPlanned": "Initial geplant",
    "isFavorite": "Favorit",
    "libraryDrift": {
      "tooltip": "Der Bibliothekseckpunkt hat sich seit der Erstellung dieses Eckpunkts verändert. Ziehe ein Update in Betracht.",
      "confirm": {
        "title": "Eckpunkt aus Bibliothek aktualisieren",
        "subtitle": "Der Eckpunkt wird durch eine frische Kopie aus der Bibliothek ersetzt. Lokale Änderungen gehen verloren.",
        "warning": "Diese Aktion kann nicht rückgängig gemacht werden.",
        "action": "Bestätigen",
        "successToast": "Aus Bibliothek aktualisiert.",
        "errorToast": "Aktualisierung aus Bibliothek fehlgeschlagen. Bitte erneut versuchen."
      }
    },
    "linksAndTools": "Standards/Vorlagen",
    "milestone": "Meilenstein",
    "newAction": "Neue Maßnahme",
    "newApproval": "Neuer Freigabeverantwortlicher",
    "nextActivities": "Nächste Eckpunkte",
    "notes": "Anmerkungen",
    "number": "Nummer",
    "optionalTitle": "optional",
    "plannedDueDate": "Fälligkeitsdatum",
    "position": "Position",
    "predecessor": "Vorgänger",
    "predecessors": "Vorgänger",
    "projectActivities": "Projecteckpunkte",
    "projectDocuments": "Projektdokumente",
    "projectMilestones": "Projectmeilensteine",
    "requiredTitle": "erforderlich",
    "resetDescription": "Beschreibung zurücksetzen",
    "resetResponsible": "Durchführungsverantwortlichen zurücksetzen",
    "resetTitle": "Titel zurücksetzen",
    "responsible": "Durchführungsverantwortlich",
    "selectStatus": "Status auswählen",
    "specialAssignment": "Abweichender Benutzer",
    "state": "Status",
    "status": "Ampel",
    "successor": "Nachfolger",
    "successors": "Nachfolger",
    "tags": "Tags",
    "title": "Titel",
    "topics": "Themen",
    "warnChangeDueDate": "Eine oder mehrere Efüllungskriterien und ein oder mehrer Aktions sind duch die Änderung des Fälligkeitsdatums betroffen. Diese werden auf des Fälligkeitsdatum des Eckpunktes gesetzt.",
    "warnChangeDueDateAction": "Ein oder mehrer Aktions sind duch die Änderung des Fälligkeitsdatums betroffen. Diese werden auf des Fälligkeitsdatum des Eckpunktes gesetzt.",
    "warnChangeDueDateCC": "Eine oder mehrere Efüllungskriterien sind duch die Änderung des Fälligkeitsdatums betroffen. Diese werden auf des Fälligkeitsdatum des Eckpunktes gesetzt.",
    "watcher": "Zu Informierender",
    "watchers": "Zu Informierende"
  },
  "approvers": {
    "activityApproved": "Eckpunkt bewährt",
    "activityNotPlanned": "Eckpunkt ungeplant",
    "addedApprover": "{name} wurde als Freigabeverantwortlicher festgelegt",
    "approver": "Freigabeverantwortlicher",
    "approvers": "Freigabeverantwortliche",
    "descriptionActivity": "Eine Eckpunkt kann nur auf „Fertig“ wechseln, wenn alle Freigabeverantwortlichen zugestimmt haben. Die Freigabeverantwortlichen können den Status nur ändern, wenn der Eckpunkt mindestens geplant ist.",
    "descriptionMilestone": "Ein Meilenstein kann nur auf „Fertig“ wechseln, wenn alle Freigabeverantwortlichen zugestimmt haben. Die Freigabeverantwortlichen können den Status nur ändern, wenn der Meilenstein mindestens geplant ist.",
    "goToApproversList": "Zur Freigabeverantwortlichenliste gehen",
    "milestoneApproved": "Zwischenmeilenstein freigegeben",
    "milestoneNotPlanned": "Zwischenmeilenstein ungeplant",
    "new": "Neuer Freigabeverantwortlicher",
    "pending": "Freigabeverantwortlicher muss zustimmen",
    "requestApproval": "Freigabe anfordern",
    "rejected": "Freigabeverantwortlicher hat abgelehnt",
    "selectApprovers": "FREIGABEVERANTWORTLICHE AUSWÄHLEN"
  },
  "button": {
    "add": "Hinzufügen",
    "addEditor": "Editor hinzufügen",
    "addNew": "Hinzufügen",
    "apply": "Anwenden",
    "back": "Zurück",
    "backToActions": "Zurück zu den Maßnahmen",
    "backToActivityList": "Zurück zur Übersicht",
    "backToActivityPage": "Zurück zum Eckpunkt",
    "backToCompletionCriteria": "Zurück zu den Erfüllungskriterien",
    "backToMilestonePage": "Zurück zum Meilenstein",
    "backToProjectPage": "Zurück zum Projekt",
    "backToTemplatePage": "Zurück zur Prozesslandkarte",
    "cancel": "Abbrechen",
    "clear": "Löschen",
    "close": "Schließen",
    "columns": "Spalten",
    "confirm": "Bestätigen",
    "copy": "Kopieren",
    "copyToClipboard": "In Zwischenablage",
    "create": "Erstellen",
    "cutConnection": "Verbindung trennen",
    "delete": "Löschen",
    "deleteRelations": "Löschen",
    "keepRelations": "Behalten",
    "discard": "Verwerfen",
    "done": "Fertig",
    "edit": "Bearbeiten",
    "enable": "Aktivieren Sie",
    "filters": "Filter",
    "groups": "Gruppieren",
    "information": "Information",
    "manage": "Verwalten",
    "next": "Weiter",
    "open": "Öffnen",
    "optional": "Optional",
    "others": "Andere",
    "previous": "Zurück",
    "proceed": "Fortsetzen",
    "protect": "Sperren",
    "remove": "Entfernen",
    "removeFromVariant": "Aus Variante entfernen",
    "replace": "Ersetzen",
    "required": "Benötigt",
    "reset": "Zurücksetzen",
    "restore": "Wiederherstellen",
    "save": "Speichern",
    "searchProperties": "Sucheinstellungen",
    "split": "Spalten",
    "toProject": "Zum Projekt",
    "unlink": "Verknüpfung aufheben",
    "update": "Aktualisieren",
    "updateStatusAndDues": "Status und Fälligkeit aktualisieren",
    "view": "Öffnen",
    "viewAll": "Alle ansehen",
    "yesDelete": "Ja, löschen",
    "yesProceed": "Ja, fortsetzen"
  },
  "calendar": {
    "country": "Land",
    "region": "Region",
    "state": "Staat",
    "title": "Kalender (Feiertage)"
  },
  "catchUpBanner": {
    "title": "Was ist neu seit",
    "whatsNew": "Was ist neu",
    "catchUp": "Catch Up",
    "heresWhat": "Das ist passiert seit dem",
    "youMissed": "Du hast {count} Änderung verpasst | Du hast {count} Änderungen verpasst",
    "forYou": "Für Dich",
    "other": "Andere",
    "dismiss": "Schließen"
  },
  "entityReferences": {
    "meetingReferences": "Besprechungsreferenzen",
    "meetingReference": "Besprechungsreferenz",
    "meetingSummaryWithReferences": "Besprechungszusammenfassung mit Referenzen",
    "noReferences": "Noch keine Besprechungsreferenzen"
  },
  "comments": {
    "addComment": "Neuen Kommentar hinzufügen",
    "comment": "Kommentar",
    "comments": "Kommentare",
    "edited": "Bearbeitet {time}",
    "noComments": "Keine Kommentare",
    "noUsersFound": "Keine Benutzer gefunden",
    "text": "Text"
  },
  "company": {
    "activity": "Bibliothekseckpunkt",
    "company": "Unternehmen",
    "noLabel": "Kein Label",
    "withoutScopes": "Ohne Bereiche",
    "projectTitle": "Projekt Titel",
    "updateProjectOwnerWarning": "Der bisherige Besitzer wird ersetzt aber weiterhin Projektteilnehmer, inklusive aller Zuweisungen, sein.",
    "updateTemplateOwnerWarning": "Der bisherige Besitzer wird ersetzt",
    "openCreatedActivityTitle": "Eckpunkt erstellt",
    "openCreatedActivitySubtitle": "Möchtest du den Eckpunkt jetzt öffnen?"
  },
  "checklist": {
    "addRows": "Zeilen hinzufügen",
    "addRowsHint": "Geben Sie einen Zeilennamen pro Zeile ein.",
    "addRowsPlaceholder": "Ein Name pro Zeile",
    "addStep": "Schritt hinzufügen",
    "checked": "Abgehakt",
    "checklist": "Checkliste",
    "checklistSteps": "Checklisten-Schritte",
    "completedOn": "Erledigt am",
    "confirmSwitchFromIndividual": "Die individuellen Zeilen dieser Checkliste und alle zugehörigen Haken werden gelöscht.",
    "confirmSwitchPoolToIndividual": "Die Zeilen und Haken bleiben erhalten, aber die Checkliste wird vom Zeilen-Pool des Projekts gelöst – spätere Änderungen am Pool werden hier nicht mehr übernommen.",
    "confirmSwitchPoolToNone": "Alle Haken dieser Checkliste werden gelöscht.",
    "confirmSwitchTitle": "Zeilenquelle ändern",
    "deleteChecklist": "Checkliste löschen",
    "deleteChecklistTitle": "Checkliste löschen",
    "deletePoolRowWarning": "Die Zeile und ihre Haken in allen Pool-basierten Checklisten dieses Projekts werden gelöscht. Dies kann über die Projekthistorie rückgängig gemacht werden.",
    "deleteRowTitle": "Zeile löschen",
    "deleteRowWarning": "Die Zeile und alle zugehörigen Haken werden gelöscht.",
    "deleteStepTitle": "Schritt löschen",
    "deleteStepWarning": "Der Schritt und alle zugehörigen Haken werden gelöscht.",
    "dueDate": "Fälligkeitsdatum",
    "editStructure": "Struktur bearbeiten",
    "emptyStateText": "Wählen Sie aus, woher die Zeilen (Einheiten) dieser Checkliste stammen: aus dem projektweiten Zeilen-Pool oder aus individuellen Zeilen für diesen Eckpunkt. Die Checklisten-Schritte bilden die Spalten des Rasters.",
    "emptyStateTextReadonly": "Für diesen Eckpunkt wurde keine Checkliste eingerichtet.",
    "emptyStateTitle": "Keine Checkliste eingerichtet",
    "entityCell": "Checklisten-Zelle",
    "entityPoolRow": "Checklisten-Pool-Zeile",
    "entityRow": "Checklisten-Zeile",
    "entityStep": "Checklisten-Schritt",
    "loadFailed": "Die Checkliste konnte nicht geladen werden.",
    "name": "Name",
    "noRowsYet": "Noch keine Zeilen.",
    "notCreated": "Keine Checkliste vorhanden",
    "openChecklist": "Checkliste öffnen",
    "openChecklistSteps": "Checklisten-Schritte öffnen",
    "openPoolEditor": "Zeilen-Pool verwalten",
    "openToCreate": "Öffnen zum Einrichten der Checkliste",
    "openToCreateStep": "Öffnen zum Erstellen des ersten Checklisten-Schritts",
    "overdue": "Überfällig",
    "poolEditorDescription": "Diese Zeilen werden von allen Eckpunkt-Checklisten dieses Projekts geteilt, die den Zeilen-Pool verwenden. Beim Löschen einer Zeile werden auch ihre Haken aus allen Pool-basierten Checklisten entfernt (über die Projekthistorie rückgängig machbar).",
    "poolEditorTitle": "Checklisten-Zeilen-Pool",
    "poolRowsManagedInSettings": "Die Zeilen werden in den Projekteinstellungen verwaltet und von allen Pool-basierten Checklisten geteilt.",
    "progress": "Fortschritt",
    "resetToParent": "Wieder vom übergeordneten Eckpunkt erben",
    "retry": "Erneut versuchen",
    "row": "Zeile",
    "rowSource": "Zeilen stammen aus",
    "rowSourceIndividual": "Individuelle Zeilen",
    "rowSourceNone": "Keine",
    "rowSourcePool": "Zeilen-Pool des Projekts",
    "rowSourceValues": {
      "individual": "Individuelle Zeilen",
      "none": "Keine",
      "pool": "Zeilen-Pool des Projekts"
    },
    "rows": "Zeilen",
    "rowsManagedInProjects": "Zeilen & Haken werden pro Projekt hinzugefügt",
    "setDueDate": "Fälligkeitsdatum setzen",
    "step": "Schritt",
    "stepTitlePlaceholder": "Titel des Schritts",
    "steps": "Schritte",
    "stepsEditorDescription": "Die hier definierten Schritte werden zu den Spalten der Eckpunkt-Checkliste, wenn diese Vorlage in einem Projekt verwendet wird.",
    "stepsEditorDescriptionLibrary": "Die hier definierten Schritte werden an alle von diesem Bibliotheks-Eckpunkt abgeleiteten Vorlagen-Eckpunkte übertragen.",
    "stepsEditorEmpty": "Noch keine Checklisten-Schritte.",
    "stepsInheritanceBrokenHint": "Diese Checkliste erbt nicht mehr vom übergeordneten Eckpunkt.",
    "stepsInheritedHint": "Die Schritte werden vom übergeordneten Eckpunkt geerbt. Eine Bearbeitung löst die gesamte Checkliste vom übergeordneten Eckpunkt.",
    "stepsNotCreated": "Keine Checklisten-Schritte vorhanden",
    "title": "Titel"
  },
  "completionCriterion": {
    "abbreviation": "EK",
    "addCompletionCriterion": "Erfüllungskriterium hinzufügen",
    "addCriteria": "Erfüllungskriterium hinzufügen",
    "addSpecialAssignment": "Abweichender Benutzer",
    "completionCriteria": "Erfüllungskriterien",
    "completionCriteriaHasBeenEdited": "Die Erfüllungskriterien wurden erfolgreich bearbeitet",
    "completionCriterion": "Erfüllungskriterium",
    "convertCompletionCriterionToActivityTitle": "Eckpunkt aus vorhandenem Erfüllungskriterium erstellen",
    "convertCompletionCriterionToActivitySubtitle": "Dieser Vorgang wird das bestehende Erfüllungskriterium löschen und stattdessen einen neuen Eckpunkt erstellen. Möchtest du fortfahren?",
    "convertActionToActivityTitle": "Eckpunkt aus vorhandener Maßnahme erstellen",
    "convertActionToActivitySubtitle": "Dieser Vorgang wird die bestehende Maßnahme löschen und stattdessen einen neuen Eckpunkt erstellen. Möchtest du fortfahren?",
    "criteriaName": "Name des Erfüllungskriteriums",
    "dateSetManually": "Das Datum wurde manuell gesetzt.",
    "deleteCompletionCriteria": "Erfüllungskriterium löschen",
    "deleteCompletionCriterion": "Erfüllungskriterium löschen",
    "description": "Beschreibung",
    "dueDate": "Fälligkeitsdatum",
    "editCompletionCriteria": "Erfüllungskriterien bearbeiten",
    "editCompletionCriterion": "Erfüllungskriterium bearbeiten",
    "function": "Funktion",
    "inheritedFromActivity": "Vom Eckpunkt vererbt",
    "manualDueDate": "Manuelles Fälligkeitsdatum",
    "notCreated": "Kein Erfüllungskriterium vorhanden",
    "openToCreate": "Öffnen zum Erstellen des ersten Erfüllungskriteriums",
    "responsible": "Durchführungsverantwortlicher",
    "specialAssignmentText": "Von Funktion abweichender Benutzer hinterlegt",
    "title": "Titel"
  },
  "confirm": {
    "areYouSure": "Bist Du sicher, dass Du {action} willst?",
    "areYouSureDelete": "{thing} wird gelöscht. Diese Aktion kann nicht rückgängig gemacht werden. Willst du wirklich löschen?",
    "areYouSureDeleteSoft": "Bist du sicher, dass du dieses {thing} löschen möchtest?",
    "areYouSureDuplicate": "{thing} wird dupliziert. Diese Aktion kann nicht rückgängig gemacht werden. Willst du wirklich duplizieren?",
    "areYouSureDuplicateMultiple": "{thing} werden dupliziert. Diese Aktion kann nicht rückgängig gemacht werden. Willst du wirklich duplizieren?",
    "areYouSurePredecessorWarning": "Es gibt Projektdokumente, die vom Vorgänger, den du löschen möchtest, als Input verwendet werden. Die Dokumente bleiben vorhanden, nur der Input wird gelöscht. Willst du trotzdem fortfahren?",
    "areYouSureMilestoneWithActivitiesWarning": "Es gibt Eckpunkte, die mit diesem Meilenstein verbunden sind. Das Löschen dieses Meilensteins entfernt alle Verbindungen zu diesen Eckpunkten. Willst du trotzdem fortfahren?",
    "areYouSureProceedActivityWarning": "Es gibt noch offene Freigaben und / oder nicht abgeschlossene Erfüllungskriterien! Wenn du fortfährst, werden alle Erfüllungskriterien abgeschlossen und alle Freigabeveranwortlichen werden entfernt. Willst du trotzdem forfahren?",
    "areYouSureProceedPhaseWarning": "Es gibt noch offene Freigaben und / oder nicht abgeschlossene Eckpunkte! Wenn du fortfährst, werden alle Eckpunkte abgeschlossen und alle Freigabeveranwortlichen werden entfernt. Willst du trotzdem forfahren?",
    "areYouSureProceedWarningMultiActivities": "Wenn es noch offene Freigaben gibt werden diese gelöscht und / oder wenn es noch nicht abgeschlossene Erfüllungskriterien gibt werden diese abgeschlossen! Willst du trotzdem fortfahren?",
    "keepOrDeleteViolatedRelations": "Durch diese Verschiebung geraten Vorgänger-/Nachfolgerbeziehungen oder Meilensteinverbindungen in die falsche Reihenfolge. Sollen sie erhalten bleiben (sie werden auf der Karte rot und gestrichelt dargestellt) oder gelöscht werden?",
    "deleteViolatedRelations": "Durch diese Verschiebung geraten Vorgänger-/Nachfolgerbeziehungen oder Meilensteinverbindungen in die falsche Reihenfolge. Sie werden gelöscht.",
    "deleteCriterion": "Dieses Erfüllungskriterium dauerhaft löschen",
    "deleteThisMilestone": "Diesen Meilenstein löschen",
    "save": "Willst Du Deine Änderungen wirklich speichern?",
    "willBeDeleted": "{action} wird gelöscht",
    "usedInTemplatesDetach": "{thing} wird noch in Prozesslandkarten verwendet. Durch das Löschen wird die Verbindung zur Bibliothek getrennt: In diesen Prozesslandkarten wird daraus ein individuelles Element."
  },
  "contextBar": {
    "actionDetailPage": "Zur Maßnahmen-Detailansicht wechseln",
    "actionsListPage": "Zur Maßnahmenliste wechseln",
    "activityDelete": "Eckpunkt löschen",
    "activityDetailPage": "Zur Eckpunkt-Detailansicht wechseln",
    "activityDuplicate": "Duplizieren des Eckpunkts",
    "activityFavorite": "Eckpunkt Favorit ändern",
    "activityFocus": "Eckpunkt fokussieren",
    "activityLinkDelete": "Beziehung löschen",
    "activityReplace": "Bibliothekseckpunkt ersetzen",
    "activitySummary": "KI generierte Eckpunktzusammenfassung",
    "activityUpdateFromLibrary": "Eckpunkt aus Bibliothek aktualisieren",
    "addDocument": "Neu hinzufügen",
    "approversAndWatchers": "Freigabeverantwortliche & Zu Informierende",
    "addDocumentExisting": "Existierendes Projektdokument verknüpfen",
    "addLink": "Neu hinzufügen",
    "addLinkExisting": "Existierenden Standard verknüpfen",
    "basicDetails": "Grundlegende Details",
    "ccDetailPage": "Zur Erfüllungskriteriums-Detailansicht wechseln",
    "ccListPage": "Zur Erfüllungskriteriumsliste wechseln",
    "checklistPage": "Zur Checkliste wechseln",
    "close": "Schließen",
    "closeActionCreation": "Maßnahme verwerfen",
    "closeCCCreation": "Erfüllungskriterium verwerfen",
    "convertActionToActivity": "Eckpunkt aus vorhandener Maßnahme erstellen",
    "convertCompletionCriterionToActivity": "Eckpunkt aus vorhandenem Erfüllungskriterium erstellen",
    "createAction": "Neue Maßnahme erstellen",
    "createCC": "Neues Erfüllungskriterium erstellen",
    "deleteAction": "Maßnahme löschen",
    "deleteCC": "Erfüllungskriterium löschen",
    "details": "Details",
    "distribute": "Inhalte der Phase gleichverteilen",
    "editDocument": "Bearbeiten",
    "editLink": "Bearbeiten",
    "empty": "Keine Artikel zum Anzeigen",
    "exportTaskToTodo": "Aufgabe zu Microsoft Todo exportieren",
    "exportToTodo": "Zu Microsoft Todo exportieren",
    "inheritFromActivity": "Vom Eckpunkt erben",
    "listDocuments": "Zur Dokumentenliste wechseln",
    "listLinks": "Zur Links-Liste wechseln",
    "milestoneDetailPage": "Zur Meilenstein-Detailansicht wechseln",
    "setManualDueDate": "Fälligkeitsdatum manuell festlegen",
    "milestoneFocus": "Meilenstein fokussieren",
    "mirroredActivityRemove": "Entfernen des gespiegelten Eckpunkts",
    "more": "Mehr",
    "moreOptions": "Weitere Optionen",
    "moveAction": "Maßnahme in anderen Eckpunkt verschieben",
    "moveCC": "Erfüllungskriterium in anderen Eckpunkt verschieben",
    "noComments": "Noch keine Kommentare. Klicken Sie zum Hinzufügen.",
    "noDescription": "Noch keine Beschreibung.",
    "phaseDelete": "Phase löschen",
    "phaseFocus": "Phase fokussieren",
    "phaseSummary": "KI generierte Phasenzusammenfassung",
    "planningDetails": "Planungsdetails",
    "projectPage": "Zu Projektlandkarte wechseln",
    "tagsAndTopics": "Tags & Themen",
    "showFullTitle": "Vollständigen Titel anzeigen",
    "showSingleLineTitle": "Einzeiligen Titel anzeigen",
    "showIcon": "Symbol anzeigen",
    "showText": "Text anzeigen",
    "toDetails": "zu Details",
    "workstreamDelete": "Teilprozess löschen",
    "workstreamFocus": "Teilprozess fokussieren",
    "workstreamSummary": "KI generierte Teilprozesszusammenfassung"
  },
  "datePicker": {
    "from": "Von",
    "to": "Bis"
  },
  "dialog": {
    "areYouSureYouWantToDelete": "Diese Aktion kann nicht rückgängig gemacht werden! Möchtest du wirklich löschen?",
    "attentionNeeded": "Bitte beachten",
    "cannotBeDeleted": "{type} kann nicht gelöscht werden",
    "firstRemoveFromAll": "Bitte entferne zuerst die {links} von allen {relation} um zu löschen. \n {relation}: {usedIn}",
    "isUsedInOthers": "Die gewählte {type} wird in einem oder mehreren {relation} verwendet",
    "willBeDeleted": "{type} wird gelöscht"
  },
  "expandableText": {
    "showLess": "Weniger anzeigen",
    "showMore": "Mehr anzeigen"
  },
  "documentCreateModal": {
    "addDocument": "Neues Dokument hinzufügen",
    "addLink": "Verknüpfung hinzufügen",
    "addProjectDocument": "Füge Projektdokument hinzu",
    "addProjectDocumentTitle": "Neues Projektdokument hinzufügen",
    "editDocument": "Dokument bearbeiten",
    "editProjectDocument": "Projektdokument bearbeiten",
    "link": "Verknüpfung",
    "manipulate": "URL transformieren",
    "relativePath": "Relativer Pfad",
    "relativePathPlaceholder": "z.B. dokumente/datei.pdf",
    "slogan": "Bitte geben Sie den Titel der Datei ein, die Sie speichern möchten, und wählen Sie den entsprechenden Dokumenttyp im Dropdown-Menü daneben aus. Falls zutreffend, können Sie unten auch einen Link hinzufügen.",
    "title": "Titel",
    "titlePlaceholder": "Bitte Titel ausfüllen",
    "type": "Typ"
  },
  "removeUnreferencedModal": {
    "removeButton": "Entferne nicht verwendete Elemente",
    "links": {
      "title": "Entferne nicht verwendete Standards/Vorlagen",
      "success": "Erfolgreich { count } Standards/Vorlagen entfernt",
      "project": {
        "subtitle": "Diese Aktion wird alle nicht verwendeten Standards/Vorlagen aus dem Projekt entfernen.",
        "subtitle2": "{ count } Standards/Vorlagen werden aus dem Projekt entfernt."
      },
      "template": {
        "subtitle": "Diese Aktion wird alle nicht verwendeten Standards/Vorlagen aus der Prozesslandkarte entfernen.",
        "subtitle2": "{ count } Standards/Vorlagen werden aus der Prozesslandkarte entfernt."
      }
    },
    "documents": {
      "title": "Entferne nicht verwendete Projektdokumente",
      "success": "Erfolgreich { count } Projektdokumente entfernt",
      "project": {
        "subtitle": "Diese Aktion wird alle nicht verwendeten Projektdokumente aus dem Projekt entfernen.",
        "subtitle2": "{ count } Projektdokumente werden aus der Prozesslandkarte entfernt."
      },
      "template": {
        "subtitle": "Diese Aktion wird alle nicht verwendeten Projektdokumente aus der Prozesslandkarte entfernen.",
        "subtitle2": "{ count } Projektdokumente werden aus der Prozesslandkarte entfernt."
      }
    }
  },
  "selectFromCompanyModal": {
    "links": {
      "title": "Standards/Vorlagen aus Bibliothek auswählen",
      "empty": "Es gibt keine weiteren Standards/Vorlagen aus der Bibliothek, die zu dieser Prozesslandkarte hinzugefügt werden können.",
      "success": "Erfolgreich { count } Standards/Vorlagen aus der Bibliothek hinzugefügt",
      "failed": "Diese Standards/Vorlagen konnten nicht hinzugefügt werden: { items }"
    },
    "documents": {
      "title": "Projektdokumente aus Bibliothek auswählen",
      "empty": "Es gibt keine weiteren Projektdokumente aus der Bibliothek, die zu dieser Prozesslandkarte hinzugefügt werden können.",
      "success": "Erfolgreich { count } Projektdokumente aus der Bibliothek hinzugefügt",
      "failed": "Diese Projektdokumente konnten nicht hinzugefügt werden: { items }"
    }
  },
  "editActivityModal": {
    "addSpecialAssignment": "Sonderaufgabe hinzufügen",
    "required": "Erforderlich"
  },
  "errors": {
    "aValueMustBeEdited": "Ein Wert muss bearbeitet werden",
    "activityDeadlineAfterPhase": "Das Fälligkeitsdatum des Eckpunkts liegt nach dem Fälligkeitsdatum der Phase",
    "activityOutsideTemplate": "Der Eckpunkt würde außerhalb der Prozesslandkarte verschoben",
    "functionExists": "Eine Funktion mit diesem Namen existiert bereits",
    "invalidEmail": "Ungültige email {email}",
    "noDataFound": "Keine Daten gefunden",
    "noAccessToActivity": "Du hast keinen Zugriff auf den Eckpunkt",
    "noFunctionFound": "Funktion ist nicht vorhanden",
    "notImplemented": "Diese Funktionalität wurde noch nicht implementiert. Bitte versuche es später.",
    "popupsMustBeEnabled": "Popups müssen in dieser Anwendung aktiviert sein, damit der PDF-Export funktioniert.",
    "selectOption": "Du musst vor dem Hinzufügen eine Option auswählen",
    "somethingWentWrong": "Etwas ist schief gelaufen...",
    "wrongActivityState": "Ein Eckpunkt mit dem Status {activityState} kann nicht in eine Phase mit dem Status {phaseState} geschoben werden"
  },
  "files": {
    "abbreviation": "DOK",
    "addDocument": "Projektdokument hinzufügen",
    "addLinksAndTools": "Füge Standard/Vorlage hinzu",
    "allDocuments": "Alle Projektdokumente",
    "allLinksAndTools": "Alle Standards/Vorlagen",
    "allTags": "All Tags",
    "allTopics": "All Topics",
    "anyAssetUsedInProjectLocation": "Alle Assets, die in Projekten verwendet werden, werden hier gespeichert.",
    "cutConnectionToPredecessorSubtitle": "Sind Sie sicher, dass Sie die Verbindung des Projektdokuments trennen möchten? Diese Aktion kann nicht rückgängig gemacht werden!",
    "cutConnectionToPredecessorTitle": "Verbindung zum Vorgänger trennen",
    "deleteDocument": "Dokument löschen",
    "deleteLink": "Link löschen",
    "deleteLinkSubtitle": "Link wird aus der Aktivität gelöscht. Diese Aktion kann nicht rückgängig gemacht werden! Möchtest du wirklich löschen?",
    "document": "Dokument",
    "documentHasBeenLinkedSuccessfully": "Projektdokument wurde erfolgreich verknüpft.",
    "linkHasBeenAttachedSuccessfully": "Link wurde erfolgreich zur Eckpunkt hinzugefügt",
    "documentHasBeenUnlinkedSuccessfully": "Projektdokument wurde erfolgreich entfernt.",
    "documentsReordered": "Die Projektdokumente wurden neu geordnet.",
    "documentHasBeenUpdated": "Projektdokument wurde aktualisiert",
    "documents": "Dokumente",
    "fileName": "Dateiname",
    "fileType": "Dateityp",
    "fromPredecessors": "Von Vorgängern",
    "goToSharepoint": "Zum SharePoint",
    "input": "Eingabe",
    "link": "Standard/Vorlagen",
    "links": "Standards/Vorlagen",
    "linkDocument": "Projektdokument verknüpfen",
    "linkHasBeenRemovedFromActivity": "Link wurde aus der Eckpunkt entfernt",
    "linksReordered": "Die Standard/Vorlagen wurden neu geordnet.",
    "manageInput": "Eingabe verwalten",
    "manageInputSubtitle": "Wählen Sie den Eckpunkt aus, von dem Sie das Dokument verknüpfen möchten.",
    "noCutConnectionPossibleWarningDescription": "Um die Verbindung zum Vorgängerdokument zu trennen, muss ein Vorgänger vorhanden sein",
    "noCutConnectionPossibleWarningTitle": "Verbindung zum Vorgänger trennen kann nicht ausgeführt werden",
    "noDocumentFound": "Keine Projektdokument gefunden",
    "noLinksFound": "Keine Links gefunden",
    "output": "Ausgabe",
    "pleaseTryAgainOrAddAnotherLink": "Bitte versuchen Sie es erneut oder fügen Sie einen anderen Link zu diesem Projekt hinzu",
    "pleaseTryAgainOrLinkAnotherDocument": "Bitte versuche es erneut oder verknüpfe ein anderes Projektdokument.",
    "projectDocument": "Projektdokument",
    "projectDocuments": "Projektdokumente",
    "projectLevelLinksAndTools": "Links auf Projektebene",
    "selectFromPredecessors": "Aus Vorgängern auswählen",
    "standardDocument": "Standards/Vorlagen",
    "startByLinkingAFile": "Beginne mit dem Verknüpfen einer Datei",
    "startCreatingByUploadingFiles": "Beginne mit dem Erstellen, indem du Dokumente verknüpfen.",
    "tagOrTopicHasBeenRemovedFromActivity": "Tag/Topic was removed from activity",
    "tagOrTopicHasBeenAttachedSuccessfully": "Tag/Topic has been attached successfully",
    "templateFiles": "Projektdokumente",
    "templateLevelLinksAndTools": "Links auf Templatebene",
    "companyLevelLinksAndTools": "Standards/Vorlagen auf Unternehmensebene",
    "companyLevelDocuments": "Projektdokumente auf Unternehmensebene",
    "typeInADocumentName": "Gebe den Namen eines Projektdokumentes ein.",
    "typeInALinkName": "Gebe den Namen eines Projektlinks ein.",
    "typeInATagName": "Type in a tag's name.",
    "typeInATopicName": "Type in a topic's name.",
    "yourSearchDidNotMatchAnyDocument": "Deine Suche {query} stimmte mit keinem der Dokumente überein.",
    "yourSearchDidNotMatchAnyLink": "Deine Suche {query} stimmte mit keinem der Links überein."
  },
  "form": {
    "pleaseSelect": "Bitte auswählen",
    "select": "Auswählen",
    "typeToSearch": "Tippe um zu suchen",
    "resetForm": "Eingaben zurücksetzen"
  },
  "function": {
    "addNewFunction": "Neue Funktion hinzufügen",
    "cannotDeleteTemplateUse": "Die ausgewählte Funktion wird in mindestens einer Prozesslandkarte benutzt.",
    "color": "Farbe",
    "companyFunction": "Unternehmensfunktion",
    "confirmRemoval": "Möchtest du die Funktion {name} wirklich entfernen?",
    "confirmedRemoval": "Function was removed",
    "createdBy": "Erstellt von",
    "customColor": "Eigene Farbe",
    "customColorHex": "Hex-Wert",
    "customColorInvalid": "Gültigen Hex-Farbwert eingeben (#RRGGBB)",
    "deleteFunction": "Funktion löschen",
    "editFunction": "Funktion bearbeiten",
    "function": "Funktion",
    "functions": "Funktionen",
    "functionsCounted": "keine Funktionen | {n} Funktion | {n} Funktionen",
    "individual": "Individuell",
    "label": "Nummernfarbe",
    "lastUpdated": "Zuletzt geändert",
    "level": "Ebene",
    "name": "Name",
    "newFunction": "Neue Funktion",
    "notDefined": "Nicht definiert",
    "override": "Überschrieben",
    "overview": "Übersicht",
    "removePreviouslySetFunction": "Vorher eingestellte Funktion entfernen",
    "resetAllOverrides": "Setze alle Überschreibungen zurück",
    "selectFromCompany": "Aus Bibliothek auswählen",
    "thisCriterionHasNoFunction": "Dieses Erfüllungskriterium hat keine ausgewählte Funktion",
    "title": "Titel",
    "user": "Benutzer"
  },
  "glossary": {
    "activity": "Eckpunkt",
    "deleted": "[gelöscht]",
    "edit": "Editieren",
    "emailAddress": "Email Adresse",
    "implementationManager": "Durchführungsverantwortlicher",
    "link": "Abhängigkeit",
    "no": "Nein",
    "noResponsibleAssigned": "Kein Verantwortlicher zugewiesen",
    "number": "Nummer",
    "phase": "Phase",
    "phases": "Phasen",
    "project": "Projekt",
    "projectFunction": "Funktion",
    "predecessor": "Vorgänger",
    "today": "Heute",
    "url": "URL",
    "warning": "Vorsicht!",
    "workstream": "Teilprozess",
    "workstreams": "Teilprozesse",
    "yes": "Ja"
  },
  "operations": {
    "history": {
      "changedFields": "{changed_fields}",
      "changedManyFields": "{changed_fields} und weitere Felder",
      "action": {
        "addComment": "Kommentar zu Aktion hinzugefügt",
        "updateComment": "Kommentar in Aktion aktualisiert",
        "removeComment": "Kommentar von Aktion entfernt"
      },
      "activityAction": {
        "addComment": "Kommentar zu Aktion hinzugefügt",
        "updateComment": "Kommentar in Aktion aktualisiert",
        "removeComment": "Kommentar von Aktion entfernt"
      },
      "activity": {
        "addAction": "Maßnahme zu Eckpunkt hinzugefügt",
        "addApprover": "Freigabeverantwortlicher zu Eckpunkt hinzugefügt",
        "addComment": "Kommentar zu Eckpunkt hinzugefügt",
        "addChecklistRow": "Checklisten-Zeile zu Eckpunkt hinzugefügt",
        "addChecklistStep": "Checklisten-Schritt zu Eckpunkt hinzugefügt",
        "addCompletionCriterion": "Erfüllungskriterium zu Eckpunkt hinzugefügt",
        "addSuccessor": "Nachfolger zu Eckpunkt hinzugefügt",
        "addTag": "Tag zu Eckpunkt hinzugefügt",
        "addPredecessor": "Vorgänger zu Eckpunkt hinzugefügt",
        "addWatcher": "Zu Informierender zu Eckpunkt hinzugefügt",
        "addDocument": "Projektdokument zu Eckpunkt hinzugefügt",
        "addLink": "Standard/Vorlage zu Eckpunkt hinzugefügt",
        "convertCompletionCriterionToActivity": "Eckpunkt aus vorhandenem Erfüllungskriterium erstellt",
        "convertActionToActivity": "Eckpunkt aus vorhandener Maßnahme erstellt",
        "createActivity": "Eckpunkt erstellt",
        "duplicateActivity": "Eckpunkt über Duplizieren erstellt",
        "duplicateActivities": "Mehrere Eckpunkte über Duplizieren erstellt",
        "duplicateActivitiesRelated": {
          "predecessor": "Vorgänger aktualisiert als Ergebnis einer Eckpunktduplizierung",
          "successor": "Nachfolger aktualisiert als Ergebnis einer Eckpunktduplizierung"
        },
        "updateActivity": "<span class='changed-fields'>{changed_fields}</span> in Eckpunkt verändert",
        "updateActivities": "<span class='changed-fields'>{changed_fields}</span> in mehreren Eckpunkten verändert",
        "updateAction": "Maßnahme in Eckpunkt aktualisiert",
        "updateApprover": "Freigabeverantwortlicher in Eckpunkt aktualisiert",
        "updateChecklistCell": "Checklisten-Zelle in Eckpunkt aktualisiert",
        "updateChecklistRow": "Checklisten-Zeile in Eckpunkt aktualisiert",
        "updateChecklistRowSource": "Zeilenquelle der Checkliste in Eckpunkt geändert",
        "updateChecklistStep": "Checklisten-Schritt in Eckpunkt aktualisiert",
        "updateComment": "Kommentar in Eckpunkt aktualisiert",
        "updateCompletionCriterion": "Erfüllungskriterien in Eckpunkt aktualisiert",
        "updateDocument": "Projektdokument in Eckpunkt aktualisiert",
        "updateLink": "Standard/Vorlage in Eckpunkt aktualisiert",
        "removeActivity": "Eckpunkt entfernt",
        "removeActivities": "Mehrere Eckpunkte entfernt",
        "removeActivitiesRelated": {
          "predecessor": "Vorgänger aktualisiert da Nachfolger gelöscht wurde",
          "successor": "Nachfolger aktualisiert da Vorgänger gelöscht wurde"
        },
        "removeAction": "Maßnahme entfernt",
        "removeChecklistRow": "Checklisten-Zeile aus Eckpunkt entfernt",
        "removeChecklistStep": "Checklisten-Schritt aus Eckpunkt entfernt",
        "removeComment": "Kommentar aus Eckpunkt entfernt",
        "removeCompletionCriterion": "Erfüllungskriterium aus Eckpunkt entfernt",
        "removeSuccessor": "Nachfolger in Eckpunkt entfernt",
        "removePredecessor": "Vorgänger in Eckpunkt entfernt",
        "removeApprover": "Freigabeverantwortlicher in Eckpunkt entfernt",
        "removeLink": "Standard/Vorlage in Eckpunkt entfernt",
        "removeDocument": "Projektdokument in Eckpunkt entfernt",
        "removeWatcher": "Zu Informierender in Eckpunkt entfernt",
        "removeTag": "Tag in Eckpunkt entfernt",
        "toggleFavorite": "Favorit in Eckpunkt verändert",
        "updateFromLibrary": "Eckpunkt aus Bibliothek aktualisiert"
      },
      "completionCriterion": {
        "addComment": "Kommentar zu Erfüllungskriterium hinzugefügt",
        "updateComment": "Kommentar in Erfüllungskriterium aktualisiert",
        "removeComment": "Kommentar von Erfüllungskriterium entfernt"
      },
      "activityCompletionCriterion": {
        "addComment": "Kommentar zu Erfüllungskriterium hinzugefügt",
        "updateComment": "Kommentar in Erfüllungskriterium aktualisiert",
        "removeComment": "Kommentar von Erfüllungskriterium entfernt"
      },
      "phase": {
        "compressPhase": "Phase komprimiert",
        "createPhase": "Phase erstellt",
        "updatePhase": "<span class='changed-fields'>{changed_fields}</span> in Phase verändert",
        "deletePhase": "Phase gelöscht",
        "shiftPhaseElements": "Space Tool (Phasenlänge beibehalten) genutzt"
      },
      "milestone": {
        "updateMilestone": "<span class='changed-fields'>{changed_fields}</span> in Meilenstein verändert",
        "createMilestone": "Zwischenmeilenstein erstellt",
        "deleteMilestone": "Zwischenmeilenstein entfernt",
        "addApprover": "Freigabeverantwortlicher zu Meilenstein hinzugefügt",
        "updateApprover": "Freigabeverantwortlicher in Meilenstein aktualisiert",
        "removeApprover": "Freigabeverantwortlicher in Meilenstein entfernt",
        "addComment": "Kommentar zu Meilenstein hinzugefügt",
        "updateComment": "Kommentar in Meilenstein aktualisiert",
        "removeComment": "Kommentar von Meilenstein entfernt"
      },
      "project": {
        "updateProject": "<span class='changed-fields'>{changed_fields}</span> in Projekt verändert",
        "copyProject": "Kopie des Projekts erstellt",
        "reorderProjectElements": "Reihenfolge von Elementen angepasst",
        "shiftProjectElements": "Space Tool (Phasenlänge anpassen) genutzt",
        "addMembers": "Mitglieder zum Projekt hinzugefügt",
        "removeMember": "Mitglied aus Projekt entfernt",
        "leaveProject": "Mitglied hat das Projekt verlassen",
        "addProjectChecklistRow": "Zeile zum Checklisten-Zeilen-Pool hinzugefügt",
        "updateProjectChecklistRow": "Zeile des Checklisten-Zeilen-Pools aktualisiert",
        "removeProjectChecklistRow": "Zeile aus dem Checklisten-Zeilen-Pool entfernt"
      },
      "projectFunction": {
        "createProjectFunction": "Funktion zu Projekt hinzugefügt",
        "updateProjectFunction": "<span class='changed-fields'>{changed_fields}</span> in Funktion verändert",
        "removeProjectFunction": "Funktion aus Projekt entfernt",
        "replaceProjectFunction": "Funktion im Projekt ersetzt"
      },
      "link": {
        "addLinkToProject": "Standard/Vorlage zu Projekt hinzugefügt",
        "updateLink": "<span class='changed-fields'>{changed_fields}</span> in Standard/Vorlage verändert",
        "removeLink": "Standard/Vorlage aus Projekt entfernt",
        "removeUnreferencedLinks": "Unbenutzte Standards/Vorlagen entfernt"
      },
      "document": {
        "addDocumentToProject": "Projektdokument zu Projekt hinzugefügt",
        "updateDocument": "<span class='changed-fields'>{changed_fields}</span> in Projektdokument verändert",
        "removeDocument": "Projektdokument aus Projekt entfernt",
        "removeUnreferencedDocuments": "Unbenutzte Projektdokumente entfernt"
      },
      "workstream": {
        "createWorkstream": "Teilprozess erstellt",
        "deleteWorkstream": "Teilprozess gelöscht",
        "updateWorkstream": "<span class='changed-fields'>{changed_fields}</span> in Teilprozess verändert"
      },
      "meetingSummary": {
        "createEntityReferences": "Besprechungsreferenzen zu Besprechungszusammenfassung hinzugefügt",
        "removeEntityReference": "Besprechungsreferenz von Besprechungszusammenfassung entfernt"
      }
    }
  },
  "entities": {
    "history": {
      "activity": {
        "addAction": "Maßnahme zu Eckpunkt hinzugefügt",
        "addApprover": "Freigabeverantwortlicher zu Eckpunkt hinzugefügt",
        "addComment": "Kommentar zu diesem Eckpunkt hinzugefügt",
        "addCompletionCriterion": "Erfüllungskriterium zu Eckpunkt hinzugefügt",
        "addSuccessor": "Nachfolger zu Eckpunkt hinzugefügt",
        "addPredecessor": "Vorgänger zu Eckpunkt hinzugefügt",
        "addWatcher": "Zu Informierender zu Eckpunkt hinzugefügt",
        "addDocument": "Projektdokument zu Eckpunkt hinzugefügt",
        "addLink": "Standard/Vorlage zu Eckpunkt hinzugefügt",
        "createActivity": "Eckpunkt erstellt",
        "duplicateActivity": "Eckpunkt über Duplizieren erstellt",
        "duplicateActivities": "Eckpunkt über Duplizieren mehrerer Eckpunkte erstellt",
        "updateActivity": "<span class='changed-fields'>{changed_fields}</span> in Eckpunkt verändert",
        "updateActivities": "<span class='changed-fields'>{changed_fields}</span> in Eckpunkt durch Mehrfachselektion verändert",
        "updateAction": "Maßnahme in Eckpunkt aktualisiert",
        "updateApprover": "Freigabeverantwortlicher in Eckpunkt aktualisiert",
        "updateComment": "Kommentar in diesem Eckpunkt aktualisiert",
        "updateCompletionCriterion": "Erfüllungskriterien in Eckpunkt aktualisiert",
        "updateDocument": "Projektdokument in Eckpunkt aktualisiert",
        "updateLink": "Standard/Vorlage in Eckpunkt aktualisiert",
        "removeActivity": "Eckpunkt entfernt",
        "removeActivities": "Eckpunkt durch Mehrfachselektion entfernt",
        "removeApprover": "Freigabeverantwortlicher in Eckpunkt entfernt",
        "removeComment": "Kommentar aus diesem Eckpunkt entfernt",
        "removeCompletionCriterion": "Erfüllungskriterium aus Eckpunkt entfernt",
        "removeDocument": "Projektdokument in Eckpunkt entfernt",
        "removeLink": "Standard/Vorlage in Eckpunkt entfernt",
        "removePredecessor": "Vorgänger in Eckpunkt entfernt",
        "removeSuccessor": "Nachfolger in Eckpunkt entfernt",
        "removeWatcher": "Zu Informierender in Eckpunkt entfernt"
      },
      "phase": {
        "updatePhase": "Geändert <span class='changed-fields'>{changed_fields}</span> in diesen Eckpunkt durch den Statuswechsel der Phase."
      },
      "milestone": {
        "updateMilestone": "Geändert <span class='changed-fields'>{changed_fields}</span> in diesen Eckpunkt durch den Statuswechsel des finalen Meilensteins."
      },
      "project": {
        "updateProject": "Geändert <span class='changed-fields'>{changed_fields}</span> im Projekt"
      }
    }
  },
  "history": {
    "activity": {
      "updateActivities": "Mehrere Eckpunkte aktualisiert",
      "removeActivities": "Mehrere Eckpunkte gelöscht",
      "duplicateActivities": "Mehrere Eckpunkte dupliziert"
    },
    "supportedOperationType": {
      "historyActivityAddAction": "Eckpunkt: Maßnahme hinzugefügt",
      "historyActivityUpdateAction": "Eckpunkt: Maßnahme aktualisiert",
      "historyActivityRemoveAction": "Eckpunkt: Maßnahme gelöscht",
      "historyActivityAddApprover": "Eckpunkt: Freigabeverantwortliche Funktion hinzugefügt",
      "historyActivityUpdateApprover": "Eckpunkt: Freigabeverantwortliche Funktion aktualisiert",
      "historyActivityRemoveApprover": "Eckpunkt: Freigabeverantwortliche Funktion entfernt",
      "historyActivityAddCompletionCriterion": "Eckpunkt: Erfüllungskriterium hinzugefügt",
      "historyActivityUpdateCompletionCriterion": "Eckpunkt: Erfüllungskriterium aktualisiert",
      "historyActivityRemoveCompletionCriterion": "Eckpunkt: Erfüllungskriterium gelöscht",
      "historyActivityAddPredecessor": "Eckpunkt: Vorgänger hinzugefügt",
      "historyActivityAddSuccessor": "Eckpunkt: Nachfolger hinzugefügt",
      "historyActivityRemovePredecessor": "Eckpunkt: Vorgänger entfernt",
      "historyActivityRemoveSuccessor": "Eckpunkt: Nachfolger entfernt",
      "historyActivityCreateActivity": "Eckpunkt: <-- Erstellt",
      "historyActivityUpdateActivity": "Eckpunkt: <-- Aktualisiert",
      "historyActivityRemoveActivity": "Eckpunkt: <-- Gelöscht",
      "historyActivityAddWatcher": "Eckpunkt: Zu Informierende hinzugefügt",
      "historyActivityRemoveWatcher": "Eckpunkt: Zu Informierende entfernt",
      "historyActivityUpdateActivities": "Eckpunkte: <-- Aktualisiert",
      "historyActivityRemoveActivities": "Eckpunkte: <-- Gelöscht",
      "historyActivityDuplicateActivities": "Eckpunkte: <-- Dupliziert",
      "historyActivityAddTag": "Eckpunkt: Tag/Thema hinzugefügt",
      "historyActivityRemoveTag": "Eckpunkt: Tag/Thema entfernt",
      "historyActivityAddComment": "Eckpunkt: Kommentar hinzugefügt",
      "historyActivityUpdateComment": "Eckpunkt: Kommentar aktualisiert",
      "historyActivityRemoveComment": "Eckpunkt: Kommentar gelöscht",
      "historyActionAddComment": "Maßnahme: Kommentar hinzugefügt",
      "historyActionUpdateComment": "Maßnahme: Kommentar aktualisiert",
      "historyActionRemoveComment": "Maßnahme: Kommentar gelöscht",
      "historyCompletionCriterionAddComment": "Erfüllungskriterium: Kommentar hinzugefügt",
      "historyCompletionCriterionUpdateComment": "Erfüllungskriterium: Kommentar aktualisiert",
      "historyCompletionCriterionRemoveComment": "Erfüllungskriterium: Kommentar gelöscht",
      "historyActivityAddChecklistStep": "Eckpunkt: Checklisten-Schritt hinzugefügt",
      "historyActivityUpdateChecklistStep": "Eckpunkt: Checklisten-Schritt aktualisiert",
      "historyActivityRemoveChecklistStep": "Eckpunkt: Checklisten-Schritt gelöscht",
      "historyActivityAddChecklistRow": "Eckpunkt: Checklisten-Zeile hinzugefügt",
      "historyActivityUpdateChecklistRow": "Eckpunkt: Checklisten-Zeile aktualisiert",
      "historyActivityRemoveChecklistRow": "Eckpunkt: Checklisten-Zeile gelöscht",
      "historyActivityUpdateChecklistCell": "Eckpunkt: Checklisten-Zelle aktualisiert",
      "historyActivityUpdateChecklistRowSource": "Eckpunkt: Zeilenquelle der Checkliste geändert",
      "historyProjectAddChecklistRow": "Projekt: Checklisten-Pool-Zeile hinzugefügt",
      "historyProjectUpdateChecklistRow": "Projekt: Checklisten-Pool-Zeile aktualisiert",
      "historyProjectRemoveChecklistRow": "Projekt: Checklisten-Pool-Zeile gelöscht",
      "historyMilestoneUpdateMilestone": "Meilenstein: <-- Aktualisiert",
      "historyMilestoneCreateMilestone": "Meilenstein: <-- Erstellt",
      "historyMilestoneDeleteMilestone": "Meilenstein: <-- Gelöscht",
      "historyMilestoneAddComment": "Meilenstein: Kommentar hinzugefügt",
      "historyMilestoneUpdateComment": "Meilenstein: Kommentar aktualisiert",
      "historyMilestoneRemoveComment": "Meilenstein: Kommentar gelöscht",
      "historyMilestoneRelevanceDeleteMilestoneRelevance": "Meilenstein: Meilensteinrelevanz entfernt",
      "historyPhaseCreatePhase": "Phase: <-- Erstellt",
      "historyPhaseUpdatePhase": "Phase: <-- Aktualisiert",
      "historyPhaseDeletePhase": "Phase: <-- Gelöscht",
      "historyPhaseShiftPhaseElements": "Phase: <-- Space Tool (Phasenlänge beibehalten) benutzt",
      "historyProjectUpdateProject": "Projekt: <-- Projektdetails aktualisiert",
      "historyProjectShiftProjectElements": "Phase: <-- Space Tool (Phasenlänge anpassen) genutzt",
      "historyProjectReorderProjectElements": "Projekt: <-- Reihenfolge von Elementen angepasst",
      "historyWorkstreamUpdateWorkstream": "Teilprozess: <-- Aktualisiert",
      "historyWorkstreamCreateWorkstream": "Teilprozess: <-- Erstellt",
      "historyWorkstreamDeleteWorkstream": "Teilprozess: <-- Gelöscht",
      "historyProjectFunctionReplaceProjectFunction": "Funktion: Durch andere Funktion ersetzt"
    },
    "filter": {
      "hideFilters": "Filter ausblenden",
      "operationType": "Änderungstyp",
      "showFilters": "Filter einblenden"
    },
    "changeHistory": "Historie",
    "undoOperation": {
      "title": "Rückgängig",
      "subtitle": "Willst du die letzte Operation rückgängig machen?",
      "success": "Operation erfolgreich rückgängig gemacht"
    },
    "replaceProjectFunction": {
      "description": "Funktion <span class='changed-fields'>{removed}</span> durch <span class='changed-fields'>{replacement}</span> ersetzt",
      "affected": "Betroffen: {items}",
      "scope": {
        "activities": "{count} Eckpunkt | {count} Eckpunkte",
        "actions": "{count} Maßnahme | {count} Maßnahmen",
        "completionCriteria": "{count} Erfüllungskriterium | {count} Erfüllungskriterien",
        "approvals": "{count} Freigabe | {count} Freigaben",
        "phases": "{count} Phase | {count} Phasen",
        "watchers": "{count} Zu Informierender | {count} Zu Informierende"
      }
    }
  },
  "hidenPhasesAndWorkstreams": {
    "infoPanel": "Phasen können nur vom Anfang oder Ende der Karte ausgeblendet werden.",
    "showAll": "Alle einblenden"
  },
  "labels": {
    "deleteSuccess": "Label erfolgreich aus der Bibliothek gelöscht",
    "updateSuccess": "Label erfolgreich aktualisiert",
    "deleteWarning": "Das Label wird für alle Eckpunkte in der Bibliothek entfernt."
  },
  "library": {
    "activities": "Eckpunkte",
    "addToLibrary": "Zu Bibliothek übertragen",
    "createChild": "Variante erstellen",
    "duplicate": "Duplizieren",
    "filterByLabels": "Nach Labels filtern",
    "goToLibrary": "Gehe zur Bibliothek",
    "hasBeenMoved": "Erfolgreich in Bibliothek übertragen",
    "label": "Label",
    "labels": "Labels",
    "selectFromCompanyLibrary": "Aus Eckpunktbibliothek auswählen",
    "matches": "Passt zu",
    "more": "mehr",
    "usedIn": "Verwendet in"
  },
  "libraryHistory": {
    "title": "Bibliothekshistorie",
    "noHistory": "Für diesen Eckpunkt ist keine Historie verfügbar.",
    "inheritedBadge": "Geerbt",
    "brokeInheritance": "Vererbung für {field} aufgehoben",
    "restoredInheritance": "Vererbung für {field} wiederhergestellt",
    "filter": {
      "entityType": "Objekttyp",
      "user": "Benutzer",
      "allUsers": "Alle Benutzer"
    },
    "entityType": {
      "CompanyActivity": "Eckpunkt",
      "CompanyCompletionCriterion": "Erfüllungskriterium",
      "CompanyChecklistStep": "Checklisten-Schritt",
      "CompanyDocument": "Dokument",
      "CompanyLink": "Standard/Vorlage",
      "CompanyTag": "Tag",
      "CompanyActivityLabel": "Eckpunkt-Label",
      "CompanyFunction": "Funktion"
    },
    "field": {
      "title": "Titel",
      "order": "Reihenfolge",
      "description": "Beschreibung",
      "responsibleId": "Durchführungsverantwortlich",
      "approversIds": "Freigabeverantwortliche",
      "watchersIds": "Zu Informierende",
      "tagsIds": "Tags",
      "labelsIds": "Labels",
      "documentsIds": "Dokumente",
      "linksIds": "Standards/Vorlagen",
      "parentId": "Übergeordnet",
      "topic": "Thema",
      "mimeType": "Dateityp",
      "relativePath": "Pfad",
      "link": "URL",
      "name": "Name",
      "color": "Farbe",
      "label": "Nummernfarbe",
      "overrideTitle": "Titel",
      "overrideDescription": "Beschreibung",
      "overrideResponsible": "Durchführungsverantwortlich",
      "overrideApprover": "Freigabeverantwortliche",
      "overrideWatcher": "Zu Informierende",
      "overrideTag": "Tag",
      "overrideTopic": "Thema",
      "overrideChecklist": "Checkliste"
    },
    "operationType": {
      "historyCompanyActivityCreate": "Eckpunkt: Erstellt",
      "historyCompanyActivityUpdate": "Eckpunkt: Aktualisiert",
      "historyCompanyActivityRemove": "Eckpunkt: Gelöscht",
      "historyCompanyActivityDuplicate": "Eckpunkt: Dupliziert",
      "historyCompanyActivityAddApprover": "Eckpunkt: Freigabeverantwortliche hinzugefügt",
      "historyCompanyActivityRemoveApprover": "Eckpunkt: Freigabeverantwortliche entfernt",
      "historyCompanyActivityAddWatcher": "Eckpunkt: Zu Informierende hinzugefügt",
      "historyCompanyActivityRemoveWatcher": "Eckpunkt: Zu Informierende entfernt",
      "historyCompanyActivityAddTag": "Eckpunkt: Tag hinzugefügt",
      "historyCompanyActivityRemoveTag": "Eckpunkt: Tag entfernt",
      "historyCompanyActivityAddDocument": "Eckpunkt: Dokument hinzugefügt",
      "historyCompanyActivityRemoveDocument": "Eckpunkt: Dokument entfernt",
      "historyCompanyActivityAddLink": "Eckpunkt: Standard/Vorlage hinzugefügt",
      "historyCompanyActivityRemoveLink": "Eckpunkt: Standard/Vorlage entfernt",
      "historyCompanyCompletionCriterionCreate": "Erfüllungskriterium: Erstellt",
      "historyCompanyCompletionCriterionUpdate": "Erfüllungskriterium: Aktualisiert",
      "historyCompanyCompletionCriterionRemove": "Erfüllungskriterium: Gelöscht",
      "historyCompanyChecklistStepCreate": "Checklisten-Schritt: Erstellt",
      "historyCompanyChecklistStepUpdate": "Checklisten-Schritt: Aktualisiert",
      "historyCompanyChecklistStepRemove": "Checklisten-Schritt: Gelöscht",
      "historyCompanyDocumentCreate": "Dokument: Erstellt",
      "historyCompanyDocumentUpdate": "Dokument: Aktualisiert",
      "historyCompanyDocumentRemove": "Dokument: Gelöscht",
      "historyCompanyLinkCreate": "Standard/Vorlage: Erstellt",
      "historyCompanyLinkUpdate": "Standard/Vorlage: Aktualisiert",
      "historyCompanyLinkRemove": "Standard/Vorlage: Gelöscht",
      "historyCompanyTagCreate": "Tag: Erstellt",
      "historyCompanyTagUpdate": "Tag: Aktualisiert",
      "historyCompanyTagRemove": "Tag: Gelöscht",
      "historyCompanyActivityLabelCreate": "Eckpunkt-Label: Erstellt",
      "historyCompanyActivityLabelUpdate": "Eckpunkt-Label: Aktualisiert",
      "historyCompanyActivityLabelRemove": "Eckpunkt-Label: Gelöscht",
      "historyCompanyFunctionCreate": "Funktion: Erstellt",
      "historyCompanyFunctionUpdate": "Funktion: Aktualisiert",
      "historyCompanyFunctionRemove": "Funktion: Gelöscht"
    }
  },
  "linksAndTools": {
    "abbreviation": "Standard/Vorlage",
    "addLink": "URL",
    "addLinksAndTools": "Füge Standard/Vorlage hinzu",
    "addLinksAndToolsModalTitle": "Füge Standard/Vorlage hinzu",
    "deleteLink": "Link löschen",
    "description": "Beschreibung",
    "editLinksAndTools": "Standard/Vorlage bearbeiten",
    "title": "Titel",
    "titlePlaceholder": "Bitte Titel ausfüllen",
    "type": "Typ"
  },
  "locale": {
    "de": "Deutsch",
    "en": "Englisch"
  },
  "login": {
    "backToLogin": "Zurück zum Login",
    "checkYourEmail": "Überprüfe deine Email",
    "clickToResend": "Neu senden",
    "confirmPassword": "Passwort bestätigen",
    "confirmResetPassword": "Soll eine Email zum Zurücksetzen des Passworts an die Person verschickt werden?",
    "didNotReceive": "Email nicht bekommen?",
    "email": "Email",
    "emailPlaceholder": "Gebe deine Email ein",
    "forgotPassword": "Passwort vergessen?",
    "helpText": "Problems? feel free to contact { email } if you have any questions",
    "login": "Login",
    "loginWithSSO": "Mit SSO einloggen",
    "loginWithBeeboardAccount": "Oder mit Nutzername und Passwort anmelden",
    "noWorries": "Keine Sorge, wir schicken Dir Informationen zum Zurücksetzen des Passwortes.",
    "password": "Passwort",
    "passwordReset": "Password zurückgesetzt",
    "passwordResetMessage": "Dein Passwort wurde erfolgreich zurückgesetzt. Klick unten um zum Login zu gelangen.",
    "passwordResetSent": "Wir haben einen Link zum Zurücksetzen der Email an die Addresse {email} geschickt",
    "resetPassword": "Password zurücksetzen",
    "setNewPassword": "Definiere neues Passwort",
    "setNewPasswordMessage": "Dein neues Passwort muss sich von zuvor benutzten unterscheiden.",
    "ssoWindowIsOpened": "Das SSO-Fenster ist geöffnet. Bitte schließen Sie die Anmeldung ab oder schließen Sie das Popup, um es erneut zu versuchen.",
    "username": "Benutzername",
    "wrong": "The username or password you entered is incorrect"
  },
  "map": {
    "activityGrouping": "Gestapelte Eckpunkte gruppieren (an / aus)",
    "addActivity": "Eckpunkt hinzufügen",
    "addMilestone": "Meilenstein hinzufügen",
    "addPhase": "Phase hinzufügen",
    "addWorkstream": "Teilprozess hinzufügen",
    "expandWorkstream": "Teilprozess vergrößern",
    "collapseWorkstream": "Teilprozess verkleinern",
    "compressFixMilestone": "Diesen Termin fixieren",
    "compressTool": "Komprimieren Richtung Phasenstart oder -ende",
    "compressUnfixMilestone": "Fixierung aufheben",
    "contextMenu": {
      "favoriteAdd": "Zu Favoriten hinzufügen",
      "favoriteRemove": "Aus Favoriten entfernen"
    },
    "exportPDF": "Als PDF exportieren",
    "exportToPlanner": "Aufgaben zu Microsoft exportieren",
    "importFromTodo": "Aus Microsoft Todo importieren",
    "importFromMicrosoft": "Aus Microsoft importieren",
    "importTasks": "Aufgaben importieren",
    "mirrorEntitiesIntoProject": "Elemente spiegeln",
    "connectionsDirect": "Direkte Verbindungen anzeigen",
    "connectionsFull": "Mehr Verbindungen anzeigen",
    "connectionsAll": "Alle Verbindungen anzeigen",
    "connectionsNone": "Keine Verbindungen anzeigen",
    "connectedMilestonesNone": "Keine verbundenen Meilensteine anzeigen",
    "connectedMilestonesOptional": "Optionale Meilensteine anzeigen",
    "connectedMilestonesRequired": "Erforderliche Meilensteine anzeigen",
    "focusActivity": "Eckpunkte fokussieren",
    "focusToday": "Heute fokussieren",
    "groupMembers": "{count} gestapelte Eckpunkte",
    "hiddenByFilter": "Durch Filter ausgeblendet",
    "hiddenPhasesWorkstreams": "Ausgeblendete Phasen und Teilprozesse",
    "hiddenWorkstreams": "Ausgeblendete Teilprozesse",
    "hiddenWorkstreamsAndFilter": "Ausgeblendete Teilprozesse & Filter",
    "linkingTool": "Verlinkungs Tool",
    "milestoneOverlay": "Meilensteinübersicht",
    "moveTool": "Move Tool",
    "moveToolVertical": "Teilprozess Move Tool",
    "presentationMode": "Präsentationsmodus",
    "resetFilter": "Filter zurücksetzen",
    "selectFilteredActivities": "Gefilterte Aktivitäten auswählen ({count})",
    "selectionTool": "Selection Tool",
    "spaceToolAdjustPhaseLength": "Space Tool (Phasenlänge anpassen)",
    "spaceToolPreservePhaseLength": "Space Tool (Phasenlänge beibehalten)",
    "splitPhase": "Phase spalten",
    "stateStatusFilter": "Status & Statusanzeige",
    "statusView": "Status Sicht (an / aus)",
    "markupTool": "Markierungsstift",
    "clearMarkup": "Markierungen löschen",
    "undo": "Rückgängig",
    "roles": {
      "responsible": "Verantwortlich",
      "approver": "Freigabe"
    }
  },
  "message": {
    "approvalRequested": "Freigabe angefordert",
    "cannotAddToDonePhase": "Diese Phase ist bereits erledigt",
    "cannotDelete": "{action} kann nicht gelöscht werden",
    "cannotDeletePhaseWithActivity": "Die Phase kann nicht gelöscht werden da sie Eckpunkte enthält.",
    "confirmDeletion": "Möchtest Du dies wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "copiedSuccessfully": "{action} wurde erfolgreich kopiert",
    "description": "Beschreibung",
    "functionRemovalWarning": "Sollte eine Funktion ausgewählt werden die bereits Freigabeverantwortlich oder zu Informierend ist, wird die Funktion dort entfernt.",
    "functionUsed": "Die Funktion kann nicht gelöscht werden, da sie von anderen Ressourcen referenziert wird.",
    "hasBeenDeleted": "{thing} wurde erfolgreich gelöscht",
    "hasBeenRemoved": "{thing} wurde erfolgreich entfernt",
    "hasBeenRemovedFromVariant": "{thing} wurde erfolgreich aus der Variante entfernt",
    "hasBeenRestored": "{thing} wurde erfolgreich wiederhergestellt",
    "loading": "Laden...",
    "notFound": "Nichts gefunden",
    "of": "von",
    "removedPredecessor": "{title} als Vorgänger entfernt",
    "removedSuccessor": "{title} als Nachfolger entfernt",
    "saveDiscardChanges": "Du hast ungespeicherte Änderungen, willst du diese speichern oder verwerfen?",
    "saveSuccess": "Deine Änderungen wurden erfolgreich gespeichert",
    "savingChanges": "Bitte warten, es wird gespeichert",
    "specialAssignmentText": "Ist ein abweichender Benutzer hinterlegt, ist die zuständige Funktion für das Element nicht mehr verantwortlich.",
    "willBeDeleted": "{action} wird gelöscht",
    "willSendEmail": "Wir senden Dir eine Email"
  },
  "milestone": {
    "addApprover": "Freigabeverantwortlichen hinzufügen",
    "addApproverHelp": "Wähle die hinzuzufügende freigebende Funktion aus.",
    "addMilestone": "Meilenstein erstellen",
    "approvers": "Freigabeverantwortliche",
    "cannotFindMilestone": "Der Meilenstein {milestoneId} existiert nicht",
    "cannotRemoveActivities": "Ein Meilenstein dem Eckpunkte zugeordnet sind kann nicht gelöscht werden",
    "cannotRemoveFinal": "Finale Meilensteine können nicht gelöscht werden",
    "completedMilestones": "Abgeschlossene Meilensteine",
    "confirmStatePlanned": "Der Meilenstein wird automatisch in den Status 'geplant' gesetzt",
    "confirmStateUnderway": "Die Phase wird automatisch in den Status 'in Bearbeitung' gesetzt",
    "deleteApprover": "Entferne Freigabeverantwortlichen",
    "deleteMilestone": "Meilenstein löschen",
    "description": "Beschreibung",
    "editMilestone": "Meilenstein bearbeiten",
    "editNotes": "Anmerkungen bearbeiten",
    "externalDate": {
      "label": "Externes Datum"
    },
    "focusTo": "Meilenstein fokussieren",
    "intermediate": "Zwieschenmeilenstein",
    "intermediateLabel": "(Zwischenmeilenstein)",
    "finalLabel": "(Finaler Meilenstein)",
    "milestone": "Meilenstein",
    "milestoneDescription": "Meilenstein Beschreibung",
    "milestoneTitle": "Meilenstein Titel",
    "nextMilestones": "Nächste Meilensteine",
    "newApprover": "Neuer Freigabeverantwortlicher",
    "notes": "Anmerkungen",
    "number": "Nummer",
    "optionalActivities": "Optionale Eckpunkte",
    "requiredActivities": "Erforderliche Eckpunkte",
    "manageActivities": "Beziehungen verwalten",
    "currentActivities": "Aktuelle Verknüpfungen",
    "activitiesToAdd": "Hinzuzufügende Verknüpfungen",
    "activitiesToRemove": "Zu entfernende Verknüpfungen",
    "availableActivities": "Verfügbare Eckpunkte",
    "noAvailableActivities": "Keine Verknüpfungen zum Hinzufügen verfügbar. Eckpunkte müssen in derselben Phase sein und vor diesem Meilenstein geplant werden.",
    "activitiesWithExistingAssociation": "Eckpunkte mit bestehender Verknüpfung",
    "showActivitiesWithAssociations": "Eckpunkte anzeigen, die bereits anderen Meilensteinen zugeordnet sind",
    "removeFromMilestoneWarning": "Dieser Eckpunkt ist derzeit dem Meilenstein \"{milestoneName}\" zugeordnet. Das Hinzufügen hier entfernt diese Zuordnung.",
    "unknownMilestone": "Unbekannter Meilenstein",
    "title": "Titel"
  },
  "mimeTypeOptions": {
    "directory-folder": "Verzeichnis / Ordner",
    "email": "Email",
    "generic": "Generisch",
    "pdf": "PDF",
    "spreadsheet": "Tabelle",
    "text-document": "Textdokument",
    "url": "URL"
  },
  "monthNames": {
    "january": "Januar",
    "february": "Februar",
    "march": "März",
    "april": "April",
    "may": "Mai",
    "june": "Juni",
    "july": "Juli",
    "august": "August",
    "september": "September",
    "october": "Oktober",
    "november": "November",
    "december": "Dezember"
  },
  "moveTaskModal": {
    "actionTitle": "Verschieben der Maßnahme in einen anderen Eckpunkt",
    "title": "Verschieben des Erfüllungskriteriums in einen anderen Eckpunkt",
    "description": "Nur gültige Ziel-Eckpunkte sind stehen zur Auswahl",
    "button": "Verschieben"
  },
  "msIntegration": {
    "exportDestination": "Export-Ziel",
    "exportToPlanner": "Microsoft Planner (Team-Zusammenarbeit)",
    "exportToTodo": "Microsoft Todo (Persönliche Aufgaben)"
  },
  "msPlannerIntegration": {
    "activityShort": "EP",
    "completionCriterionShort": "EK",
    "createExport": "Exportieren",
    "errorMessage": "Export fehlgeschlagen",
    "exportMode": "Export-Modus",
    "exportPhase": "Gesamte Phase exportieren",
    "exportSelected": "Ausgewählte Eckpunkte exportieren",
    "exportSelectedCount": "Ausgewählte Eckpunkte exportieren ({count})",
    "exportSelectedNone": "Ausgewählte Eckpunkte exportieren (keine ausgewählt)",
    "groupSelection": "Gruppe auswählen",
    "login": "Login mit Microsoft Account",
    "phaseSelection": "Phase auswählen",
    "plannerSelection": "Planner auswählen",
    "successMessage": "Erfolgreich exportiert",
    "title": "Microsoft Export",
    "includeCriteriaAsChecklist": "Erfüllungskriterien als Checklisten-Elemente einschließen",
    "includeCriteriaAsChecklistHint": "Erfüllungskriterien als Checklisten-Elemente innerhalb der Eckpunkt-Aufgaben hinzufügen, anstatt separate Aufgaben zu erstellen",
    "noPlannersFound": "Keine Planner-Pläne gefunden. Bitte erstellen Sie zuerst einen Plan in Microsoft Planner."
  },
  "msTodoIntegration": {
    "errorMessage": "Fehler beim Export zu Todo",
    "successMessage": "Erfolgreich zu Todo exportiert",
    "todoListSelection": "Todo-Liste auswählen",
    "noListsFound": "Keine Todo-Listen verfügbar",
    "noListsMessage": "Keine Todo-Listen gefunden. Bitte erstellen Sie zuerst mindestens eine Liste in Microsoft Todo.",
    "exportActivityTitle": "Eckpunkt zu Microsoft Todo exportieren",
    "exportActivitiesTitle": "Eckpunkte zu Microsoft Todo exportieren",
    "singleActivityExported": "Eckpunkt erfolgreich zu Todo exportiert",
    "activitiesExported": "{count} Eckpunkte erfolgreich zu Todo exportiert",
    "exportError": "Fehler beim Export der Eckpunkte zu Todo",
    "exportWithCriteria": "Erfüllungskriterien einschließen ({count} Einträge)",
    "exportWithCriteriaMultiple": "Erfüllungskriterien als Checklisten-Elemente einschließen",
    "andMore": "und {count} weitere",
    "exportTaskTitle": "Aufgabe zu Microsoft Todo exportieren",
    "taskExported": "Aufgabe erfolgreich zu Todo exportiert",
    "taskExportError": "Fehler beim Export der Aufgabe zu Todo",
    "includeCriteriaAsChecklist": "Erfüllungskriterien als Checklisten-Elemente einschließen",
    "includeCriteriaAsChecklistHint": "Erfüllungskriterien als Checklisten-Elemente innerhalb der Eckpunkt-Aufgaben hinzufügen, anstatt separate Aufgaben zu erstellen",
    "taskBodyActivity": "Beeboard Eckpunkt: {title}",
    "taskBodyAction": "Maßnahme aus Beeboard",
    "taskBodyCompletionCriterion": "Erfüllungskriterium aus Beeboard",
    "taskBodyActivityLabel": "Eckpunkt: {title}",
    "taskBodyViewInBeeboard": "In Beeboard ansehen: {url}",
    "taskBodyResponsible": "Verantwortlich: {name} ({email})",
    "taskBodyContext": "Kontext: {context}",
    "loadingLists": "Lade Todo-Listen..."
  },
  "msTodoImport": {
    "hideCompleted": "Erledigte ausblenden",
    "noTasks": "Keine Aufgaben in dieser Liste gefunden.",
    "loadingTasks": "Lade Aufgaben...",
    "loadTasksError": "Fehler beim Laden der Aufgaben aus Todo",
    "loginError": "Anmeldung fehlgeschlagen. Bitte versuche es erneut.",
    "importError": "Fehler beim Importieren der Aufgaben",
    "completionCriterionAdded": "Erfüllungskriterium erfolgreich hinzugefügt",
    "actionAdded": "Maßnahme erfolgreich hinzugefügt",
    "noActivityPermission": "Du hast keine Berechtigung, Eckpunkte in diesem Projekt zu erstellen.",
    "sidebarTitle": "Aufgaben importieren",
    "sourceTodo": "Todo",
    "sourcePlanner": "Planner",
    "sourceMeeting": "Besprechungen",
    "planSelection": "Planner-Plan auswählen",
    "noPlansFound": "Keine Planner-Pläne gefunden",
    "meetingSelection": "Besprechung auswählen",
    "noMeetingsFound": "Keine Besprechungen mit Zusammenfassungen gefunden",
    "loadMeetingTodosError": "Fehler beim Laden der Meeting-Aufgaben",
    "dragHint": "Ziehe eine Aufgabe auf die Karte, um einen Eckpunkt zu erstellen, oder auf einen Eckpunkt um ein EK oder eine Maßnahme zu erstellen.",
    "dropOutsideMap": "Bitte lege die Aufgabe auf einer gültigen Position auf der Karte ab.",
    "activityCreated": "Eckpunkt erfolgreich erstellt",
    "dropOnActivityTitle": "Zum Eckpunkt hinzufügen",
    "escToCancel": "ESC drücken zum Abbrechen",
    "responsibleMenuTitle": "Verantwortlichen zuweisen",
    "responsibleSkip": "Überspringen (kein Verantwortlicher)",
    "responsibleSuggested": "Vorgeschlagen",
    "responsibleFunctions": "Alle Funktionen",
    "responsibleMembers": "Alle Mitglieder",
    "sourceMail": "E-Mail",
    "phaseNotAllowed": "Sie können Aktivitäten nur in Phasen hinzufügen, für die Sie verantwortlich sind."
  },
  "notificationActions": {
    "addToProject": "{dispatcher} hat dich zum Projekt {entity} hinzugefügt",
    "projectResponsible": "{dispatcher} hat dich zum Projektverantwortlichen im Projekt {entity} ernannt",
    "activityApprovalRequested": "{dispatcher} hat deine Genehmigung für Eckpunkt {entity} angefordert",
    "milestoneApprovalRequested": "{dispatcher} hat deine Genehmigung für Meilenstein {entity} angefordert",
    "taskAssigned": "{dispatcher} hat dir eine Aufgabe für {entity} zugewiesen",
    "functionAssigned": "{dispatcher} hat dir die Funktion {entity} im Projekt {parentEntity} zugewiesen",
    "watchedDone": "Der Eckpunkt {entity}, zu dem du informiert werden sollst, ist erledigt",
    "meetingEnded": "{dispatcher} hat die Besprechung {entity} beendet",
    "activityToInProgressByTask": "{dispatcher} hat den Eckpunkt {entity} durch Änderung einer Aufgabe in den Status 'In Bearbeitung' gesetzt",
    "actionToDoneByActivity": "{dispatcher} hat die Maßnahme {entity} durch Änderung des zugehörigen Eckpunkts {parentEntity} auf 'Fertig' gesetzt",
    "completionCriterionToDoneByActivity": "{dispatcher} hat das Erfüllungskriterium {entity} durch Änderung des zugehörigen Eckpunkts {parentEntity} auf 'Fertig' gesetzt",
    "userMentionedInComment": "{dispatcher} hat dich in einem Kommentar bei {entity} erwähnt",
    "commentCreated": "{dispatcher} hat einen Kommentar zu {entity} erstellt",
    "activityAssigned": "{dispatcher} hat dir den Eckpunkt {entity} zugewiesen",
    "actionAssigned": "{dispatcher} hat dir die Maßnahme {entity} in Eckpunkt {parentEntity} zugewiesen",
    "completionCriterionAssigned": "{dispatcher} hat dir das Erfüllungskriterium {entity} in Eckpunkt {parentEntity} zugewiesen",
    "commentUpdated": "{dispatcher} hat einen Kommentar zu {entity} aktualisiert",
    "commentDeleted": "{dispatcher} hat einen Kommentar zu {entity} gelöscht",
    "projectMailReceived": "Neue Projekt-E-Mail: {entity}"
  },
  "notifications": {
    "empty": "Du hast keine Benachrichtungen",
    "markAllAsRead": "Alle als gelesen markieren",
    "markAsRead": "Als gelesen markieren",
    "newNotificationPopup": "Neue Benachrichtigung",
    "newNotifications": "Du hast neue Benachrichtigungen",
    "settings": "Einstellungen E-Mail Benachrichtigungen"
  },
  "projectUpdateFromTemplateModal": {
    "title": "Projekt aus Template aktualisieren",
    "selectTemplate": "Wähle das Template aus",
    "selectPhases": "Wähle die Phasen die du aktualisieren möchtest aus",
    "projectPhases": "Projekt-Phasen",
    "templatePhases": "Prozesslandkarten-Phasen",
    "finalMilestones": "Finale Meilensteine",
    "warningTitleActivities": "Die für den Austausch geplanten Projektphasen enthalten Eckpunkte, die entweder in Bearbeitung oder abgeschlossen sind.",
    "warningTitlePhases": "Die für den Austausch geplanten Projektphasen sind entweder in Bearbeitung oder abgeschlossen.",
    "projectWillBeUpdated": "Das Projekt wird aktualisiert",
    "projectWillBeUpdatedSubtitle": "Phasen und Eckpunkte, die für den Austausch geplant sind, werden ersetzt. Dieser Vorgang kann nicht rückgängig gemacht werden! Sind Sie sicher?"
  },
  "addWorkstreamFromTemplateModal": {
    "title": "Teilprozess aus Prozesslandkarte hinzufügen",
    "selectTemplate": "Wählen Sie die Prozesslandkarte aus, aus der Sie einen Teilprozess kopieren möchten",
    "selectWorkstream": "Wählen Sie den Teilprozess aus, den Sie zu Ihrem Projekt hinzufügen möchten",
    "availableWorkstreams": "Verfügbare Teilprozesse",
    "noWorkstreamsAvailable": "Keine Teilprozesse in dieser Vorlage verfügbar",
    "mappingWorkstream": "Teilprozess hinzufügen",
    "projectPhases": "Projekt-Phasen",
    "templatePhases": "Prozesslandkarten-Phasen",
    "dropTemplatePhases": "Prozesslandkarten-Phasen hier ablegen",
    "autoMap": "Automatisch zuordnen",
    "clearAll": "Alle löschen",
    "dragInstructions": "Ziehen Sie Prozesslandkarten-Phasen aus der rechten Spalte zu Projekt-Phasen auf der linken Seite, um Zuordnungen zu erstellen. Jede Projekt-Phase kann mehrere Prozesslandkarten-Phasen erhalten.",
    "workstreamOrder": "Reihenfolge",
    "phaseOrder": "Position"
  },
  "mirrorEntitiesIntoProject": {
    "title": "Spiegel {entity} in Projekt",
    "activities": "Eckpunkte",
    "milestones": "Meilensteine",
    "sourceProject": "Quellprojekt",
    "targetWorkstream": "Ziel Teilprozess",
    "projectGroup": "Projektgruppe",
    "otherProjects": "Andere Projekte",
    "sourceResponsibleFilter": "Filtern Durchführungsverantwortliche",
    "switchTabWarningTitle": "Aktuelle Auswahl verwerfen?",
    "switchTabWarningDescription": "Ihre aktuellen Auswahlen gehen verloren."
  },
  "personalDashboard": {
    "backToDashboardOverview": "Zurück zu Dashboard Überblick",
    "done": "Erledigt",
    "emptyTable": "Bitte stellen Sie sicher, dass Sie beeboard richtig verwenden.",
    "myProjects": "Meine Projekte",
    "myTasks": "Meine Aufgaben",
    "noProjects": "Keine Projekte gefunden",
    "noTasks": "Keine Aufgaben gefunden",
    "personalDashboard": "Persönliches Dashboard",
    "toDo": "Offen",
    "total": "Gesamt",
    "viewAll": "Alle ansehen",
    "viewModes": {
      "table": "Tabellenansicht",
      "kanban": "Kanban-Board"
    },
    "welcomeBack": "Willkommen zurück"
  },
  "phase": {
    "addPhase": "Phase hinzufügen",
    "deadline": "Fälligkeitsdatum",
    "deadlineChangeConfirm": "Einige Eckpunkte und Zwischenmeilensteine können die Phase wechseln. Ungeplante Elemente, die in eine geplante oder in Bearbeitung befindliche Phase wechseln, werden auf Geplant gesetzt.",
    "deadlineChangeConfirmTemplate": "Einige Eckpunkte und Zwischenmeilensteine können die Phase wechseln. Verbindungen zu Meilensteinen außerhalb der Phase werden automatisch entfernt.",
    "deadlineChangeTooltip": "Halte die 'SHIFT'-Taste gedrückt, um das Fälligkeitsdatum weiter zu verschieben",
    "positionChangeTooltip": "Halte die 'SHIFT'-Taste gedrückt, um den Eckpunkt weiter zu verschieben",
    "editPhase": "Phase bearbeiten",
    "messageCantChangePosition": "Die Position kann nicht verändert werden, weil bereits Eckpunkte der Phase zugeteilt wurden.",
    "phaseStatusWarning": "Die Phase wird automatisch in den Status 'in Bearbeitung' gesetzt",
    "phaseWillBeUpdated": "Phase wird aktualisiert",
    "position": "Position",
    "positionAtFirst": "am Anfang",
    "positionAtLast": "am Ende",
    "positionBefore": "vor {title}",
    "splitPhase": "Phase spalten",
    "title": "Titel",
    "milestoneTitle": "Meilenstein titel",
    "warnSplitMilestoneAsPhase": "Die Phase wird an Stelle des Zwischenmeilensteins gespalten und der Zwischenmeilenstein wird zum finalen Meilenstein. Wenn es Verbindungen von Eckpunkten zu Meilensteinen außerhalb der neuen Phase gibt, werden diese automatisch entfernt.",
    "warnSplitPhase": "Die Phase wird an der selektierten Position gespalten. Wenn es Verbindungen von Eckpunkten zu Meilensteinen außerhalb der neuen Phase gibt, werden diese automatisch entfernt."
  },
  "project": {
    "active": "Aktiv",
    "activePhase": "Aktive Phase",
    "address": "Adresse",
    "assignedToUser": "Benutzer zugewiesen",
    "blankProjectDescription": "",
    "blankProjectTitle": "Projekt ohne Vorlage",
    "createProject": "Projekt erstellen",
    "createProjectErrors": {
      "titleBlank": "Der Projekttitel darf nicht leer sein.",
      "creatorWithoutScope": "Zum Erstellen eines Projekts wird mindestens ein Bereich benötigt, in dem Projekte erstellt werden dürfen.",
      "firstPhaseTooShort": "Die erste Phase muss mindestens 2 Tage nach dem Projektstart enden.",
      "scopesNotOfResponsible": "Der Projektverantwortliche muss Zugriff auf alle ausgewählten Bereiche haben.",
      "scopesNotOfCreator": "Es können nur Bereiche ausgewählt werden, in denen Projekte erstellt werden dürfen.",
      "scopesNotOfTemplate": "Die ausgewählten Bereiche müssen zur Prozesslandkarte gehören.",
      "phasesNotScheduled": "Jede Phase braucht ein Datum für ihren finalen Meilenstein und muss mindestens 2 Tage lang sein."
    },
    "dueDate": "Fälligkeitsdatum",
    "editProject": "Projekt bearbeiten",
    "copyProject": "Projekt kopieren",
    "copyOfProject": "Kopie von {project}",
    "projectCopySuccess": "Projekt {originalProjectTitle} wurde erfolgreich kopiert als {copiedProjectTitle}.",
    "projectTitle": "Projekttitel",
    "endOfFirstPhase": "Ende der ersten Phase",
    "exportExcel": "Export aller Eckpunkte",
    "exportExcelSuccess": "Excel-Datei erfolgreich exportiert",
    "exportExcelError": "Fehler beim Exportieren der Excel-Datei",
    "viewTranscripts": "Meeting-Transkripte ansehen",
    "transcript": {
      "selectMeetingTranscript": "Meeting-Transkript auswählen",
      "connectToTeams": "Mit Microsoft Teams verbinden",
      "connectDescription": "Verbinden Sie sich mit Microsoft Teams, um auf Meeting-Transkripte zuzugreifen. Sie müssen Berechtigungen zum Lesen von Online-Meetings und Transkripten erteilen.",
      "selectMeeting": "Meeting auswählen",
      "selectTranscript": "Transkript auswählen",
      "selectedMeeting": "Ausgewähltes Meeting",
      "participants": "Eingeladene Teilnehmer",
      "organizer": "Organisator",
      "coorganizer": "Co-Organisator",
      "loadTranscript": "Transkript laden",
      "cancel": "Abbrechen",
      "showOnlyMyMeetings": "Nur mit zugänglichem Transkript",
      "loadingMeetings": "Lade Meetings...",
      "loadingTranscripts": "Lade Transkripte...",
      "noMeetingsFound": "Keine Meetings gefunden",
      "noTranscriptsAvailable": "Keine Transkripte für dieses Meeting verfügbar",
      "transcriptTitle": "Transkript: {subject}",
      "speakers": "Sprecher",
      "entries": "Einträge",
      "stats": "Statistik",
      "aiSettings": "KI-Einstellungen",
      "aiSummary": "KI-Zusammenfassung",
      "copy": "Kopieren",
      "close": "Schließen",
      "searchTranscript": "Transkript durchsuchen...",
      "groupBySpeaker": "Nach Sprecher gruppieren",
      "noResultsFound": "Keine Ergebnisse für \"{query}\" gefunden",
      "noTranscriptEntries": "Keine Transkripteinträge gefunden",
      "copiedToClipboard": "In Zwischenablage kopiert",
      "copyFailed": "Kopieren in die Zwischenablage fehlgeschlagen",
      "summaryError": "Unbekannter Fehler beim Abrufen der Zusammenfassung.",
      "meetingTranscripts": "Meeting-Transkripte",
      "meetingSummaries": "Meeting-Zusammenfassungen",
      "pageDescription": "Erstelle aus aufgezeichneten Meeting-Transkripten automatisch KI-generierte Zusammenfassungen und extrahiere Aufgaben.",
      "selectTranscriptToView": "Transkript zum Anzeigen auswählen",
      "selectTranscriptHint": "Wählen Sie links ein Meeting und ein Transkript aus, um es hier anzuzeigen",
      "loadingTranscript": "Lade Transkript...",
      "uploadVtt": "VTT-Datei hochladen",
      "uploadVttDescription": "Laden Sie eine VTT-Transkriptdatei von Ihrem Computer hoch",
      "uploadVttButton": "VTT-Datei auswählen",
      "uploadVttDragDrop": "Ziehen Sie eine VTT-Datei hierher oder klicken Sie, um sie auszuwählen",
      "uploadVttError": "Fehler beim Hochladen der VTT-Datei",
      "uploadVttInvalidFormat": "Ungültiges VTT-Dateiformat. Bitte laden Sie eine gültige WebVTT-Datei hoch.",
      "uploadVttInvalidExtension": "Ungültiges Dateiformat. Bitte laden Sie eine .vtt-Datei hoch.",
      "noTranscriptsForSelectedMeetings": "Keine Transkripte für ausgewählte Meetings gefunden",
      "uploadVttSuccess": "VTT-Datei erfolgreich hochgeladen",
      "manualUploadTitle": "Manueller Upload",
      "manualTranscriptTitle": "Hochgeladenes Transkript",
      "backToTeamsMeetings": "Zurück zu Teams-Meetings",
      "backToMeetings": "Zurück zu Meetings",
      "backToTranscripts": "Zurück zu Transkripten",
      "savedSummaries": "Gespeicherte Zusammenfassungen",
      "loadingSummaries": "Lade Zusammenfassungen...",
      "noSavedSummaries": "Noch keine gespeicherten Zusammenfassungen",
      "noSavedSummariesHint": "Erstelle eine Zusammenfassung aus einem Meeting-Transkript um sie hier zu sehen",
      "task": "Aufgabe",
      "tasks": "Aufgaben",
      "batchMode": "Hintergrundverarbeitung",
      "processSelected": "{count} ausgewählt",
      "processMeetings": "Verarbeiten",
      "saveToProject": "In Projekt speichern",
      "projectOptional": "Optional",
      "processingMeetings": "{processed} von {total} Meetings werden verarbeitet",
      "cancelJob": "Abbrechen",
      "jobInProgress": "Ein Auftrag läuft gerade",
      "jobCancelled": "Auftrag abgebrochen",
      "pending": "Wird verarbeitet...",
      "checkingForTranscripts": "Prüfe auf Transkripte...",
      "transcriptAvailable": "Transkript verfügbar",
      "noTranscriptAvailable": "Kein Transkript verfügbar",
      "noAccessToTranscripts": "Kein Zugriff auf dieses Meeting",
      "authenticatedAs": "Angemeldet als",
      "reauthenticate": "Erneut anmelden",
      "authRequiredForBatch": "Microsoft-Authentifizierung ist für die Hintergrundverarbeitung erforderlich",
      "authenticateWithMicrosoft": "Mit Microsoft anmelden",
      "reasoningEffort": "Reasoning-Intensität",
      "reasoningEffortLow": "Niedrig (Schnell)",
      "reasoningEffortMedium": "Mittel (Besser)",
      "useStreaming": "Live-Vorschau",
      "generatingContent": "Inhalt wird generiert...",
      "generatingSummary": "KI-Zusammenfassung wird erstellt...",
      "generationTimeWarning": "Dies kann je nach Modell, Reasoning-Intensität und Transkriptlänge bis zu mehrere Minuten dauern.",
      "saveToHistory": "Im Verlauf speichern",
      "savedToHistory": "Im Verlauf gespeichert",
      "saveToHistoryError": "Fehler beim Speichern im Verlauf. Bitte versuchen Sie es erneut.",
      "summaryAlreadyExistsError": "Für dieses Meeting existiert bereits eine Zusammenfassung im Verlauf. Löschen Sie die vorhandene zuerst, um eine neue zu speichern.",
      "sendEmail": "Per E-Mail senden",
      "sendToChat": "In Meeting-Chat senden",
      "extractedTasks": "Extrahierte Aufgaben",
      "exportTasksToTodo": "Aufgaben zu Microsoft To Do exportieren",
      "exportTasksDescription": "{count} extrahierte Aufgaben zu Microsoft To Do exportieren",
      "noTasksSelected": "Keine Aufgaben ausgewählt",
      "customSummary": {
        "button": "Benutzerdefinierte KI-Zusammenfassung",
        "title": "Benutzerdefinierte KI-Zusammenfassung",
        "description": "Geben Sie Anweisungen zur Struktur und Formatierung des Meeting-Protokolls. Die KI erstellt das Protokoll basierend auf dem Transkript.",
        "placeholder": "Beschreiben Sie die gewünschte Struktur, z.B. \"Überschriften: Themen, Beschlüsse, Aufgaben. Tabelle für Aufgaben mit Spalten: Aufgabe, Verantwortlich, Termin.\"",
        "examplesLabel": "Beispiele:",
        "example1": "Überschriften: Themen, Beschlüsse, Aufgaben, Nächste Schritte",
        "example2": "Stichpunkte für Diskussionspunkte, Tabelle für Aufgaben",
        "example3": "Kurze Zusammenfassung (max 5 Sätze), dann Liste der offenen Punkte",
        "generate": "Generieren",
        "savedPrompts": "Gespeicherte Vorlagen",
        "loadingPrompts": "Vorlagen werden geladen...",
        "noSavedPrompts": "Noch keine gespeicherten Vorlagen",
        "selectPrompt": "Gespeicherte Vorlage auswählen",
        "newPrompt": "Neue Vorlage",
        "promptName": "Vorlagenname",
        "promptNamePlaceholder": "z.B. Wöchentliches Team-Meeting Protokoll",
        "savePrompt": "Vorlage speichern",
        "updatePrompt": "Vorlage aktualisieren",
        "copyPrompt": "Kopieren",
        "deletePrompt": "Löschen",
        "editPrompt": "Bearbeiten",
        "confirmDelete": "Möchten Sie diese Vorlage wirklich löschen?",
        "promptSaved": "Vorlage erfolgreich gespeichert",
        "promptUpdated": "Vorlage erfolgreich aktualisiert",
        "promptCopied": "Vorlage erfolgreich kopiert",
        "promptDeleted": "Vorlage erfolgreich gelöscht",
        "promptError": "Fehler beim Speichern der Vorlage",
        "promptNameRequired": "Bitte geben Sie einen Namen für die Vorlage ein",
        "useWithoutSaving": "Ohne Speichern verwenden"
      },
      "email": {
        "composeEmail": "E-Mail verfassen",
        "loginRequired": "Bitte melden Sie sich mit Ihrem Microsoft-Konto an, um E-Mails zu senden",
        "loginToSend": "Anmelden zum E-Mail senden",
        "recipients": "Empfänger",
        "recipientsPlaceholder": "email1{'@'}example.com, email2{'@'}example.com",
        "recipientsHint": "Trennen Sie mehrere E-Mail-Adressen durch Kommas",
        "subject": "Betreff",
        "subjectPlaceholder": "E-Mail-Betreff",
        "body": "E-Mail-Text",
        "bodyPlaceholder": "Schreiben Sie hier Ihren E-Mail-Inhalt...",
        "preview": "Vorschau",
        "send": "E-Mail senden",
        "sending": "Wird gesendet...",
        "noRecipients": "Bitte geben Sie mindestens einen Empfänger ein",
        "sendError": "E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
        "summarySubject": "Meeting-Zusammenfassung",
        "defaultSubject": "KI-generierte Meeting-Zusammenfassung"
      },
      "chat": {
        "composeMessage": "Chat-Nachricht verfassen",
        "sendToMeetingChat": "Diese Nachricht wird in den Meeting-Chat gesendet",
        "message": "Nachricht",
        "send": "In Chat senden",
        "sendSuccess": "Nachricht erfolgreich in Chat gesendet",
        "sendError": "Nachricht konnte nicht in Chat gesendet werden. Bitte versuchen Sie es erneut.",
        "noChatId": "Keine Chat-ID für dieses Meeting verfügbar",
        "noContent": "Bitte geben Sie eine Nachricht ein"
      },
      "export": {
        "title": "Aufgaben zu Beeboard-Projekt exportieren",
        "selectProject": "Projekt auswählen",
        "selectProjectPlaceholder": "Wählen Sie ein Projekt aus, in das die Aufgaben exportiert werden sollen",
        "configureTasks": "Aufgaben konfigurieren",
        "exportAs": "Exportieren als",
        "activity": "Eckpunkt",
        "completionCriterion": "Erfüllungskriterium",
        "dueDate": "Fälligkeitsdatum",
        "optionalDueDate": "Optionales Fälligkeitsdatum",
        "parentActivity": "Übergeordneter Eckpunkt",
        "selectParentActivity": "Übergeordneten Eckpunkt auswählen",
        "exportToBeeboard": "Beeboard Export",
        "importToBeeboard": "Aufgaben in Projekt importieren",
        "successMessage": "Aufgaben erfolgreich zu Beeboard-Projekt exportiert",
        "errorMessage": "Fehler beim Exportieren der Aufgaben zu Beeboard. Bitte versuchen Sie es erneut.",
        "errorLoadingProject": "Fehler beim Laden der Projektdetails. Bitte versuchen Sie es erneut.",
        "activityDescription": "Erstellt aus Meeting: {meeting}\nVerantwortliche Person aus Meeting: {responsible}",
        "criterionDescription": "Erstellt aus Meeting: {meeting}\nVerantwortliche Person aus Meeting: {responsible}",
        "noPermissionForActivity": "Sie haben keine Berechtigung, Eckpunkte in diesem Projekt zu erstellen",
        "noPermissionForCriterion": "Sie haben keine Berechtigung, Kriterien für diesen Eckpunkt zu erstellen",
        "phaseDoneError": "Eckpunkt kann nicht erstellt werden - die Zielphase ist als abgeschlossen markiert",
        "activityDoneError": "Kriterium kann nicht erstellt werden - der übergeordnete Eckpunkt ist als abgeschlossen markiert",
        "noValidPhase": "Keine gültige Phase in diesem Projekt verfügbar",
        "noValidActivities": "Keine Eckpunkte verfügbar, für die Sie Erfüllungskriterien erstellen können",
        "noProjectsAvailable": "Keine Projekte, in denen Sie die Berechtigung haben, Eckpunkte oder Kriterien zu erstellen",
        "exportSummary": "{success} Aufgabe(n) erfolgreich exportiert, {failed} fehlgeschlagen"
      },
      "meetingSummary": {
        "title": "Meeting-Zusammenfassungen",
        "description": "KI-gestützte Meeting-Zusammenfassungen im Hintergrund verarbeitet",
        "selectMeetings": "Meetings zum Zusammenfassen auswählen",
        "selectMeetingsDescription": "Wählen Sie Meetings mit Transkripten aus, um KI-Zusammenfassungen zu erstellen",
        "selectedCount": "{count} Meeting(s) ausgewählt",
        "noMeetingsSelected": "Keine Meetings ausgewählt",
        "startProcessing": "Verarbeitung starten",
        "processing": "Verarbeitung läuft...",
        "processingMeetings": "{processed} von {total} Meetings verarbeitet",
        "jobCreated": "Zusammenfassungsauftrag erfolgreich erstellt",
        "jobFailed": "Zusammenfassungsauftrag konnte nicht erstellt werden",
        "jobCompleted": "Alle Meetings wurden verarbeitet",
        "jobCancelled": "Verarbeitungsauftrag wurde abgebrochen",
        "jobInProgress": "Ein Auftrag läuft gerade",
        "cancelJob": "Abbrechen",
        "pending": "Wird verarbeitet...",
        "viewSummaries": "Zusammenfassungen anzeigen",
        "noSummaries": "Noch keine Meeting-Zusammenfassungen",
        "noSummariesHint": "Wählen Sie Meetings mit Transkripten aus und starten Sie die Verarbeitung, um KI-Zusammenfassungen zu erstellen",
        "summaryDate": "Meeting-Datum",
        "summaryCreated": "Erstellt",
        "summarySubject": "Betreff",
        "summaryParticipants": "Teilnehmer",
        "authRequired": "Hintergrundverarbeitung aktivieren, um KI-Zusammenfassungen zu erstellen",
        "authenticateWithMicrosoft": "Hintergrundverarbeitung aktivieren",
        "authenticatedAs": "Hintergrundverarbeitung aktiviert für {email}",
        "reauthenticate": "Erneut autorisieren",
        "deleteSummary": "Zusammenfassung löschen",
        "deleteSummaryConfirm": "Sind Sie sicher, dass Sie diese Besprechungszusammenfassung zusammen mit den verknüpften Entitätsreferenzen löschen möchten? Dies kann nicht rückgängig gemacht werden.",
        "summaryDeleted": "Zusammenfassung erfolgreich gelöscht",
        "hasSavedSummary": "Dieses Meeting hat eine gespeicherte Zusammenfassung",
        "alreadyHasSummary": "Für dieses Transkript existiert bereits eine Zusammenfassung",
        "summaryExists": "Zusammenfassung vorhanden",
        "summaryTitle": "Zusammenfassung",
        "editHint": "Bearbeiten Sie den HTML-Inhalt der Zusammenfassung. Änderungen werden gespeichert, wenn Sie auf Speichern klicken.",
        "editSummary": "Zusammenfassung bearbeiten",
        "copySummary": "Zusammenfassung kopieren",
        "todos": {
          "title": "Meeting-Aufgaben",
          "description": "Aus Ihren Meetings extrahierte Aufgaben",
          "noTodos": "Noch keine Aufgaben",
          "noTodosHint": "Aufgaben werden hier angezeigt, nachdem Meetings verarbeitet wurden",
          "pending": "Ausstehend",
          "completed": "Erledigt",
          "dismissed": "Verworfen",
          "markComplete": "Als erledigt markieren",
          "markDismissed": "Verwerfen",
          "reopen": "Wieder öffnen",
          "deleteTodo": "Aufgabe löschen",
          "deleteTodoConfirm": "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
          "todoDeleted": "Aufgabe erfolgreich gelöscht",
          "assignee": "Zuständig",
          "dueDate": "Fälligkeitsdatum",
          "fromMeeting": "Aus Meeting",
          "statusUpdated": "Aufgabenstatus aktualisiert",
          "unassigned": "Nicht zugewiesen",
          "addTask": "Aufgabe hinzufügen",
          "newTaskPlaceholder": "Aufgabentitel eingeben...",
          "descriptionLabel": "Beschreibung",
          "showMore": "Mehr anzeigen",
          "showLess": "Weniger anzeigen"
        },
        "jobs": {
          "title": "Verarbeitungsaufträge",
          "description": "Hintergrundaufträge für die Meeting-Zusammenfassungserstellung",
          "noJobs": "Keine Verarbeitungsaufträge",
          "status": {
            "pending": "Ausstehend",
            "running": "Läuft",
            "completed": "Abgeschlossen",
            "failed": "Fehlgeschlagen",
            "cancelled": "Abgebrochen"
          },
          "progress": "{processed} von {total} Meetings verarbeitet",
          "startedAt": "Gestartet",
          "completedAt": "Abgeschlossen",
          "viewJob": "Details anzeigen",
          "cancelJob": "Auftrag abbrechen"
        },
        "errors": {
          "loadFailed": "Meeting-Zusammenfassungen konnten nicht geladen werden",
          "processingFailed": "Meetings konnten nicht verarbeitet werden",
          "noRefreshToken": "Authentifizierung erforderlich. Bitte verbinden Sie sich erneut mit Microsoft Teams.",
          "noMeetingsWithTranscripts": "Keine Meetings mit Transkripten verfügbar"
        }
      },
      "askAi": {
        "title": "KI zu diesem Meeting befragen",
        "emptyState": "Stelle eine Frage zu dem, was in diesem Meeting gesagt wurde. Die Antworten basieren auf dem Transkript – mit Belegen zum Nachlesen.",
        "placeholder": "z. B. Was haben wir zur Deadline entschieden?",
        "send": "Fragen",
        "clear": "Chat löschen",
        "clearConfirmTitle": "Chat löschen?",
        "clearConfirmSubtitle": "Die Fragen und Antworten zu diesem Meeting werden endgültig gelöscht. Die Meeting-Zusammenfassung und das Transkript bleiben unberührt.",
        "sources": "Belege ({count})",
        "tab": "KI fragen"
      }
    },
    "exportOptions": "Export-Optionen",
    "includeDocuments": "Dokumente einschließen",
    "includeDocumentsHint": "Eckpunkt-Dokumente mit ihren URLs zum Export hinzufügen",
    "updateFromTemplate": "Aus Template aktualisieren",
    "addWorkstreamFromTemplate": "Teilprozess aus Template hinzufügen",
    "favorites": "Favoriten",
    "fillInTheDataSubtitle": "Daten ausfüllen und Projekt starten - *Pflichtfelder",
    "fromTemplate": "Von Vorlage {template}",
    "goToProject": "Projekt öffnen",
    "imageUrl": "Bild-URL",
    "image": {
      "image": "Bild",
      "upload": "Datei hochladen",
      "uploadError": "Fehler beim Hochladen des Projektbilds",
      "invalidType": "Ungültiger Dateityp. Erlaubt: JPEG, PNG, WebP, GIF",
      "clickToUpload": "Klicken Sie, um ein neues Bild hochzuladen"
    },
    "documentsPath": "Projekt-Dokumentenpfad",
    "newProject": "Neues Projekt",
    "isActive": "Projekt ist aktiv",
    "isActiveState": "Aktivitätsstatus",
    "isNotActive": "Projekt ist inaktiv",
    "calendarSync": {
      "label": "Mit Outlook-Kalender synchronisieren",
      "enabledHint": "Projektelemente werden in Outlook abgebildet",
      "disabledHint": "Outlook-Kalender wird nicht synchronisiert",
      "notConfigured": "Die Kalendersynchronisation ist für Ihre Organisation nicht aktiviert — bitte wenden Sie sich an Ihre Administration."
    },
    "nonWorkingDays": {
      "title": "Zusätzliche freie Tage",
      "add": "Freie Tage hinzufügen",
      "startDate": "Von",
      "endDate": "Bis",
      "label": "Grund",
      "labelPlaceholder": "z. B. Betriebsruhe",
      "errorDatesRequired": "Bitte Start- und Enddatum auswählen.",
      "errorEndBeforeStart": "Das Enddatum darf nicht vor dem Startdatum liegen.",
      "errorLabelRequired": "Bitte einen Grund angeben."
    },
    "showNotActive": "Inaktive Projekte",
    "members": "Mitglieder",
    "noLinksAndToolsAdded": "Kein Link vorhanden",
    "noProjectDocumentsAdded": "Kein Projekt-Dokument vorhanden",
    "none": "Keine",
    "number": "Projektnummer",
    "openToCreateYourFirstDocument": "Öffnen zum Erstellen des ersten Projekt-Dokumentes",
    "openToLinkYourFirstLinkAndTool": "Öffnen zum Erstellen des ersten Link",
    "parentProject": "Übergeordnetes Projekt",
    "participating": "Projektmitglied",
    "pleaseTypeInProjectName": "Bitte gib den Projektnamen ein",
    "projectCalculateMilestones": "Berechne Meilensteintermine basierend auf dem Template",
    "includeIntermediateMilestones": "Zwischenmeilensteine einbeziehen",
    "milestoneDateErrors": {
      "afterProjectStart": "Mindestens {days} Tage nach dem Projektstart (frühestens {date})",
      "afterPreviousPhase": "Mindestens {days} Tage nach dem finalen Meilenstein der vorherigen Phase (frühestens {date})",
      "afterPreviousMilestone": "Mindestens {days} Tage nach dem vorherigen Meilenstein dieser Phase (frühestens {date})"
    },
    "projectCreatedTitle": "Projekt erfolgreich erstellt",
    "projectDetailsAndMandatory": "Projektdetails / *erforderliche Eingaben",
    "projectListOverview": "Projekte",
    "projectNumber": "Projektnummer",
    "projectOutdated": "Projekt Veraltet, zum Aktualisieren klicken",
    "projectResponsible": "Projektverantwortlicher",
    "projectWillBeDeleted": "Project will be deleted",
    "projectWillBeDeletedSubtitle": "This project will be deleted. This action cannot be undone! Are you sure?",
    "recommended": "Empfohlen",
    "replaceByFunction": "Durch Funktion ersetzen",
    "replaceByFunctionAlertSubtitle": "Diese Aktion kann nicht rückgängig gemacht werden. Wenn Sie die Funktion später wieder haben möchten, müssen Sie dieser Funktion wieder alles manuell zuweisen. Sind Sie sicher, dass Sie fortfahren möchten?",
    "replaceByFunctionAlertTitle": "Die Funktion {functionName} wird ersetzt durch {replacement}",
    "replaceByFunctionSubtitle": "Diese Aktion wird verwendet, um eine Funktion durch eine andere zu ersetzen. Alle Verantwortlichkeiten und Aufgaben der alten Funktion werden der neuen Funktion übertragen. Die alte Funktion wird gelöscht.",
    "replaceByFunctionUndoableAlertSubtitle": "Alle Verantwortlichkeiten gehen auf die neue Funktion über, die alte Funktion wird gelöscht. Solange dies die letzte Änderung im Projekt ist, können Sie sie in der Historie rückgängig machen.",
    "replaceByLibraryActivitySubtitle": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "responsible": "Projektverantwortlicher",
    "responsibleShort": "Verantwortlich",
    "scope": "Bereiche",
    "selectFromTemplateDescription": "",
    "selectFromTemplateTitle": "Projekt aus Prozesslandkarte",
    "selectResponsibleFirst": "Zuerst Projektverantwortlichen auswählen",
    "selectTemplateStateSubtitle": "Wählen sie zwischen einem Projekt ohne und mit Prozesslandkarte aus.",
    "selectTemplateSubtitle": "Wählen Sie die gewünschte Prozesslandkarte aus",
    "setMilestones": "Bitte lege das Datum für alle finalen Meilensteine fest",
    "shareLink": "Link teilen:",
    "startDate": "Projektstart",
    "template": "Prozesslandkarte",
    "title": "Titel",
    "updatedAt": "Zuletzt geändert",
    "updatedAtShort": "Geändert",
    "createdAt": "Erstellt am",
    "volume": "Projektvolumen",
    "xxx": "Placeholder"
  },
  "projectOverview": {
    "title": "Projektdashboard",
    "backToProjectOverview": "Zurück zum Projektdashboard",
    "projectStats": {
      "ccTarget": "Soll",
      "ccCompleted": "Erledigte Erfüllungskriterien",
      "completedActivities": "Erledigte Eckpunkte",
      "daysUntilNextMilestone": "Tage bis zum nächsten Meilenstein"
    },
    "projectDetails": {
      "title": "Projektdetails",
      "currentPhase": "Aktuelle Phase",
      "currentPhaseFallback": "Das Projekt ist abgeschlossen",
      "projectCode": "Projektnummer",
      "responsible": "Projektverantwortlicher",
      "volume": "Projektvolumen",
      "startDate": "Startdatum",
      "endDate": "Enddatum",
      "templateMapLinkTitle": "Zur Prozesslandkarte",
      "projectMapLinkTitle": "Zur Projektlandkarte"
    },
    "activityListTitle": "Nächste Eckpunkte",
    "milestonesListTitle": "Nächste Meilensteine",
    "historyListTitle": "Letzte Änderungen",
    "MeetingListTitle": "Besprechungen",
    "ViewAllLinkTitle": "Alle ansehen"
  },
  "projectList": {
    "action": "Maßnahme",
    "activity": "Eckpunkt",
    "backToListView": "Zurück zur Listenansicht",
    "cc": "Erfüllungskriterium",
    "dueDate": "Fälligkeitsdatum",
    "favorite": "Favorit",
    "favoriteYes": "Ja",
    "favoriteNo": "Nein",
    "finalMilestone": "Finaler Meilenstein",
    "intermediateMilestone": "Zwischenmeilenstein",
    "listView": "Listenansicht",
    "mirroredActivity": "Gespiegelter Eckpunkt",
    "showOnlyMilestones": "Meilensteine",
    "showOnlyNotFinished": "Nicht abgeschlossen",
    "showOnlyOwn": "Mir zugewiesen",
    "noResponsible": "Kein Durchführungsverantwortlicher",
    "noUser": "Kein Benutzer",
    "phase": "Phase",
    "phaseView": "Phasenansicht",
    "project": "Projekt",
    "responsible": "Durchführungsverantwortlicher",
    "status": "Status",
    "statusIndicator": "Statusfarbe",
    "title": "Titel",
    "type": "Typ",
    "user": "Benutzer",
    "views": "Ansichten",
    "workstream": "Teilprozess",
    "workstreamView": "Teilprozessansicht"
  },
  "projectMembers": {
    "addUsers": "Benutzer hinzufügen",
    "addUsersSubtitle": "Wähle im Dropdown aus welche Benutzer du dem Projekt hinzufügen möchtest.",
    "createUser": "Benutzer erstellen",
    "editor": "Editor",
    "editUser": "Benutzer editieren",
    "externalUser": "Benutzer extern",
    "grantEditorRights": "Editorenrechte gewähren",
    "internalUser": "Benutzer intern",
    "lastName": "Nachnamen",
    "member": "Teilnehmer",
    "name": "Name",
    "owner": "Besitzer",
    "removeEditorRights": "Editorenrechte entfernen",
    "removeUser": "Benutzer entfernen",
    "removeUserSubtitle": "Die Person die dem Projekt zugewiesen ist, wird den Zugriff auf das Projekt verlieren. Willst du wirklich fortfahren?",
    "leaveProject": "Projekt verlassen",
    "leaveProjectSubtitle": "Du wirst den Zugriff auf dieses Projekt verlieren. Willst du wirklich fortfahren?",
    "ssoUser": "Benutzer SSO",
    "user": "Benutzer",
    "users": "Benutzer",
    "usersCounted": "kein Benutzer | {n} Benutzer | {n} Benutzer",
    "userType": "Typ"
  },
  "projectMeetings": {
    "active": "Aktiv",
    "attendees": "Teilnehmer",
    "changes": "Änderungen",
    "date": "Datum",
    "deleteMeeting": "Besprechung löschen",
    "detailMeeting": "Besprechungsdetails",
    "detailsAndTasks": "Details & Aufgaben",
    "endMeeting": "Besprechung beenden",
    "ended": "Beendet",
    "endedAt": "Beendet um",
    "meeting": "Besprechung",
    "meetingDeletedSuccessfully": "Besprechung erfolgreich gelöscht",
    "meetingEnded": "Ende",
    "meetingFor": "Besprechung",
    "meetingInProgress": "Besprechung läuft",
    "meetingNotes": "Notizen Besprechung",
    "meetingStartedSuccessfully": "Besprechung erfolgreich gestartet",
    "meetingTitle": "Titel",
    "meetingUpdatedSuccessfully": "Besprechung erfolgreich aktualisiert",
    "meetings": "Besprechungen",
    "noAttendees": "Keine Teilnehmer",
    "noChanges": "Keine Änderungen für diese Besprechung aufgezeichnet",
    "noMeetings": "Noch keine Besprechungen",
    "noSummary": "Keine Zusammenfassung für diese Besprechung verfügbar",
    "otherAttendees": "Andere Teilnehmer",
    "otherAttendeesPlaceholder": "Gib die Teilnehmer durch ein Komma separiert ein",
    "selectMeeting": "Wählen Sie eine Besprechung aus, um Details anzuzeigen",
    "startMeeting": "Besprechung starten",
    "startedAt": "Gestartet um",
    "status": "Status",
    "summary": "Zusammenfassung",
    "summaryIsAttachedToTheMeeting": "Zusammenfassung ist der Besprechung beigefügt",
    "timeDuration": "Zeit & Dauer",
    "viewFullSummaryAndTasks": "Vollständige Zusammenfassung & Aufgaben anzeigen",
    "entityMatching": {
      "matchToProject": "Mit Projekt verknüpfen",
      "match": "Verknüpfen",
      "reviewTitle": "KI-Entitätsabgleich",
      "reviewSubtitle": "KI-vorgeschlagene Verknüpfungen zwischen Zusammenfassungsinhalt und Projektentitäten prüfen und bearbeiten.",
      "description": "Beschreibung",
      "selected": "{count} von {total} ausgewählt",
      "saveSelected": "Auswahl speichern",
      "savedSuccessfully": "Besprechungsreferenzen gespeichert",
      "entityReferences": "Besprechungsreferenzen",
      "noMatchesFound": "Keine passenden Besprechungsreferenzen in dieser Zusammenfassung gefunden",
      "aiProcessing": "KI analysiert die Zusammenfassung...",
      "quote": "Zitat",
      "overrideWarning": "Dies ersetzt alle vorhandenen Besprechungsreferenzen",
      "cancelConfirmTitle": "KI-Abgleich abbrechen?",
      "cancelConfirmSubtitle": "Die KI verarbeitet noch. Wenn Sie jetzt schließen, gehen die Ergebnisse verloren.",
      "cancelConfirmAction": "Ja, schließen"
    }
  },
  "projectReports": {
    "projectReporting": "Projektreporting",
    "title": "Titel",
    "status": "Status",
    "passedDues": "Überfällig",
    "phase": "Phase",
    "owner": "Projektverantwortlicher",
    "start": "Start",
    "end": "Ende",
    "number": "Nummer",
    "totalVolume": "Gesamtvolumen",
    "projectsCount": "{count} Projekt in diesen Bereichen | {count} Projekte in diesen Bereichen",
    "projectsTotal": "Projekt | Projekte",
    "milestones": "Meilenstein | Meilensteine",
    "activities": "Eckpunkt | Eckpunkte",
    "actions": "Maßnahme | Maßnahmen",
    "completionCriteria": "Erfüllungskriterien",
    "completionCriteriaShort": "EK",
    "legend": "Legende",
    "statusDetails": "Status-Details",
    "elementOverview": "Fortschritt",
    "criticalTasks": "Details",
    "clickToExpand": "Klicken Sie für Details",
    "clickToCollapse": "Klicken Sie zum Ausblenden",
    "healthCritical": "Kritisch",
    "healthOnTrack": "Im Plan",
    "sortByHealth": "Status",
    "sortByName": "Name",
    "sortByStart": "Startdatum",
    "sortByEnd": "Enddatum",
    "allStatuses": "Alle",
    "criticalIssues": "roter Status | rote Status",
    "warnings": "gelber Status | gelbe Status",
    "overdueItems": "überfälliges Element | überfällige Elemente",
    "onTrack": "Im Plan",
    "noProjectsFound": "Keine Projekte entsprechen Ihren Filtern",
    "subProjects": "Unterprojekt | Unterprojekte",
    "issuesByType": "Probleme nach Typ",
    "type": "Typ",
    "overdue": "Überfällig",
    "goToProject": "Zum Projekt",
    "inactive": "Inaktiv",
    "viewClassic": "Klassisch",
    "viewCards": "Neu",
    "viewDetailed": "Detailliert",
    "viewCompact": "Kompakt",
    "beta": "Beta",
    "nextMilestone": "Nächster Meilenstein",
    "nextActivity": "Nächster Eckpunkt",
    "maxDaysOverdue": "max. {count} Tag überfällig | max. {count} Tage überfällig",
    "healthAtRisk": "Gefährdet",
    "sortByOverdue": "Tage überfällig",
    "progressDone": "Erledigt",
    "progressInProgress": "In Bearbeitung",
    "progressNotStarted": "Nicht begonnen"
  },
  "random": {
    "page": "Seite",
    "pageOf": "Seite {page} von {total}",
    "search": "Suche",
    "viewAllResults": "Alle Ergebnisse anzeigen",
    "searchResults": "Suchergebnisse",
    "searchingFor": "Suche nach",
    "noResultsFound": "Keine Ergebnisse gefunden",
    "tryDifferentQuery": "Versuchen Sie eine andere Suchanfrage",
    "foundResults": "{count} Ergebnisse gefunden"
  },
  "search": {
    "aiNoResultsDescription": "Die KI-Suche konnte keine relevanten Übereinstimmungen finden. Versuchen Sie eine andere Suchanfrage oder gehen Sie zurück zur Karte.",
    "aiNotAvailable": "KI-Suche ist noch nicht verfügbar. Der Backend-Endpunkt wird entwickelt.",
    "aiPoweredSemanticSearch": "KI-gestützte semantische Suche",
    "aiResults": "KI-Ergebnisse",
    "aiSearching": "Suche mit KI...",
    "aiSearchingDescription": "Bitte warten Sie, während wir mit KI nach relevanten Ergebnissen suchen.",
    "aiSearchResults": "KI-Suchergebnisse",
    "bestMatch": "Beste Übereinstimmung",
    "clearAiResults": "KI-Ergebnisse löschen",
    "exactMatches": "Genaue Treffer",
    "noResults": "Keine Ergebnisse gefunden",
    "noResultsDescription": "Wir konnten keine Übereinstimmungen für Ihre Suche finden. Probieren Sie unsere KI-gestützte Suche für bessere Ergebnisse.",
    "readyToSearchWithAi": "Bereit für KI-Suche",
    "readyToSearchWithAiDescription": "Klicken Sie auf die Schaltfläche unten, um relevante Ergebnisse mit KI-gestützter semantischer Suche zu finden.",
    "relevanceScore": "Relevanzbewertung",
    "searchPlaceholder": "Suchen (mind. 2)",
    "searchWithAi": "Mit KI suchen",
    "tryOurAi": "KI ausprobieren"
  },
  "roles": {
    "FORBID_EXPORT": "Export verbieten",
    "LIBRARY_MANAGER": "Verwaltung Library",
    "MANAGE_FUNCTIONS": "Verwalten Funktionen",
    "MANAGE_PROJECT_RESPONSIBLE": "Verwalten Projektverantwortlicher",
    "MANAGE_SCOPES": "Verwaltung Bereiche",
    "MANAGE_TEMPLATE_OWNER": "Prozesslandkarten-Admin",
    "MANAGE_USERS": "Verwaltung Nutzer",
    "MANAGE_VIEWS": "Verwaltung Ansichten",
    "PROJECTS_WITHOUT_SCOPE": "Projekte ohne Bereich",
    "role": "Rolle",
    "roles": "Rollen",
    "EXCLUDE_FROM_ANALYTICS": "Von Analytics ausschließen",
    "VIEW_ANALYTICS": "Analytics anzeigen",
    "VIEW_DASHBOARD": "Reports anzeigen",
    "MANAGE_IN_APP_CONTENT": "In-App-Inhalte verwalten",
    "MANAGE_SKILLS": "KI-Skills verwalten",
    "MANAGE_AI_MODELS": "KI-Modelle verwalten"
  },
  "routes": {
    "company/functions": "Funktionen",
    "dashboard": "Dashboard",
    "dashboard/my-projects": "Meine Projeke",
    "dashboard/tasks": "Meine Aufgaben",
    "projects": "Projekt",
    "projects/*/activities": "Eckpunkt",
    "projects/*/activities/*/actions": "Actions",
    "projects/*/activities/*/approvals": "Freigabeverantwortliche",
    "projects/*/activities/*/checklist": "Checkliste",
    "projects/*/activities/*/completion-criteria": "Erfüllungskriterien",
    "projects/*/activities/*/documents": "Projektdokumente",
    "projects/*/activities/*/links-and-tools": "Verknüpfungen & Werkzeuge",
    "projects/*/activities/*/notes": "Notizen",
    "projects/*/activities/*/predecessors": "Vorgänger",
    "projects/*/activities/*/successors": "Nachfolger",
    "projects/*/activities/*/watchers": "Zu Informierende",
    "projects/*/milestones": "Meilenstein",
    "projects/*/milestones/*/approvals": "Freigabeverantwortliche",
    "projects/*/milestones/*/notes": "Notizen",
    "projects/*/settings": "Einstellungen",
    "projects/*/settings/checklist-rows": "Checklisten-Zeilen",
    "projects/*/settings/documents": "Projektdokumente",
    "projects/*/settings/editors": "Prozesslandkarten-Editoren",
    "projects/*/settings/functions": "Funktionen",
    "projects/*/settings/links-and-tools": "Verknüpfungen & Werkzeuge",
    "projects/*/settings/members": "Projektteilnehmer",
    "root": "Dashboard",
    "settings": "Einstellungen",
    "settings/company": "Einstellungen",
    "templates": "Prozesslandkarte",
    "templates/*/activities": "Eckpunkt",
    "templates/*/activities/*/approvers": "Freigabeverantwortliche",
    "templates/*/activities/*/checklist-steps": "Checklisten-Schritte",
    "templates/*/activities/*/completion-criteria": "Erfüllungskriterien",
    "templates/*/activities/*/documents": "Projektdokumente",
    "templates/*/activities/*/links-and-tools": "Verknüpfungen & Werkzeuge",
    "templates/*/activities/*/predecessors": "Vorgänger",
    "templates/*/activities/*/successors": "Nachfolger",
    "templates/*/activities/*/watchers": "Zu Informierende",
    "templates/*/editors": "Prozesslandkarten-Editoren",
    "templates/*/milestones": "Meilenstein",
    "templates/*/milestones/*/activities/optional": "Optionale Eckpunkte",
    "templates/*/milestones/*/activities/required": "Erforderliche Eckpunkte",
    "templates/*/milestones/*/approvers": "Freigabeverantwortliche",
    "templates/*/milestones/*/predecessors": "Vorgänger",
    "templates/*/milestones/*/successors": "Nachfolger",
    "templates/*/settings": "Einstellungen",
    "templates/*/settings/documents": "Projektdokumente",
    "templates/*/settings/editors": "Prozesslandkarten-Editoren",
    "templates/*/settings/functions": "Funktionen",
    "templates/*/settings/links-and-tools": "Verknüpfungen & Werkzeuge"
  },
  "scopes": {
    "all": "Alle",
    "assignToAllUsers": "Allen Benutzern zuweisen (nur additiv)",
    "createScope": "Bereich erstellen",
    "editScope": "Bereich ändern",
    "pleaseTypeInScopeName": "Bitte gib den Namen des Bereichs ein",
    "projectCreator": "Erstellen Projekte",
    "projectReader": "Lesen Projekte",
    "removeScopeSubtitle": "Vorsicht! Der Bereich wird gelöscht, alle Prozesslandkarten und Benutzer werden diesen Bereich verlieren.",
    "removeScopeTitle": "Der Bereich wird gelöscht",
    "scope": "Bereich",
    "scopes": "Bereiche",
    "templateCreator": "Erstellen Prozesslandkarten",
    "templateReader": "Lesen Prozesslandkarten"
  },
  "settings": {
    "documents": "Projektdokumente",
    "linksAndTools": "Standards/Vorlagen",
    "profile": "Profil",
    "settings": "Einstellungen",
    "settingsOverview": "Einstellungen",
    "slogan": "Administriere deine Funktionen und Dokumente für diese Prozesslandkarte.",
    "teamMembers": "Teammitglieder"
  },
  "sideBar": {
    "assignedToMe": "Mir zugewiesen",
    "assignedToMeTooltip": "Alle Verantwortlichkeiten hervorheben",
    "days": "Tage",
    "favorites": "Favoriten",
    "favoritesTooltip": "Alle favorisierten Eckpunkte hervorheben",
    "hideMirrored": "Gespiegelte ausblenden",
    "hideMirroredTooltip": "Eckpunkte und Meilensteine aus anderen Projekten ausblenden",
    "filterHideModeTooltip": "Nur Treffer anzeigen: Eckpunkte, die nicht zum aktiven Filter oder zur Suche passen, ausblenden statt abblenden",
    "fromLibrary": "Aus Bibliothek",
    "fromLibraryTooltip": "Eckpunkte aus der Unternehmensbibliothek hervorheben",
    "templateOnly": "Nur Vorlage",
    "templateOnlyTooltip": "In dieser Vorlage erstellte Eckpunkte hervorheben",
    "latestChanges": "Änderungen der letzten ",
    "latestChangesTooltip": "Alle Änderungen an Eckpunkten der letzten Tage hervorheben"
  },
  "sideNavigation": {
    "companySettings": "Einstellungen",
    "english": "Englisch",
    "functionsAndUsers": "Funktionen",
    "german": "Deutsch",
    "history": "Historie",
    "inviteColleagues": "Personen einladen",
    "kanbanView": "Kanban-Board",
    "languages": "Sprachen",
    "library": "Bibliothek",
    "linksAndTools": "Standards/Vorlagen",
    "listView": "Listenansicht",
    "logout": "Abmelden",
    "meetings": "Besprechungen",
    "myBeeboard": "Mein Beeboard",
    "myTasks": "Meine Aufgaben",
    "notifications": "Benachrichtigungen",
    "projectOverview": "Projektdashboard",
    "projectDocuments": "Projektdokumente",
    "projectMembers": "Projektteilnehmer",
    "projects": "Projekte",
    "projectReports": "Projektreporting",
    "analytics": "Nutzungsstatistiken",
    "reports": "Berichte",
    "template": "Prozesslandkarte",
    "templateEditors": "Prozesslandkarten-Editoren",
    "templates": "Prozesslandkarten",
    "userProfile": "Profil",
    "userSettings": "Einstellungen",
    "featureRanking": "Feature Ranking",
    "more": "Mehr"
  },
  "featureRanking": {
    "title": "Feature Ranking",
    "pageSubtitle": "Features per Drag & Drop nach Business Value sortieren. Oben = höchster Wert.",
    "popupSubtitle": "Sortiere diese Features nach Business Value. Per Drag & Drop umsortieren. Oben = höchster Wert.",
    "allFeatures": "Alle Features",
    "myRanking": "Mein Ranking",
    "saveRanking": "Ranking speichern",
    "saving": "Speichern...",
    "submitRanking": "Ranking abgeben",
    "skipForToday": "Heute überspringen",
    "emptyRanking": "Du hast noch keine Features bewertet. Das Ranking-Popup erscheint nach dem Login.",
    "devopsId": "DevOps ID",
    "featureTitle": "Titel",
    "description": "Beschreibung",
    "effort": "Aufwand",
    "featureDate": "Datum",
    "avgValue": "Durchschn. Wert",
    "votes": "Stimmen",
    "showDescription": "Details anzeigen",
    "hideDescription": "Details ausblenden",
    "rankMore": "Weitere Bewertung"
  },
  "statusBadges": {
    "done": "Fertig",
    "inProgress": "In Bearbeitung",
    "none": "Kein",
    "notRequired": "Nicht erforderlich",
    "planned": "Geplant",
    "underway": "In Bearbeitung",
    "unplanned": "Ungeplant",
    "onTrack": "Im Plan",
    "atRisk": "Gefährdet",
    "offTrack": "Verzögert"
  },
  "kanban": {
    "emptyColumn": "Keine Aufgaben",
    "dropHere": "Hier ablegen zum Verschieben",
    "cannotDropHere": "Hier nicht ablegen möglich",
    "alsoMoves": "Wird auch verschoben",
    "mobileWarning": "Drag & Drop funktioniert am besten auf dem Desktop. Tippen Sie auf Karten, um Details anzuzeigen.",
    "legend": {
      "canDrop": "Hier ablegen möglich",
      "cannotDrop": "Hier nicht ablegen möglich"
    },
    "validation": {
      "sameColumn": "Aufgabe ist bereits in dieser Spalte",
      "projectLoadError": "Projektdaten konnten nicht geladen werden",
      "cannotMoveFromUnplanned": "Aufgaben können nicht aus dem Status 'Ungeplant' verschoben werden",
      "cannotMoveToUnplanned": "Aufgaben können nicht zurück zu 'Ungeplant' verschoben werden",
      "childrenInProgress": "Aktivität kann nicht auf 'Geplant' gesetzt werden, während untergeordnete Elemente in Bearbeitung sind",
      "restrictedFromNotRequired": "Eingeschränkte Übergänge vom Status 'Nicht erforderlich'",
      "notRequiredNotAllowed": "'Nicht erforderlich' ist nur für Abnahmekriterien verfügbar",
      "transitionNotAllowed": "Dieser Statusübergang ist nicht erlaubt"
    },
    "errors": {
      "taskNotFound": "Aufgabe nicht gefunden"
    }
  },
  "projectKanban": {
    "kanbanView": "Kanban-Board",
    "filters": "Filter",
    "searchPlaceholder": "Board durchsuchen",
    "users": "Benutzer",
    "cardLocked": "Sie haben keine Berechtigung, dieses Element zu ändern",
    "mobileHintTitle": "Das Kanban-Board benötigt mehr Platz",
    "mobileHintText": "Das Kanban-Board ist nur auf breiteren Bildschirmen verfügbar. Wechseln Sie zur Listenansicht, um dieses Projekt auf kleineren Displays zu bearbeiten.",
    "goToListView": "Zur Listenansicht",
    "setFunction": "Funktion",
    "setUser": "Benutzer",
    "workstream": "Teilprozess",
    "noFunction": "Keine Funktion",
    "functionDefaultUser": "Standardbenutzer der Funktion",
    "assignFunction": "Funktion zuweisen",
    "assignUser": "Benutzer zuweisen",
    "resizeFilters": "Zum Anpassen ziehen – Doppelklick zum Zurücksetzen",
    "groupBy": "Gruppieren nach",
    "groupByStatus": "Nach Status",
    "groupByWorkstream": "Nach Teilprozess",
    "noWorkstream": "Kein Teilprozess",
    "hideDone": "Fertige ausblenden",
    "newActivity": "Neuer Eckpunkt",
    "newActivityTitle": "Titel des Eckpunkts",
    "setDate": "Datum",
    "deadlineOutOfRange": "Die Frist liegt außerhalb der Projektphasen"
  },
  "projectViewSwitcher": {
    "label": "Projektansicht",
    "list": "Liste",
    "board": "Board"
  },
  "statusColors": {
    "red": "rot",
    "yellow": "gelb",
    "green": "grün"
  },
  "statusApproval": {
    "pending": "Ausstehend",
    "approved": "Genehmigt",
    "rejected": "Abgelehnt"
  },
  "table": {
    "active": "aktiv",
    "activeFilters": "Aktive Filter",
    "clearAll": "Alle Filter zurücksetzen",
    "filterBy": "Filtern nach",
    "groupBy": "Gruppe nach",
    "searchBy": "Suchen nach {placeholder}",
    "search": "Suchen",
    "selected": "ausgewählt",
    "noEntriesFound": "Keine Einträge vorhanden",
    "reset": "Tabelle zurücksetzen",
    "any": "Alle",
    "selectColumns": "Spalten auswählen",
    "from": "Von",
    "to": "Bis",
    "invalidDateRange": "Enddatum muss nach dem Startdatum liegen"
  },
  "tag": {
    "addTag": "Tag hinzufügen",
    "editTags": "Tags bearbeiten",
    "searchFor": "Nach Tag suchen",
    "tag": "Tag",
    "tagHasBeenAddedSuccessfully": "Tag wurde erfolgreich hinzugefügt",
    "tagHasBeenRemovedSuccessfully": "Tag wurde erfolgreich entfernt",
    "tagsHaveBeenUpdatedSuccessfully": "Tags wurden erfolgreich aktualisiert",
    "tags": "Tags",
    "title": "Titel",
    "topic": "Thema"
  },
  "tagsAndTopics": {
    "addTagOrTopic": "Tag/Thema hinzufügen",
    "editTagOrTopic": "{thing} bearbeiten",
    "tags": "Tags",
    "tagsAndTopics": "Tags/Themen",
    "title": "Titel",
    "titlePlaceholder": "Bitte Titel ausfüllen",
    "type": "Typ"
  },
  "task": {
    "action": "Aktion",
    "dueDate": "Fälligkeitsdatum: {date}",
    "project": "Projekt",
    "status": "Status",
    "statusPredecessors": "Frühester Status der Vorgänger",
    "title": "Titel",
    "type": "Typ"
  },
  "taskTypeBadges": {
    "Action": "Maßnahme",
    "Activity": "Eckpunkt",
    "CC": "EK"
  },
  "template": {
    "keepPreviousOwnerAsEditor": "{name} als Editor behalten",
    "ownerNeedsTemplateScopes": "Der neue Besitzer braucht in jedem ausgewählten Bereich „Lesen Prozesslandkarten“.",
    "activitiesRenumbered": "Eckpunkte neu nummeriert",
    "copyOfTemplate": "Kopie von {template}",
    "copyTemplate": "Prozesslandkarte kopieren",
    "create": "Prozesslandkarte Erstellen",
    "createNewProjectMap": "Prozesslandkarte erstellen",
    "delete": "Prozesslandkarte löschen",
    "edit": "Prozesslandkarte bearbeiten",
    "editProjectMapTemplate": "Eine Prozesslandkarte bearbeiten",
    "isDraftState": "Prozesslandkarte ist ein Entwurf",
    "isNotActive": "Prozesslandkarte ist inaktiv",
    "milestonesRenumbered": "Meilensteine neu nummeriert",
    "newTemplate": "Neue Prozesslandkarte",
    "openToReviewFindings": "Prozesslandkarte öffnen",
    "originNotReleased": "Die Prozesslandkarte, aus der dieses Projekt erstellt wurde, ist nicht mehr veröffentlicht und kann nicht für eine Aktualisierung verwendet werden.",
    "owner": "Besitzer",
    "pleaseTypeInTemplateName": "Please Type in the Template Name",
    "qualityCheck": "Qualitätsprüfung",
    "release": "Veröffentlichen",
    "releaseConfirmSubtitle": "Nach der Veröffentlichung kann diese Prozesslandkarte für Projekte verwendet werden.",
    "releaseConfirmTitle": "Prozesslandkarte veröffentlichen",
    "releaseNoFindings": "Die Qualitätsprüfung hat keine offenen Punkte gefunden.",
    "releaseQualityLoading": "Qualitätsprüfung läuft…",
    "releaseQualitySummary": "Die Qualitätsprüfung hat {warnings} Warnung(en) und {hints} Hinweis(e) gefunden. Sie können sie trotzdem veröffentlichen.",
    "releaseQualityUnavailable": "Die Qualitätsprüfung konnte nicht geladen werden. Sie können sie trotzdem veröffentlichen.",
    "renumberActivities": "Eckpunkte neu nummerieren",
    "renumberMilestones": "Meilensteine neu nummerieren",
    "setInactive": "Inaktiv setzen",
    "setInactiveConfirmSubtitle": "Eine inaktive Prozesslandkarte ist nur noch für ihren Besitzer und für Benutzer mit der Rolle „Prozesslandkarten-Admin“ sichtbar, kann nicht mehr für neue Projekte verwendet werden, und Projekte können nicht mehr daraus aktualisiert werden. Sie können sie später wieder aktivieren.",
    "setInactiveConfirmTitle": "Prozesslandkarte inaktiv setzen",
    "status": "Status",
    "statusChangeFailed": "Der Status konnte nicht geändert werden",
    "statusChanged": "Status aktualisiert",
    "statusDraft": "Entwurf",
    "statusFilter": "Status",
    "statusInactive": "Inaktiv",
    "statusReleased": "Veröffentlicht",
    "template": "Prozesslandkarte",
    "templateCopySuccess": "Vorlage {originalTemplateTitle} wurde erfolgreich kopiert als {copiedTemplateTitle}.",
    "templateHasBeenCreated": "Vorlage wurde erfolgreich erstellt",
    "templateList": "Titel",
    "templateListOverview": "Prozesslandkarten",
    "templateTitle": "Titel der Prozesslandkarte",
    "templateWillBeDeleted": "Template will be deleted",
    "templateWillBeDeletedSubtitle": "This template will be deleted. This action cannot be undone! Are you sure?",
    "title": "Titel"
  },
  "templateEditor": {
    "keepMeAsEditor": "Mich als Editor behalten",
    "addUser": "Benutzer hinzufügen",
    "addUsers": "Benutzer hinzufügen",
    "addUserSubtitle": "Wähle in der Liste unten einen Benutzer als Prozesslandkarten-Editor.",
    "addUsersSubtitle": "Wähle in der Liste unten Benutzer als Prozesslandkarten-Editoren aus.",
    "confirmOwnerAlert": "Falls Du den Verantwortlichen änderst, verlierst Du die Berechtigung zur Bearbeitung dieser Prozesslandkarte und kannst dies selber nicht rückgängig machen.",
    "confirmOwnerAlertKeepEditor": "Du bist danach nicht mehr Verantwortlicher dieser Prozesslandkarte, bleibst aber Editor.",
    "confirmOwnerSubtitle": "Du wirst als Vorlage-Verantwortlicher durch den ausgewählten Benutzer ersetzt.",
    "emptyTable": "Bitte stellen Sie sicher, dass Sie beeboard richtig verwenden.",
    "name": "Name",
    "noEditors": "Keine Editoren gefunden",
    "removeUser": "Benutzer entfernen",
    "removeUserSubtitle": "Der Benutzer ist der Prozesslandkarte zugeordnet. Er wird seine Berechtigung zur Bearbeitung dieser Prozesslandkarte verlieren? Willst Du weitermachen?",
    "selectUser": "Wähle Benutzer aus",
    "selectUsers": "Wähle Benutzer aus",
    "templateEditors": "Prozesslandkarten-Editoren",
    "templateEditorsSubtitle": "Der Prozesslandkarten-Verantwortliche kann weitere Editoren hinzufügen und entferenen",
    "templateOwner": "Prozesslandkarten-Verantwortlicher",
    "templateOwnerSubtitle": "Benutzer der die Prozesslandkarte administrieren kann",
    "updateOwnerSubtitle": "Wähle in der Liste einen Benutzer als neuen Prozesslandkarten-Verantwortlichen aus.",
    "user": "Benutzer",
    "users": "Benutzer",
    "usersCounted": "Kein Benutzer | {n} Benutzer | {n} Benutzer"
  },
  "toolbar": {
    "labelShow": "Beschriftungen anzeigen",
    "timeLineTemplateMode": "Grid / Positionen anzeigen"
  },
  "topic": {
    "addTopic": "Thema hinzufügen",
    "editTopics": "Themen bearbeiten",
    "searchFor": "Nach Thema suchen",
    "topic": "Thema",
    "topicHasBeenAddedSuccessfully": "Thema wurde erfolgreich hinzugefügt",
    "topicHasBeenRemovedSuccessfully": "Thema wurde erfolgreich entfernt",
    "topicsHaveBeenUpdatedSuccessfully": "Themen wurden erfolgreich aktualisiert",
    "topics": "Themen"
  },
  "users": {
    "exportToExcel": "Excel-Export",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "name": "Name",
    "userName": "Benutzername",
    "userType": "Typ",
    "deletedUser": "Gelöschter Benutzer",
    "unknownUser": "Unbekannter Benutzer"
  },
  "userSettings": {
    "receiveEmailNotifications": "E-Mail Benachrichtigungen erhalten",
    "emailLanguage": "E-Mail Sprache",
    "receiveEmailTasksNotifications": "E-Mail Benachrichtigungen zu Aufgaben erhalten",
    "receiveEmailTasksThreshold": "Tage im Voraus",
    "sectionGeneral": "Allgemeine E-Mail Benachrichtigungen",
    "sectionGeneralHint": "Hier erhälst du täglich (wenn vorhanden) deine neuen Benachrichtigungen aus der Glocke oben rechts.",
    "sectionTasks": "E-Mail Benachrichtigungen zu Aufgaben",
    "sectionTasksHint": "Hier erhälst du täglich (wenn vorhanden) Benachrichtigungen zu überfälligen Aufgaben und Aufgaben innerhalb des Zeitfensters deines Schwellenwertes.",
    "sectionTeams": "Microsoft Teams Benachrichtigungen",
    "sectionTeamsHint": "Erhalte deine In-App-Benachrichtigungen in Echtzeit als persönliche Nachrichten in Microsoft Teams. Deine Organisation muss dafür die beeboard Teams-App aktiviert haben.",
    "receiveTeamsNotifications": "Benachrichtigungen in Microsoft Teams erhalten",
    "sectionSlack": "Slack Benachrichtigungen",
    "sectionSlackHint": "Erhalte deine In-App-Benachrichtigungen in Echtzeit als persönliche Nachrichten der beeboard App in Slack.",
    "receiveSlackNotifications": "Benachrichtigungen in Slack erhalten",
    "slackUserNotFound": "Für deine E-Mail-Adresse wurde kein Slack-Konto gefunden. Slack-Benachrichtigungen funktionieren nur, wenn dein Slack-Konto dieselbe E-Mail-Adresse verwendet wie dein beeboard-Konto.",
    "slackUnavailable": "Slack ist gerade nicht erreichbar. Bitte versuche es später noch einmal.",
    "sectionLanguage": "Sprache",
    "sectionLanguageHint": "",
    "profilePicture": {
      "section": "Profilbild",
      "formats": "Unterstützt: JPG, PNG, WebP, GIF",
      "invalidType": "Nur JPG, PNG, WebP oder GIF Bilder werden unterstützt.",
      "uploadSuccess": "Profilbild erfolgreich aktualisiert.",
      "cropTitle": "Profilbild anpassen",
      "cropHint": "Ziehen zum Verschieben · Scrollen oder Pinchen zum Zoomen",
      "upload": "Foto hochladen",
      "remove": "Bild entfernen",
      "removeSuccess": "Profilbild erfolgreich entfernt.",
      "removeConfirm": "Möchtest du dieses Foto wirklich entfernen?",
      "rotate": "Drehen",
      "change": "Ändern",
      "syncMs": "Mit Microsoft synchronisieren",
      "syncSuccess": "Profilbild erfolgreich mit Microsoft synchronisiert.",
      "msSynced": "Mit Microsoft synchronisiert"
    }
  },
  "watcher": {
    "addWatcher": "Zu Informierenden hinzufügen",
    "addWatcherSubtitle": "Wähle eine Funktion aus.",
    "deleteWatcher": "Zu Informierenden löschen",
    "goToWatchersList": "Zur Zu Informierenden-Liste gehen",
    "watcherHasBeenAddedSuccessfully": "Zu Informierender wurde erfolgreich hinzugefügt",
    "watcherHasBeenRemovedSuccessfully": "Zu Informierender wurde erfolgreich entfernt",
    "watcher": "Zu Informierender",
    "watchers": "Zu Informierende"
  },
  "weekday": {
    "monday": "Mo",
    "tuesday": "Di",
    "wednesday": "Mi",
    "thursday": "Do",
    "friday": "Fr",
    "saturday": "Sa",
    "sunday": "So"
  },
  "workstream": {
    "addWorkstreamTitle": "Teilprozess erstellen",
    "deleteWorkstream": "Teilprozess löschen",
    "deleteWorkstreamTitle": "Teilprozess löschen",
    "description": "Beschreibung",
    "editWorkstreamTitle": "Teilprozess bearbeiten",
    "order": "Reihenfolge",
    "placeholder": "Name",
    "position": "Position",
    "positionAtFirst": "am Anfang",
    "positionAtLast": "am Ende",
    "positionBefore": "vor {title}",
    "title": "Titel"
  },
  "roadmap": {
    "title": "Produkt-Roadmap",
    "subtitle": "Große bevorstehende Funktionen und Verbesserungen für die Plattform. Nicht enthalten sind die kleinen Änderungen, die wir ständig zur Verbesserung der Benutzererfahrung und zur Implementierung von Ad-hoc-Feedbacks bereitstellen.",
    "searchPlaceholder": "Roadmap-Einträge durchsuchen...",
    "noItems": "Keine Roadmap-Einträge gefunden",
    "activeItems": "Aktive Einträge",
    "completedItems": "Abgeschlossene Einträge"
  },
  "aiSkills": {
    "tabTitle": "KI-Skills",
    "title": "KI-Skills",
    "subtitle": "Vordefinierte Prompts und Tool-Sets, die Benutzer im Chat per /slug aufrufen können.",
    "addSkill": "Skill hinzufügen",
    "editSkill": "Skill bearbeiten",
    "noSkills": "Es wurden noch keine KI-Skills definiert.",
    "slug": "Befehl",
    "slugPlaceholder": "meeting-minutes",
    "slugHint": "Was Benutzer im Chat nach / eingeben, um diesen Skill aufzurufen. Kleinbuchstaben a–z, 0–9 und Bindestriche. Kann später geändert werden — der Chat-Verlauf bleibt über die id des Skills verknüpft.",
    "name": "Name",
    "namePlaceholder": "Meeting Minutes",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Fasst ein angehängtes Meeting-Transkript in strukturierte Protokolle zusammen.",
    "descriptionHint": "Wird im Skill-Auswahlfenster angezeigt — eine kurze Beschreibung, was der Skill tut.",
    "slots": {
      "title": "Anhang-Slots",
      "hint": "Definiere einen Slot pro Dokumenttyp, den dieser Skill erwartet. Benutzer erhalten beim Aufruf des Skills pro Slot ein beschriftetes Upload-Feld. Leer lassen, wenn der Skill keine Anhänge braucht — Benutzer können trotzdem Dateien per Büroklammer-Button anhängen.",
      "label": "Slot-Bezeichnung",
      "labelPlaceholder": "Vertrag",
      "description": "Slot-Beschreibung",
      "descriptionPlaceholder": "Der PDF-Vertrag, der analysiert werden soll.",
      "required": "Erforderlich",
      "multiple": "Mehrere Dateien erlauben",
      "add": "Slot hinzufügen",
      "remove": "Slot entfernen",
      "moveUp": "Nach oben",
      "moveDown": "Nach unten"
    },
    "systemPrompt": "System-Prompt",
    "systemPromptPlaceholder": "Du bist ein Meeting-Minutes-Assistent. Erzeuge: Teilnehmer, Entscheidungen, Action Items.",
    "contexts": {
      "title": "Wo kann dieser Skill verwendet werden?",
      "hint": "Projekt-Chat und Template-Chat haben unterschiedliche Tools. Aktivieren Sie die Kontexte, in denen dieser Skill verfügbar sein soll, und wählen Sie für jeden die zugehörigen Tools.",
      "project": "Projekt-Chat",
      "template": "Template-Chat"
    },
    "toolCategory": {
      "read": "Lesen",
      "write": "Schreiben",
      "system": "System",
      "orchestration": "Teilaufgaben"
    },
    "deleteConfirmTitle": "Diesen Skill löschen?",
    "deleteConfirmMessage": "„{name}“ wird gelöscht. Benutzer können ihn nicht mehr im Chat aufrufen.",
    "createSuccess": "Skill erstellt.",
    "updateSuccess": "Skill aktualisiert.",
    "deleteSuccess": "Skill gelöscht.",
    "errors": {
      "nameRequired": "Name ist erforderlich.",
      "promptRequired": "System-Prompt ist erforderlich.",
      "slugPattern": "Verwenden Sie Kleinbuchstaben a–z, 0–9 und Bindestriche. Muss mit Buchstabe oder Ziffer beginnen.",
      "contextRequired": "Wählen Sie mindestens einen Kontext (Projekt-Chat oder Template-Chat)."
    }
  },
  "aiModels": {
    "tabTitle": "KI-Modelle",
    "resource": {
      "sectionTitle": "KI-Ressourcen",
      "sectionSubtitle": "OpenAI-Konten oder Azure-OpenAI-Ressourcen. API-Schlüssel werden verschlüsselt gespeichert und niemals von einer Schnittstelle zurückgegeben.",
      "add": "Ressource hinzufügen",
      "createTitle": "KI-Ressource hinzufügen",
      "editTitle": "KI-Ressource bearbeiten",
      "empty": "Noch keine KI-Ressourcen konfiguriert. Lege zuerst eine an, bevor du Modelle definierst.",
      "type": "Typ",
      "typeImmutable": "Der Ressourcen-Typ kann nach dem Anlegen nicht geändert werden — lege stattdessen eine neue Ressource an.",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "https://contoso-ai.openai.azure.com",
      "endpointRequired": "Endpoint ist für Azure-Ressourcen erforderlich.",
      "apiKey": "API-Schlüssel",
      "apiKeyCreatePlaceholder": "sk-...",
      "apiKeyEditPlaceholder": "Leer lassen, um den bestehenden Schlüssel zu behalten",
      "apiKeyHint": "Wird mit AES-256-GCM verschlüsselt gespeichert. Beim Bearbeiten rotiert das Eintragen den Schlüssel.",
      "apiKeyRequired": "API-Schlüssel ist beim Anlegen erforderlich.",
      "displayName": "Anzeigename",
      "displayNamePlaceholder": "DECK OpenAI",
      "displayNameRequired": "Anzeigename ist erforderlich.",
      "editAction": "Bearbeiten / Schlüssel rotieren",
      "createSuccess": "KI-Ressource angelegt.",
      "updateSuccess": "KI-Ressource aktualisiert.",
      "deleteSuccess": "KI-Ressource gelöscht.",
      "deleteConfirmTitle": "KI-Ressource löschen",
      "deleteConfirmMessage": "'{name}' löschen? Modelle, die diese Ressource verwenden, müssen vorher entfernt werden."
    },
    "model": {
      "sectionTitle": "KI-Modelle",
      "sectionSubtitle": "Modelle, die im Chat genutzt werden können. Markiere, welches Modell pro Funktion Standard ist — höchstens eines pro Funktion.",
      "add": "Modell hinzufügen",
      "createTitle": "KI-Modell hinzufügen",
      "editTitle": "KI-Modell bearbeiten",
      "empty": "Noch keine KI-Modelle konfiguriert.",
      "noResources": "Keine Ressource verfügbar. Lege zuerst eine an.",
      "noResourcesError": "Lege eine KI-Ressource an, bevor du Modelle erstellst.",
      "resource": "Ressource",
      "resourceRequired": "Wähle eine Ressource für dieses Modell.",
      "resourceImmutable": "Ressource ist nach dem Anlegen unveränderlich.",
      "modelName": "OpenAI-Modell-ID",
      "modelNamePlaceholder": "gpt-5-mini-2025-08-07",
      "modelNameHint": "Die OpenAI-Modell-ID, die an die API gesendet wird. Muss innerhalb dieses Mandanten eindeutig sein.",
      "modelNameImmutable": "Modell-ID ist nach dem Anlegen unveränderlich.",
      "modelNameRequired": "Modell-ID ist erforderlich.",
      "deploymentName": "Azure-Deployment-Name",
      "deploymentNamePlaceholder": "gpt-5-mini-deployment",
      "deploymentNameHint": "Optional. Wenn gesetzt, wird dieser Name an Azure gesendet statt der Modell-ID.",
      "displayName": "Anzeigename",
      "displayNamePlaceholder": "GPT-5 mini",
      "displayNameRequired": "Anzeigename ist erforderlich.",
      "isAvailable": "Im Chat-Modellauswähler anzeigen",
      "isAvailableShort": "Verfügbar",
      "isAvailableYes": "Ja",
      "isAvailableNo": "Nein",
      "isAvailableHint": "Wenn deaktiviert, ist das Modell für Endnutzer ausgeblendet, kann aber weiterhin als Standard für Funktionen markiert werden.",
      "defaultFor": "Standard für Funktionen",
      "defaultForHint": "Funktionen, für die dieses Modell der Mandanten-Standard ist. Höchstens ein Modell pro Funktion und Mandant. Endnutzer können in den Chat-Assistenten weiterhin jedes verfügbare Modell auswählen — der Standard ist nur das, was automatisch gewählt wird.",
      "capabilityClaimed": "Bereits durch '{name}' belegt. Dort zuerst entfernen, um es neu zuzuweisen.",
      "capabilityClaimedShort": "belegt durch {name}",
      "pricingTitle": "Preise (USD pro 1 Mio. Tokens)",
      "pricingHint": "Leer lassen, um die eingebauten Standardpreise für diese Modell-ID zu verwenden. Setze Werte, um Kosten pro Chat zu erfassen. Komma oder Punkt als Dezimaltrennzeichen — beides funktioniert.",
      "inputPrice": "Eingabe",
      "outputPrice": "Ausgabe",
      "cachedInputPrice": "Eingabe (Cache)",
      "pricePlaceholder": "z. B. 0,25",
      "priceInvalid": "Muss eine nicht-negative Zahl sein, z. B. 0,25 oder 0.25.",
      "contextWindowTitle": "Kontextfenster",
      "contextWindowHint": "Gesamtzahl der Tokens, die das Modell verarbeiten kann. Leer lassen, um den eingebauten Wert für diese Modell-ID zu verwenden. Ein höherer Wert erlaubt längere Transkripte für Meeting-Fragen – ohne Code-Änderung.",
      "contextWindowTokens": "Kontextfenster (Tokens)",
      "contextWindowPlaceholder": "z. B. 400000",
      "contextWindowInvalid": "Muss eine ganze Zahl ab 1 sein, z. B. 400000 oder 400.000.",
      "capabilities": {
        "project_assistant": "Projekt-KI-Assistent",
        "template_assistant": "Template-KI-Assistent",
        "meeting_summary": "Meeting-Zusammenfassung",
        "meeting_qa": "Meeting-Fragen (Q&A)",
        "entity_matching": "Meeting-Entity-Zuordnung",
        "template_translate": "Template-Übersetzung",
        "template_quality_check": "Qualitätsprüfung der Prozesslandkarte",
        "company_relay": "Unternehmens-KI-Relay"
      },
      "createSuccess": "KI-Modell angelegt.",
      "updateSuccess": "KI-Modell aktualisiert.",
      "deleteSuccess": "KI-Modell gelöscht.",
      "deleteConfirmTitle": "KI-Modell löschen",
      "deleteConfirmMessage": "'{name}' löschen? Chats, die dieses Modell nutzen, fallen still auf den Mandanten-Standard zurück."
    }
  },
  "aiGlossary": {
    "tabTitle": "KI-Glossar",
    "title": "KI-Glossar",
    "subtitle": "Kanonische Schreibweisen für Namen und Begriffe, damit KI-Zusammenfassungen, Aufgaben und Antworten Spracherkennungsfehler aus Transkripten korrigieren.",
    "addTerm": "Begriff hinzufügen",
    "editTerm": "Begriff bearbeiten",
    "noTerms": "Es wurden noch keine Glossarbegriffe angelegt.",
    "term": "Begriff",
    "termPlaceholder": "beeboard",
    "termHint": "Die kanonische Schreibweise, die die KI verwenden soll.",
    "aliases": "Bekannte Fehltranskriptionen",
    "aliasesPlaceholder": "B-Board\nBee Board",
    "aliasesHint": "Optional, eine pro Zeile. Schreibweisen, die die Spracherkennung für diesen Begriff typischerweise erzeugt (max. 10).",
    "note": "Notiz",
    "notePlaceholder": "unser Produktname",
    "noteHint": "Optionaler kurzer Kontext, der der KI zum Begriff angezeigt wird.",
    "createSuccess": "Glossarbegriff angelegt.",
    "updateSuccess": "Glossarbegriff aktualisiert.",
    "deleteSuccess": "Glossarbegriff gelöscht.",
    "deleteConfirmTitle": "Glossarbegriff löschen",
    "deleteConfirmMessage": "'{name}' löschen? Die KI korrigiert Fehltranskriptionen dieses Begriffs dann nicht mehr.",
    "capReached": "Das Limit von {max} Glossarbegriffen ist erreicht. Löschen Sie einen Begriff, bevor Sie einen neuen anlegen.",
    "errors": {
      "termRequired": "Begriff ist erforderlich.",
      "termDuplicate": "'{term}' existiert bereits im Glossar.",
      "tooManyAliases": "Höchstens {max} Fehltranskriptionen pro Begriff.",
      "aliasTooLong": "Jede Fehltranskription darf höchstens {max} Zeichen haben."
    }
  },
  "customProperties": {
    "title": "Benutzerdefinierte Eigenschaften",
    "tabTitle": "Benutzerdefinierte Eigenschaften",
    "projectPropertiesTitle": "Zusätzliche Eigenschaften",
    "addProperty": "Eigenschaft hinzufügen",
    "editProperty": "Eigenschaft bearbeiten",
    "noProperties": "Es wurden noch keine benutzerdefinierten Eigenschaften definiert.",
    "name": "Name",
    "key": "Schlüssel",
    "dataType": "Datentyp",
    "required": "Erforderlich",
    "actions": "Aktionen",
    "description": "Beschreibung",
    "defaultValue": "Standardwert",
    "hasDefaultValue": "Standardwert festlegen",
    "booleanDefaultValue": "Standardwert (Wahr/Falsch)",
    "keyHint": "Eindeutige Kennung für diese Eigenschaft (kann nach der Erstellung nicht geändert werden)",
    "options": "Optionen",
    "optionValue": "Wert",
    "optionLabel": "Bezeichnung",
    "addOption": "Option hinzufügen",
    "minLength": "Mindestlänge",
    "maxLength": "Maximale Länge",
    "minValue": "Mindestwert",
    "maxValue": "Maximalwert",
    "deleteConfirmTitle": "Eigenschaft löschen",
    "deleteConfirmMessage": "Möchten Sie die Eigenschaft '{name}' wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteInUseTitle": "Eigenschaft wird verwendet",
    "deleteInUseMessage": "'{name}' wird derzeit von {count} Projekt(en) verwendet. Deren Werte werden entfernt. Trotzdem löschen?",
    "deleteInUseTemplateMessage": "'{name}' wird derzeit von {count} Vorlage(n) verwendet. Deren Werte werden entfernt. Trotzdem löschen?",
    "deleteAnyway": "Trotzdem löschen",
    "createSuccess": "Eigenschaft erfolgreich erstellt",
    "updateSuccess": "Eigenschaft erfolgreich aktualisiert",
    "deleteSuccess": "Eigenschaft erfolgreich gelöscht",
    "loadError": "Benutzerdefinierte Eigenschaften konnten nicht geladen werden",
    "showOnList": "In Liste anzeigen",
    "nameAndKeyRequired": "Name und Schlüssel sind Pflichtfelder",
    "namePlaceholder": "Eigenschaftsnamen eingeben",
    "keyPlaceholder": "Eindeutigen Schlüssel eingeben",
    "setProjectProperties": "Projekteigenschaften festlegen",
    "setProjectPropertiesSubtitle": "Konfigurieren Sie benutzerdefinierte Eigenschaftswerte für dieses Projekt (optional)",
    "editProjectProperties": "Projekteigenschaften bearbeiten",
    "editProjectPropertiesSubtitle": "Benutzerdefinierte Eigenschaftswerte für '{project}' bearbeiten",
    "dataTypes": {
      "text": "Text",
      "number": "Zahl",
      "date": "Datum",
      "boolean": "Boolean",
      "select": "Auswahl",
      "multiselect": "Mehrfachauswahl"
    },
    "projects": "Projekte",
    "templates": "Prozesslandkarten",
    "showOnTemplateList": "In Liste anzeigen"
  },
  "ai": {
    "panel": {
      "title": "KI-Assistent",
      "close": "Schließen",
      "resize": "Ziehen, um die Breite zu ändern"
    },
    "chat": {
      "loading": "Chat wird geladen…",
      "starters": {
        "lead": {
          "project": "Frag mich etwas zu diesem Projekt – oder lass mich etwas daran ändern.",
          "template": "Frag mich etwas zu dieser Prozesslandkarte – oder lass mich etwas daran ändern."
        },
        "leadReadOnly": {
          "project": "Frag mich etwas zu diesem Projekt.",
          "template": "Frag mich etwas zu dieser Prozesslandkarte."
        },
        "project": {
          "dueSoon": "Welche Eckpunkte sind in den nächsten zwei Wochen fällig?",
          "overdue": "Welche Eckpunkte sind überfällig, und wer ist verantwortlich?",
          "status": "Fasse den aktuellen Stand des Projekts kurz zusammen.",
          "createActivity": "Lege einen Eckpunkt „Designs prüfen“ an, fällig nächsten Freitag."
        },
        "template": {
          "structure": "Welche Phasen und Teilprozesse hat diese Prozesslandkarte?",
          "firstPhase": "Welche Eckpunkte gehören zur ersten Phase?",
          "summary": "Fasse diese Prozesslandkarte in wenigen Sätzen zusammen.",
          "createActivity": "Lege in der ersten Phase einen Eckpunkt „Projektstart-Workshop“ an."
        }
      },
      "thinking": "Denke nach",
      "reasoning": "Überlegung",
      "processing": "Verarbeite",
      "subagent": {
        "statusLine": "{running} von {total} Teilaufgaben laufen",
        "prompt": "Auftrag",
        "toolsUsed": "Tools",
        "summary": "{iterations} Iterationen · {tools} Tools",
        "runningStatus": "Läuft...",
        "failed": "Fehlgeschlagen",
        "truncated": "Iterationslimit erreicht",
        "stopped": "Gestoppt",
        "errorFallback": "Die Teilaufgabe wurde ohne Fehlermeldung abgebrochen."
      },
      "cancel": "Abbrechen",
      "stop": "Antwort stoppen",
      "running": "KI-Assistent arbeitet",
      "inputPlaceholder": {
        "default": "Nachricht... ({'@'} für Element)",
        "withDictation": "Nachricht... ({'@'} für Element)"
      },
      "dictation": {
        "start": "Diktat starten (Strg+D)",
        "stop": "Diktat stoppen (Esc)"
      },
      "newChat": "Neuer Chat",
      "send": "Senden",
      "mention": {
        "noItemsFound": "Keine Elemente gefunden"
      },
      "entityChip": {
        "notAvailable": "Diese Referenz kann aus der aktuellen Ansicht nicht geöffnet werden."
      },
      "model": {
        "label": "Modell:",
        "lockedTooltip": "Ein Chat bleibt bei seinem Modell. Für ein anderes Modell starte einen neuen Chat."
      },
      "skill": {
        "noItemsFound": "Kein passender Skill.",
        "toolsLocked": "Tools werden für diese Nachricht durch den Skill /{slug} festgelegt.",
        "attachmentMissingTitle": "Ohne erforderliche Anhänge senden?",
        "attachmentMissingMessage": "/{slug} hat diese Slots als erforderlich markiert, sie sind aber leer: {slots}",
        "attachmentMissingConfirm": "Trotzdem senden",
        "stickyActive": "ist für diesen Chat aktiv.",
        "stop": "Skill beenden",
        "slotRequired": "(erforderlich)",
        "slotUpload": "Datei hochladen",
        "slotUploadMultiple": "Datei hinzufügen",
        "slotFilledEarlier": "Bereits bereitgestellt:",
        "slotFilledEarlierTooltip": "Diese Datei wurde bereits in diesem Chat hochgeladen und steht der KI weiterhin zur Verfügung. Erneut hochladen, um sie zu ersetzen.",
        "collapse": "Skill-Bereich einklappen",
        "expand": "Skill-Bereich ausklappen",
        "collapsedFileCount": "{count} Datei | {count} Dateien"
      },
      "attachments": {
        "add": "Datei anhängen",
        "remove": "Anhang entfernen",
        "uploadFailed": "Datei-Upload fehlgeschlagen",
        "waitForUpload": "Warten auf Upload-Abschluss",
        "tooMany": "Zu viele Dateien – maximal {max} Anhänge pro Nachricht"
      },
      "codeInterpreter": {
        "codeInput": "Python-Code",
        "executing": "Code wird ausgeführt",
        "output": "Ausgabe",
        "generatedImage": "Generiertes Bild",
        "download": "Herunterladen",
        "ephemeralHint": "Dieses Bild ist nur in der aktuellen Sitzung verfügbar. Jetzt herunterladen, um es zu behalten.",
        "imageUnavailable": "Bild nicht mehr verfügbar"
      },
      "steps": {
        "entity": {
          "activity": "Eckpunkt | Eckpunkte",
          "phase": "Phase | Phasen",
          "milestone": "Meilenstein | Meilensteine",
          "workstream": "Teilprozess | Teilprozesse",
          "function": "Funktion | Funktionen",
          "completion_criterion": "Erfüllungskriterium | Erfüllungskriterien",
          "member": "Mitglied | Mitglieder",
          "relation": "Abhängigkeit | Abhängigkeiten",
          "milestone_connection": "Meilensteinrelevanz | Meilensteinrelevanzen",
          "approver": "Freigabeverantwortlicher | Freigabeverantwortliche",
          "document": "Projektdokument | Projektdokumente",
          "activity_document": "Projektdokument | Projektdokumente",
          "link": "Standard/Vorlage | Standards/Vorlagen",
          "activity_link": "Standard/Vorlage | Standards/Vorlagen"
        },
        "connector": {
          "in": "in",
          "to": "→",
          "for": "für",
          "at": "an"
        },
        "fields": {
          "title": "Titel",
          "description": "Beschreibung",
          "state": "Status",
          "status": "Ampel",
          "deadline": "Fälligkeit",
          "phase": "Phase",
          "workstream": "Teilprozess",
          "responsible": "Verantwortlich",
          "duration": "Dauer",
          "position": "Position",
          "name": "Name",
          "color": "Farbe",
          "label": "Nummernfarbe",
          "parent": "Übergeordnete Funktion",
          "user_id": "Person",
          "force_update_deadline": "Fälligkeit trotz Abhängigkeiten erzwingen",
          "remove_violated_connections": "verletzte Abhängigkeiten entfernen"
        },
        "reads": {
          "project": "Projekt gelesen",
          "template": "Prozesslandkarte gelesen",
          "count": "{n} Abfrage | {n} Abfragen"
        },
        "changes": "Keine Änderungen | {n} Änderung | {n} Änderungen",
        "failed": "{n} fehlgeschlagen",
        "stopped": "Gestoppt",
        "stopping": "Wird gestoppt …",
        "notRun": "nicht ausgeführt",
        "noChange": "keine Änderung nötig",
        "failedCall": "fehlgeschlagen",
        "untitled": "ohne Titel",
        "showOnMap": "Auf Karte zeigen"
      },
      "plusMenu": {
        "title": "Datei anhängen, Websuche, Code-Interpreter",
        "webSearch": "Websuche",
        "codeInterpreter": "Code-Interpreter"
      },
      "writeAccess": {
        "question": "Darf ich Änderungen vornehmen?",
        "allowOnce": "Einmal erlauben",
        "allowForChat": "Für diesen Chat erlauben",
        "readOnly": "Nein, nur lesen",
        "templateNoUndo": "Änderungen an Prozesslandkarten lassen sich nicht rückgängig machen.",
        "decided": {
          "allowed": "Für diesen Chat erlaubt",
          "allowedOnce": "Einmal erlaubt",
          "rejected": "Nur lesen",
          "discarded": "Nicht ausgeführt – neue Nachricht gesendet",
          "pending": "Wartet auf deine Entscheidung"
        },
        "chip": "Darf ändern",
        "chipTooltip": "Der KI-Assistent darf in diesem Chat Änderungen vornehmen. Klicken, um die Erlaubnis zurückzunehmen.",
        "revoke": "Erlaubnis zurücknehmen",
        "readOnlyLabel": "Nur lesen",
        "readOnlyTooltip": {
          "project": "Keine Bearbeitungsrechte in diesem Projekt",
          "template": "Keine Bearbeitungsrechte in dieser Prozesslandkarte"
        },
        "waiting": "KI-Assistent wartet auf deine Entscheidung"
      },
      "error": {
        "stage": {
          "send": "Deine Nachricht wurde nicht gesendet.",
          "answer": "Die Antwort ist fehlgeschlagen.",
          "load": "Der Chat konnte nicht geladen werden."
        },
        "reason": {
          "network": "Der Server ist nicht erreichbar.",
          "busy": "Die vorherige Antwort läuft noch – warte, bis sie fertig ist.",
          "files": "Eine angehängte Datei ist nicht mehr verfügbar – bitte hänge sie erneut an.",
          "model": "Ein Chat bleibt bei seinem Modell – für ein anderes Modell starte einen neuen Chat.",
          "notFound": "Diesen Chat gibt es nicht mehr – deine nächste Nachricht beginnt einen neuen Chat.",
          "rateLimit": "Der KI-Dienst ist gerade ausgelastet – versuche es gleich noch einmal.",
          "forbidden": "Dafür fehlt dir die Berechtigung.",
          "unknown": "Es ist ein unerwarteter Fehler aufgetreten."
        },
        "partial": "Was bis dahin geändert wurde, ist gespeichert.",
        "retry": "Erneut senden",
        "continueFailed": "Die Antwort konnte nicht fortgesetzt werden.",
        "revokeFailed": "Die Erlaubnis konnte nicht zurückgenommen werden.",
        "skillFailed": "Der Skill konnte nicht beendet werden."
      }
    },
    "conversations": {
      "title": "Chats",
      "loading": "Chats werden geladen…",
      "empty": "Noch keine früheren Chats.",
      "messageCount": "keine Nachrichten | {n} Nachricht | {n} Nachrichten",
      "rename": "Umbenennen",
      "delete": "Löschen",
      "deleteConfirm": "Chat löschen?",
      "loadFailed": "Die Chats konnten nicht geladen werden.",
      "renameFailed": "Der Chat konnte nicht umbenannt werden.",
      "deleteFailed": "Der Chat konnte nicht gelöscht werden.",
      "time": {
        "justNow": "Gerade eben",
        "minutesAgo": "vor {n} Min. | vor {n} Min. | vor {n} Min.",
        "hoursAgo": "vor {n} Std. | vor {n} Std. | vor {n} Std.",
        "daysAgo": "vor {n} Tag | vor {n} Tag | vor {n} Tagen"
      }
    },
    "metadata": {
      "tokens": "{count} Tokens",
      "cached": "{count} gecached",
      "details": "Modell, Dauer, Tokens und Kosten",
      "duration": "{seconds} s"
    }
  },
  "zoomWarning": {
    "title": "Browser-Zoom erkannt",
    "message": "Ihr Browser ist derzeit auf {zoomLevel}% gezoomt.",
    "instruction": "Für die beste Darstellung empfehlen wir, den Zoom auf 100 % zurückzusetzen ({key}). Sie können diese Meldung ignorieren, wenn Sie mit der aktuellen Ansicht zufrieden sind.",
    "dontShowAgain": "Diese Meldung nicht mehr anzeigen",
    "dismiss": "Ausblenden"
  },
  "wysiwygEditor": {
    "table": {
      "insertTable": "Tabelle einfügen",
      "addRowBefore": "Zeile davor",
      "addRowAfter": "Zeile danach",
      "deleteRow": "Zeile löschen",
      "addColumnBefore": "Spalte davor",
      "addColumnAfter": "Spalte danach",
      "deleteColumn": "Spalte löschen",
      "deleteTable": "Tabelle löschen"
    },
    "link": "Link einfügen",
    "image": "Bild einfügen",
    "embed": "Video einbetten",
    "insert": "Einfügen",
    "original": "Original"
  },
  "meetingSummary": {
    "confirmConnectTitle": "Besprechungszusammenfassung mit Projekt verbinden",
    "connectErrorMessage": "Fehler beim Verbinden der Besprechungszusammenfassung mit dem Projekt. Bitte versuchen Sie es erneut.",
    "connectErrorTitle": "Verbindung fehlgeschlagen",
    "connectInfoMessage": "Dadurch wird eine Kopie der Besprechungszusammenfassung, einschließlich aller Aufgaben und Teilnehmer, innerhalb des ausgewählten Projekts erstellt. Sie haben sowohl die persönliche Zusammenfassung als auch die projektverknüpfte Zusammenfassung.",
    "connectSuccess": "Besprechungszusammenfassung wurde mit Projekt verbunden",
    "connectSuccessTitle": "Erfolgreich verbunden",
    "connectSuccessWithDelete": "Besprechungszusammenfassung wurde mit Projekt verbunden, und die persönliche Zusammenfassung wurde gelöscht.",
    "connectToProject": "Mit Projekt verbinden",
    "connectToProjectButton": "Mit Projekt verbinden",
    "connectToProjectTitle": "Mit Beeboard-Projekt verbinden",
    "deleteOriginalHelper": "Aktivieren Sie diese Option, wenn Sie nur die projektverknüpfte Zusammenfassung behalten und Ihre persönliche Zusammenfassung entfernen möchten.",
    "deleteOriginalSummary": "Meine persönliche Zusammenfassung nach dem Verbinden löschen",
    "loadingProjects": "Projekte werden geladen...",
    "noMeetingsHelper": "Es gibt keine Besprechungen in diesem Projekt, mit denen eine Zusammenfassung verbunden werden kann.",
    "noMeetingsInProject": "Keine Besprechungen verfügbar",
    "noProjectsFound": "Keine Projekte gefunden",
    "searchProjects": "Projekte durchsuchen...",
    "selectMeeting": "Besprechung auswählen",
    "selectMeetingPlaceholder": "Wählen Sie eine Besprechung (optional)...",
    "selectProject": "Projekt auswählen",
    "selectProjectDescription": "Wählen Sie ein Projekt aus, um diese Besprechungszusammenfassung zu verbinden. Dadurch wird eine Kopie der Zusammenfassung im Projektkontext erstellt.",
    "selectProjectPlaceholder": "Wählen Sie ein Projekt...",
    "selectProjectTitle": "Projekt auswählen",
    "selectedProject": "Ausgewähltes Projekt"
  },
  "views": {
    "title": "Ansichten",
    "myViews": "Meine Ansichten",
    "managedViews": "Verwaltete Ansichten",
    "createView": "Ansicht erstellen",
    "editView": "Ansicht bearbeiten",
    "deleteView": "Ansicht löschen",
    "forkView": "In meine Ansichten kopieren",
    "noViews": "Noch keine Ansichten. Erstellen Sie Ihre erste Ansicht.",
    "noResults": "Keine passenden Ergebnisse für diese Ansicht.",
    "personalEmptyTitle": "Ihre persönlichen Ansichten",
    "personalEmptyDescription": "Persönliche Ansichten ermöglichen es Ihnen, individuelle Übersichten zu erstellen, die Eckpunkte und Meilensteine aus allen Projekten anzeigen, auf die Sie Zugriff haben. Jede Ansicht wendet Ihre Filter an und zeigt nur die Daten, die Sie sehen dürfen.",
    "personalEmptyHint": "Starten Sie schnell mit einem dieser Beispiele:",
    "presetActiveItems": "Aktive Elemente",
    "presetActiveItemsDesc": "Alle geplanten und laufenden Eckpunkte und Meilensteine Ihrer Projekte.",
    "presetFullOverview": "Komplette Meilenstein- und Eckpunktübersicht",
    "presetFullOverviewDesc": "Alle Eckpunkte und Meilensteine Ihrer zugänglichen Projekte.",
    "presetMilestonesOverview": "Meilensteinübersicht",
    "presetMilestonesOverviewDesc": "Alle Meilensteine mit Phasen Ihrer zugänglichen Projekte auf einen Blick.",
    "personal": "Persönlich",
    "managed": "Verwaltet",
    "bypassUserRights": "Alle Projekte anzeigen, unabhängig von den Berechtigungen des Betrachters",
    "entityTypes": "Elementtypen",
    "entityTypesRequired": "Mindestens ein Elementtyp muss ausgewählt sein",
    "activities": "Eckpunkte",
    "milestones": "Meilensteine",
    "projectSelection": "Projekte",
    "projectProperties": "Projekteigenschaften",
    "templateFilter": "Prozesslandkarte",
    "noTemplate": "(Keine Prozesslandkarte)",
    "activityFilters": "Eckpunkt-Filter",
    "milestoneFilters": "Meilenstein-Filter",
    "phaseFilters": "Phasen-Filter",
    "milestoneStates": "Meilenstein-Status",
    "milestoneStatuses": "Meilenstein-Statusanzeige",
    "milestoneDeadline": "Meilenstein-Frist",
    "titleSearch": "Titelsuche",
    "states": "Status",
    "statuses": "Statusanzeige",
    "deadlineRange": "Fälligkeitszeitraum",
    "deadlineFrom": "Von",
    "deadlineTo": "Bis",
    "responsibility": "Verantwortlich",
    "approval": "Freigabe",
    "approvalFunctions": "Freigabeverantwortliche (Funktionen)",
    "users": "Benutzer",
    "hasDocuments": "Hat Dokumente",
    "myProjectsOnly": "Nur meine Projekte",
    "usersProjectsOnly": "Nur Projekte des Benutzers",
    "allProjects": "Alle Projekte",
    "specificProjects": "{count} ausgewählte Projekte",
    "addPropertyFilter": "Eigenschaftsfilter hinzufügen",
    "filterValue": "Wert",
    "selectPropertyFirst": "Zuerst Eigenschaft auswählen",
    "addValueHint": "Eingeben und Enter drücken",
    "exactMatch": "Exakt",
    "containsMatch": "Enthält",
    "results": {
      "projects": "{count} Projekte",
      "activitiesCount": "{count} Eckpunkte",
      "milestonesCount": "{count} Meilensteine",
      "openInProject": "Im Projekt öffnen",
      "refresh": "Aktualisieren",
      "overdue": "Überfällig",
      "backToViews": "Zurück zu Ansichten",
      "expandAll": "Alle aufklappen",
      "collapseAll": "Alle zuklappen",
      "externalDateSync": {
        "inSync": "Externes Datum synchron"
      }
    },
    "confirmDelete": "Möchten Sie diese Ansicht wirklich löschen?",
    "deleteSuccess": "Ansicht erfolgreich gelöscht",
    "saveSuccess": "Ansicht erfolgreich gespeichert",
    "forkSuccess": "Ansicht in Ihre Ansichten kopiert",
    "filtersActive": "{count} Filter aktiv",
    "shareWithUsers": "Mit Benutzern teilen",
    "sharedWithCount": "Geteilt mit {count} Benutzer(n)",
    "deadline": "Fälligkeit",
    "panel": {
      "goToEntity": "Zum {entity}"
    },
    "swimlane": {
      "today": "Heute",
      "clickToOpen": "Klicken um im Projekt zu öffnen",
      "clickToComment": "Klicken für Details, Doppelklick um im Projekt zu öffnen",
      "items": "Einträge",
      "more": "weitere",
      "zoomIn": "Vergrößern",
      "zoomOut": "Verkleinern",
      "zoomReset": "Zoom zurücksetzen",
      "zoomToday": "Heute fokussieren",
      "togglePhases": "Phasen ein-/ausblenden",
      "toggleActivities": "Eckpunkte ein-/ausblenden",
      "toggleMilestones": "Meilensteine ein-/ausblenden",
      "toggleLabels": "Beschriftungen ein-/ausblenden",
      "labelModeTitle": "Titel",
      "labelModeNumber": "Nr + Titel",
      "labelModeDate": "Titel + Datum",
      "weekPrefix": "KW",
      "manageProjects": "Projekte verwalten",
      "showAllProjects": "Alle Projekte anzeigen",
      "sortByDate": "Nach Startdatum sortieren",
      "sortByDateAsc": "Nach Startdatum sortieren (aufsteigend)",
      "sortByDateDesc": "Nach Startdatum sortieren (absteigend)",
      "sortByTitle": "Nach Projekttitel sortieren",
      "sortByTitleAsc": "Nach Projekttitel sortieren (A-Z)",
      "sortByTitleDesc": "Nach Projekttitel sortieren (Z-A)",
      "sortByNearest": "Nach nächstem Termin zu heute sortieren",
      "paintMode": "Highlighten",
      "eraser": "Radierer",
      "clearHighlights": "Alle Highlights löschen",
      "clearHighlightsTitle": "Highlights löschen",
      "clearHighlightsConfirm": "Möchten Sie wirklich alle Highlights löschen?",
      "hatching": "Schraffur",
      "contentScale": "Inhaltsgröße",
      "colorLabel": "Bezeichnung...",
      "colorLabels": "Farbbezeichnungen",
      "labelDragHint": "Ziehen zum Verschieben, Doppelklick zum Zurücksetzen",
      "labelSettings": "Beschriftungseinstellungen",
      "labelModeSection": "Anzeige",
      "labelWidthSection": "Max. Breite",
      "labelPlacementMode": "Beschriftungen bearbeiten",
      "resetLabels": "Alle Beschriftungen zurücksetzen",
      "toggleProjectImages": "Projektbilder anzeigen",
      "editHighlight": "Markierung bearbeiten",
      "highlightStart": "Start",
      "highlightEnd": "Ende",
      "exportPdf": "Als PDF exportieren",
      "exportSuccess": "PDF erfolgreich exportiert",
      "exportError": "PDF-Export fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "presets": {
        "title": "Layouts",
        "default": "Standard",
        "save": "Speichern",
        "saveAs": "Speichern als...",
        "rename": "Umbenennen",
        "edit": "Zeitfenster bearbeiten...",
        "namePlaceholder": "Layoutname",
        "discard": "Änderungen verwerfen",
        "resetAll": "Ansicht zurücksetzen",
        "deleteTitle": "Layout löschen",
        "deleteConfirm": "Möchten Sie das Layout \"{name}\" wirklich löschen?",
        "saveError": "Layout konnte nicht gespeichert werden",
        "deleteError": "Layout konnte nicht gelöscht werden",
        "renameError": "Layout konnte nicht umbenannt werden",
        "rollingTooltip": "Rollierend: -{past} Wochen / +{future} Wochen",
        "reanchorTooltip": "Auf heute neu ausrichten",
        "dialog": {
          "titleCreate": "Layout speichern",
          "titleEdit": "Layout \"{name}\" bearbeiten",
          "nameLabel": "Name",
          "windowLabel": "Zeitfenster",
          "modeAbsolute": "Absolut",
          "modeRolling": "Rollierend",
          "hintAbsolute": "Speichert den aktuell sichtbaren Datumsbereich.",
          "hintRolling": "Zeigt immer den Bereich von heute minus vergangenen Wochen bis heute plus zukünftigen Wochen.",
          "pastWeeksLabel": "Vergangenheit (Wochen)",
          "futureWeeksLabel": "Zukunft (Wochen)",
          "errorReservedName": "\"default\" ist reserviert.",
          "errorDuplicateName": "Ein Layout mit diesem Namen existiert bereits.",
          "errorRollingWindow": "Bitte nicht-negative ganze Zahlen eingeben (Vergangenheit + Zukunft mindestens 1)."
        }
      }
    }
  },
  "easter": {
    "findTheEggs": "Finde die goldenen Eier!",
    "congratulations": "Du hast alle Eier gefunden!",
    "allEggsFound": "Frohe Ostern vom Beeboard-Team!",
    "dismissSession": "Jetzt ausblenden",
    "dismissForever": "Nicht mehr anzeigen"
  },
  "news": {
    "title": "Neuigkeiten",
    "empty": "Noch keine Neuigkeiten",
    "manage": "Verwalten"
  },
  "help": {
    "title": "Hilfe & Ressourcen",
    "empty": "Keine Ressourcen verfügbar",
    "chatWithUs": "Schreib uns",
    "moveToHeader": "In Kopfzeile verschieben",
    "moveToFloat": "Von Kopfzeile lösen",
    "ai": {
      "buttonLabel": "Mit KI chatten",
      "headerTitle": "beeboard-Hilfe",
      "welcome": "Hallo! Ich bin die beeboard-Hilfe. Frag mich alles über die Anwendung.",
      "conversation": "Chat mit der beeboard-Hilfe",
      "placeholder": "Nachricht eingeben…",
      "inspecting": "Sehe in der Anwendung nach…",
      "queued": "Warte auf einen freien Platz…",
      "clearChat": "Chat löschen",
      "close": "Chat schließen",
      "send": "Nachricht senden",
      "stop": "Generierung stoppen",
      "stopped": "Antwort gestoppt.",
      "error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "interrupted": "Die Antwort wurde unterbrochen. Bitte versuche es erneut.",
      "rateLimited": "Du hast in kurzer Zeit viele Fragen gestellt. Bitte warte {seconds} Sekunden und versuche es dann erneut.",
      "rateLimitedShort": "Bitte warte {seconds} s",
      "unavailable": "Die beeboard-Hilfe ist für dein Konto nicht verfügbar."
    }
  },
  "inAppContent": {
    "title": "In-App-Inhalte",
    "tabTitle": "Inhalte",
    "newsEntries": "Neuigkeiten",
    "knowledgeSources": "Wissensquellen",
    "createNews": "Neuigkeit erstellen",
    "editNews": "Neuigkeit bearbeiten",
    "createKnowledgeSource": "Wissensquelle erstellen",
    "editKnowledgeSource": "Wissensquelle bearbeiten",
    "status": "Status",
    "statusValues": {
      "draft": "Entwurf",
      "published": "Veröffentlicht"
    },
    "targetRealms": "Ziel-Realms",
    "targetRealmsLabel": "Ziel-Realms",
    "targetRealmsHint": "Kommagetrennte Realm-Namen (leer = alle Realms)",
    "allRealms": "Alle Realms",
    "publishedAt": "Veröffentlicht",
    "views": "Aufrufe",
    "url": "URL",
    "description": "Beschreibung",
    "iconLabel": "Icon-Name",
    "sortOrder": "Reihenfolge",
    "contentLabel": "Inhalt",
    "titleLabel": "Titel",
    "languageDE": "Deutsch",
    "languageEN": "Englisch",
    "globallyManaged": "Global verwaltet",
    "targetUserGroupsLabel": "Zielgruppen",
    "targetUsersLabel": "Bestimmte Benutzer",
    "noUserTargeting": "Keine Einzelbenutzer",
    "noUserGroupTargeting": "Keine Zielgruppen",
    "userGroups": {
      "allProjectResponsiblesAndEditors": "Alle Projektverantwortlichen und Bearbeiter",
      "allProjectResponsibles": "Alle Projektverantwortlichen",
      "allProjectMembers": "Alle Projektmitglieder"
    }
  },
  "presence": {
    "showLiveCursors": "Live-Cursor anzeigen",
    "hideLiveCursors": "Live-Cursor ausblenden",
    "follow": "Ansicht folgen",
    "unfollow": "Nicht mehr folgen",
    "followingBanner": "{name} wird gefolgt",
    "beingFollowedBanner": "{names} folgt dir",
    "aiAssistant": "KI-Assistent"
  },
  "validation": {
    "required": "Dieses Feld ist erforderlich",
    "minLength": "Muss mindestens {min} Zeichen lang sein",
    "maxLength": "Darf höchstens {max} Zeichen lang sein",
    "pattern": "Ungültiges Format",
    "minValue": "Muss mindestens {min} sein",
    "maxValue": "Darf höchstens {max} sein"
  },
  "templateQuality": {
    "sharedDocument": {
      "needsHandover": "Weitergabe fehlt noch",
      "alreadyWired": "Bereits weitergegeben",
      "likelyFrom": "Erhält das Dokument wahrscheinlich von „{title}“ — Dokumente dieses Eckpunkts öffnen, um die Weitergabe als Input zu modellieren",
      "likelyTo": "Erzeugt das Dokument wahrscheinlich — Weitergabe vermutlich an „{title}“. Dokumente dieses Eckpunkts öffnen, um sie als Output zu modellieren",
      "less": "Weniger anzeigen",
      "more": "+{count} weitere",
      "wired": "Bereits als Input/Output weitergegeben",
      "notWiredConnected": "Auf der Prozesslandkarte verbunden, aber das Dokument wird noch nicht als Input/Output weitergegeben — Dokumente dieses Eckpunkts öffnen",
      "notWiredUnconnected": "Nicht mit den anderen Eckpunkten verbunden — prüfen, ob hier eine Weitergabe modelliert werden sollte"
    },
    "checks": {
      "dangling_activity": {
        "label": "Nicht verbundener Eckpunkt",
        "description": "Markiert Eckpunkte, die nicht in den Ablauf der Prozesslandkarte eingebunden sind. Der erste und der letzte Eckpunkt der Prozesslandkarte werden für das fehlende Ende nicht markiert.",
        "message": "Dieser Eckpunkt hat keinen Vorgänger oder keinen Nachfolger. Verbinden Sie ihn mit der übrigen Prozesslandkarte.",
        "messageNoPredecessor": "Dieser Eckpunkt hat keinen Vorgänger — nichts führt zu ihm hin.",
        "messageNoSuccessor": "Dieser Eckpunkt hat keinen Nachfolger — nichts folgt auf ihn.",
        "messageNeither": "Dieser Eckpunkt hat weder Vorgänger noch Nachfolger — er ist gar nicht mit der Prozesslandkarte verbunden.",
        "shortLabel": "Nicht verbunden"
      },
      "unassigned_function_activity": {
        "label": "Eckpunkt ohne verantwortliche Funktion",
        "description": "Markiert Eckpunkte, denen keine verantwortliche Funktion zugewiesen ist.",
        "message": "Diesem Eckpunkt ist keine verantwortliche Funktion zugewiesen.",
        "shortLabel": "Keine verantwortliche Funktion"
      },
      "ai_suggest_function_activity": {
        "label": "Vorgeschlagene verantwortliche Funktion (Eckpunkt)",
        "description": "Schlägt per KI vor, welche Funktion der Prozesslandkarte für einen Eckpunkt ohne verantwortliche Funktion zuständig sein sollte.",
        "message": "Keine verantwortliche Funktion zugewiesen. Vorgeschlagene Funktion:",
        "shortLabel": "Vorgeschlagene verantwortliche Funktion"
      },
      "unassigned_function_completion_criterion": {
        "label": "Erfüllungskriterium ohne verantwortliche Funktion",
        "description": "Markiert Erfüllungskriterien, denen keine verantwortliche Funktion zugewiesen ist.",
        "message": "Diesem Erfüllungskriterium ist keine verantwortliche Funktion zugewiesen.",
        "shortLabel": "Keine verantwortliche Funktion"
      },
      "ai_suggest_function_completion_criterion": {
        "label": "Vorgeschlagene verantwortliche Funktion (Erfüllungskriterium)",
        "description": "Schlägt per KI vor, welche Funktion der Prozesslandkarte für ein Erfüllungskriterium ohne verantwortliche Funktion zuständig sein sollte.",
        "message": "Keine verantwortliche Funktion zugewiesen. Vorgeschlagene Funktion:",
        "shortLabel": "Vorgeschlagene verantwortliche Funktion"
      },
      "unassigned_function_phase": {
        "label": "Phase ohne verantwortliche Funktion",
        "description": "Markiert Phasen, denen keine verantwortliche Funktion zugewiesen ist.",
        "message": "Dieser Phase ist keine verantwortliche Funktion zugewiesen.",
        "shortLabel": "Keine verantwortliche Funktion"
      },
      "shared_document": {
        "label": "Von mehreren Eckpunkten genutztes Dokument",
        "description": "Markiert Dokumente, die an mehr als einen Eckpunkt angehängt sind — meist ein Hinweis darauf, dass das Dokument stattdessen als Input/Output weitergegeben werden sollte. Dokumente, deren Weitergabe bereits als Input/Output modelliert ist, werden nicht markiert.",
        "message": "Dieses Dokument ist an mehrere Eckpunkte angehängt. Geben Sie es stattdessen als Input/Output zwischen den Eckpunkten weiter.",
        "shortLabel": "Von mehreren Eckpunkten genutzt"
      },
      "missing_description_activity": {
        "label": "Eckpunkt ohne Beschreibung",
        "description": "Markiert Eckpunkte ohne Beschreibung.",
        "message": "Dieser Eckpunkt hat keine Beschreibung.",
        "shortLabel": "Keine Beschreibung"
      },
      "missing_description_completion_criterion": {
        "label": "Erfüllungskriterium ohne Beschreibung",
        "description": "Markiert Erfüllungskriterien ohne Beschreibung.",
        "message": "Dieses Erfüllungskriterium hat keine Beschreibung.",
        "shortLabel": "Keine Beschreibung"
      },
      "missing_description_milestone": {
        "label": "Meilenstein ohne Beschreibung",
        "description": "Markiert Meilensteine ohne Beschreibung.",
        "message": "Dieser Meilenstein hat keine Beschreibung.",
        "shortLabel": "Keine Beschreibung"
      },
      "missing_title_activity": {
        "label": "Eckpunkt ohne Titel",
        "description": "Markiert Eckpunkte ohne Titel.",
        "message": "Dieser Eckpunkt hat keinen Titel.",
        "shortLabel": "Kein Titel"
      },
      "missing_title_milestone": {
        "label": "Meilenstein ohne Titel",
        "description": "Markiert Meilensteine ohne Titel.",
        "message": "Dieser Meilenstein hat keinen Titel.",
        "shortLabel": "Kein Titel"
      },
      "ai_title_quality_activity": {
        "label": "Qualität der Eckpunkt-Titel (KI)",
        "description": "Lässt die KI prüfen, ob Eckpunkt-Titel klar, konkret und einheitlich formuliert sind.",
        "message": "Die KI schlägt vor, diesen Eckpunkt-Titel zu verbessern.",
        "shortLabel": "Vorgeschlagener Titel"
      },
      "ai_title_quality_milestone": {
        "label": "Qualität der Meilensteintitel (KI)",
        "description": "Lässt die KI prüfen, ob Meilensteintitel klar, konkret und einheitlich formuliert sind.",
        "message": "Die KI schlägt vor, diesen Meilensteintitel zu verbessern.",
        "shortLabel": "Vorgeschlagener Titel"
      },
      "ai_description_quality_activity": {
        "label": "Qualität der Eckpunkt-Beschreibungen (KI)",
        "description": "Lässt die KI prüfen, ob Eckpunkt-Beschreibungen die zu leistende Arbeit tatsächlich erklären.",
        "message": "Die KI schlägt vor, diese Eckpunkt-Beschreibung zu verbessern.",
        "shortLabel": "Vorgeschlagene Beschreibung"
      },
      "ai_description_quality_completion_criterion": {
        "label": "Qualität der Beschreibungen von Erfüllungskriterien (KI)",
        "description": "Lässt die KI prüfen, ob Erfüllungskriterien ein überprüfbares Ergebnis beschreiben.",
        "message": "Die KI schlägt vor, die Beschreibung dieses Erfüllungskriteriums zu verbessern.",
        "shortLabel": "Vorgeschlagene Beschreibung"
      },
      "ai_description_quality_milestone": {
        "label": "Qualität der Meilensteinbeschreibungen (KI)",
        "description": "Lässt die KI prüfen, ob Meilensteinbeschreibungen erklären, was erreicht wurde.",
        "message": "Die KI schlägt vor, diese Meilensteinbeschreibung zu verbessern.",
        "shortLabel": "Vorgeschlagene Beschreibung"
      }
    },
    "panel": {
      "title": "Qualitätsprüfung",
      "close": "Schließen",
      "runAiCheck": "KI-Prüfung starten",
      "runError": "Die KI-Qualitätsprüfung konnte nicht abgeschlossen werden.",
      "progress": "{processed} von {total} geprüft",
      "noFindings": "Keine Qualitätsprobleme gefunden.",
      "untitled": "Ohne Titel",
      "proposal": "Textvorschlag",
      "aiBadge": "KI",
      "aiBadgeTooltip": "Von der KI vorgeschlagen",
      "apply": "Anwenden",
      "applySuccess": "Der Vorschlag wurde angewendet.",
      "applyError": "Der Vorschlag konnte nicht angewendet werden.",
      "dismiss": "Diesen Hinweis ignorieren",
      "dismissError": "Der Hinweis konnte nicht aktualisiert werden.",
      "showIgnored": "Ignorierte anzeigen",
      "ignoredTitle": "Ignorierte Hinweise",
      "noIgnored": "Es wurden keine Hinweise ignoriert.",
      "unignore": "Wiederherstellen",
      "markSolved": "Als erledigt markieren",
      "toggleGroup": "Ein- oder ausklappen",
      "suggestedFunction": "Vorgeschlagene Funktion"
    },
    "tab": {
      "goToFix": "Zur Behebung springen"
    },
    "setup": {
      "title": "Einstellungen der Qualitätsprüfung",
      "subtitle": "Wählen Sie, welche Prüfungen dieses Mal ausgeführt werden sollen. Die Auswahl gilt nur für diesen Durchlauf — die gespeicherten Standardwerte bleiben unverändert.",
      "confirm": "Ergebnisse anzeigen"
    },
    "entities": {
      "activity": "Eckpunkte",
      "completion_criterion": "Erfüllungskriterien",
      "milestone": "Meilensteine",
      "phase": "Phasen",
      "document": "Dokumente"
    },
    "settings": {
      "navLabel": "Qualitätsprüfungen",
      "templateTitle": "Qualitätsprüfungen",
      "templateSubtitle": "Legen Sie fest, welche Prüfungen für diese Prozesslandkarte laufen. Nicht überschriebene Prüfungen folgen der Unternehmensvorgabe.",
      "companyTitle": "Standards für Qualitätsprüfungen",
      "companySubtitle": "Diese Vorgaben gelten für alle Prozesslandkarten Ihres Unternehmens. Jede Prozesslandkarte kann sie einzeln überschreiben.",
      "inherited": "Geerbt",
      "overridden": "Überschrieben",
      "overriddenCount": "{count} überschrieben",
      "reset": "Zurücksetzen",
      "loadError": "Die Einstellungen der Qualitätsprüfung konnten nicht geladen werden.",
      "saveError": "Die Einstellungen der Qualitätsprüfung konnten nicht gespeichert werden.",
      "enabledCount": "{enabled} von {total} aktiv",
      "aiTag": "KI"
    }
  },
  "projectMail": {
    "attachments": "Anhänge",
    "attachmentsNotStored": "Die Dateien selbst werden nicht in beeboard gespeichert.",
    "detailFailed": "Diese E-Mail konnte nicht geladen werden",
    "dragHint": "E-Mail auf die Map ziehen, um daraus einen Eckpunkt zu erstellen, oder auf einen bestehenden Eckpunkt, um sie als Erfüllungskriterium, Maßnahme oder Kommentar hinzuzufügen.",
    "hasAttachments": "Anhänge: {count}",
    "noBody": "Diese E-Mail hat keinen Inhalt.",
    "noSubject": "(kein Betreff)",
    "addressTitle": "E-Mail-Adresse",
    "on": "Aktiv",
    "off": "Inaktiv",
    "copy": "Kopieren",
    "enable": "Aktivieren",
    "disable": "Deaktivieren",
    "aliasLabel": "Adressname",
    "aliasRules": "Kleinbuchstaben, Ziffern, Punkte und Bindestriche. Muss mit einem Buchstaben oder einer Ziffer beginnen und enden.",
    "previewLabel": "Neue Adresse:",
    "addressSaved": "Projekt-E-Mail-Adresse gespeichert",
    "addressCopied": "Adresse kopiert",
    "addressCopyFailed": "Adresse konnte nicht kopiert werden",
    "addressTaken": "Diese Adresse wird bereits von einem anderen Projekt verwendet. Bitte wähle einen anderen Namen.",
    "disabled": "Projekt-E-Mail deaktiviert",
    "responsibleOnly": "Nur der Projektverantwortliche kann die Projekt-E-Mail-Adresse ändern.",
    "retentionHint": "Mails werden ab dem Eingangstag {days} Tage aufbewahrt und danach gelöscht – unabhängig davon, ob daraus etwas erstellt wurde.",
    "formerAddresses": "Frühere Adressen:",
    "formerAddressesHint": "Mails an eine frühere Adresse erreichen dieses Projekt weiterhin, damit Absender mit der alten Adresse nicht ins Leere schreiben.",
    "disableConfirmTitle": "Projekt-E-Mail deaktivieren?",
    "disableConfirmMessage": "Neue Mails an die Adresse dieses Projekts werden verworfen. Bereits empfangene Mails bleiben in der Seitenleiste „Aufgaben importieren“, bis sie {days} Tage alt sind.",
    "deleteMail": "Mail löschen",
    "loadMore": "Mehr laden ({loaded} von {total})",
    "loadingMore": "Wird geladen…",
    "noMail": "Noch keine Mails. Alles, was an {address} gesendet wird, erscheint hier.",
    "noMailNoAddress": "Noch keine Mails.",
    "deleteTitle": "Diese Mail löschen?",
    "deleteMessage": "„{subject}“ wird samt Inhalt entfernt. Das kann nicht rückgängig gemacht werden.",
    "deleteAfterConvertTitle": "Diese Mail löschen?",
    "deleteAfterConvertMessage": "„{title}“ wurde aus dieser Mail erstellt. Beim Löschen der Mail wird ihr Inhalt entfernt – das gerade Erstellte bleibt erhalten. Behalte die Mail, wenn du daraus noch etwas anderes erstellen willst; sie wird {days} Tage nach Eingang automatisch gelöscht.",
    "deleteAfterCommentMessage": "Die Mail wurde als Kommentar zu „{title}“ hinzugefügt. Beim Löschen der Mail wird ihr Inhalt entfernt – der Kommentar bleibt erhalten. Die Mail kann behalten werden, um daraus noch etwas anderes zu erstellen; sie wird {days} Tage nach Eingang automatisch gelöscht.",
    "commentAdded": "Kommentar hinzugefügt",
    "commentFailed": "Der Kommentar konnte nicht hinzugefügt werden.",
    "commentFrom": "Von",
    "commentReceived": "Empfangen",
    "commentSubject": "Betreff",
    "commentSenderFailed": "⚠ Absender nicht bestätigt – die Absenderadresse kann gefälscht sein",
    "commentAttachmentsNotStored": "nicht in beeboard gespeichert",
    "unknownSender": "Unbekannter Absender",
    "deleted": "Mail gelöscht",
    "deleteFailed": "Mail konnte nicht gelöscht werden",
    "embeddedImages": "Eingebettete Bilder",
    "senderVerified": "Absender bestätigt",
    "senderVerifiedHint": "Die Absenderdomain hat bestätigt, dass diese Nachricht wirklich von ihr stammt (DMARC bestanden).",
    "senderFailed": "Absender nicht bestätigt",
    "senderFailedHint": "Die Absenderdomain hat diese Nachricht nicht bestätigt (DMARC fehlgeschlagen). Die angegebene Adresse kann gefälscht sein.",
    "senderUnverified": "Absender unbekannt",
    "senderUnverifiedHint": "Die Absenderdomain veröffentlicht keine prüfbare Richtlinie, was häufig vorkommt. Es ist nichts falsch, aber auch nichts bestätigt."
  }
}
